var Ua = Object.defineProperty;
var Oa = (t, e, n) => e in t ? Ua(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var Bt = (t, e, n) => Oa(t, typeof e != "symbol" ? e + "" : e, n);
import { onMounted as qt, onUnmounted as Ai, ref as G, defineComponent as Mt, useSlots as Ni, watch as jt, computed as C, onBeforeUpdate as Fa, openBlock as q, createElementBlock as B, Fragment as Rt, unref as nt, createElementVNode as I, renderList as te, normalizeStyle as dt, renderSlot as rt, watchEffect as dr, nextTick as Ya, createBlock as Ia, resolveDynamicComponent as Wa, Teleport as Ra, withCtx as za, createCommentVNode as pt, normalizeClass as Et, mergeProps as mr, toDisplayString as gt, toRefs as La, normalizeProps as gr, guardReactiveProps as Ha, createTextVNode as Xa, useCssVars as Pi } from "vue";
import { toPixels as xt, useColorTheme as Va } from "@prefecthq/prefect-design";
import { useElementRect as Pt, useKeyDown as Ui, useNow as qa } from "@prefecthq/vue-compositions";
function Ke(t, e) {
  return t == null || e == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function Ba(t, e) {
  return t == null || e == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function vr(t) {
  let e, n, r;
  t.length !== 2 ? (e = Ke, n = (s, c) => Ke(t(s), c), r = (s, c) => t(s) - c) : (e = t === Ke || t === Ba ? t : Ga, n = t, r = t);
  function i(s, c, u = 0, l = s.length) {
    if (u < l) {
      if (e(c, c) !== 0) return l;
      do {
        const d = u + l >>> 1;
        n(s[d], c) < 0 ? u = d + 1 : l = d;
      } while (u < l);
    }
    return u;
  }
  function a(s, c, u = 0, l = s.length) {
    if (u < l) {
      if (e(c, c) !== 0) return l;
      do {
        const d = u + l >>> 1;
        n(s[d], c) <= 0 ? u = d + 1 : l = d;
      } while (u < l);
    }
    return u;
  }
  function o(s, c, u = 0, l = s.length) {
    const d = i(s, c, u, l - 1);
    return d > u && r(s[d - 1], c) > -r(s[d], c) ? d - 1 : d;
  }
  return { left: i, center: o, right: a };
}
function Ga() {
  return 0;
}
function Qa(t) {
  return t === null ? NaN : +t;
}
const Za = vr(Ke), Ka = Za.right;
vr(Qa).center;
function Or(t, e) {
  let n, r;
  if (e === void 0)
    for (const i of t)
      i != null && (n === void 0 ? i >= i && (n = r = i) : (n > i && (n = i), r < i && (r = i)));
  else {
    let i = -1;
    for (let a of t)
      (a = e(a, ++i, t)) != null && (n === void 0 ? a >= a && (n = r = a) : (n > a && (n = a), r < a && (r = a)));
  }
  return [n, r];
}
const Ja = Math.sqrt(50), ja = Math.sqrt(10), to = Math.sqrt(2);
function sn(t, e, n) {
  const r = (e - t) / Math.max(0, n), i = Math.floor(Math.log10(r)), a = r / Math.pow(10, i), o = a >= Ja ? 10 : a >= ja ? 5 : a >= to ? 2 : 1;
  let s, c, u;
  return i < 0 ? (u = Math.pow(10, -i) / o, s = Math.round(t * u), c = Math.round(e * u), s / u < t && ++s, c / u > e && --c, u = -u) : (u = Math.pow(10, i) * o, s = Math.round(t / u), c = Math.round(e / u), s * u < t && ++s, c * u > e && --c), c < s && 0.5 <= n && n < 2 ? sn(t, e, n * 2) : [s, c, u];
}
function eo(t, e, n) {
  if (e = +e, t = +t, n = +n, !(n > 0)) return [];
  if (t === e) return [t];
  const r = e < t, [i, a, o] = r ? sn(e, t, n) : sn(t, e, n);
  if (!(a >= i)) return [];
  const s = a - i + 1, c = new Array(s);
  if (r)
    if (o < 0) for (let u = 0; u < s; ++u) c[u] = (a - u) / -o;
    else for (let u = 0; u < s; ++u) c[u] = (a - u) * o;
  else if (o < 0) for (let u = 0; u < s; ++u) c[u] = (i + u) / -o;
  else for (let u = 0; u < s; ++u) c[u] = (i + u) * o;
  return c;
}
function Bn(t, e, n) {
  return e = +e, t = +t, n = +n, sn(t, e, n)[2];
}
function Gn(t, e, n) {
  e = +e, t = +t, n = +n;
  const r = e < t, i = r ? Bn(e, t, n) : Bn(t, e, n);
  return (r ? -1 : 1) * (i < 0 ? 1 / -i : i);
}
function no(t, e, n) {
  t = +t, e = +e, n = (i = arguments.length) < 2 ? (e = t, t = 0, 1) : i < 3 ? 1 : +n;
  for (var r = -1, i = Math.max(0, Math.ceil((e - t) / n)) | 0, a = new Array(i); ++r < i; )
    a[r] = t + r * n;
  return a;
}
function ro(t) {
  return t;
}
var Je = 1, Pn = 2, Qn = 3, Ce = 4, Fr = 1e-6;
function io(t) {
  return "translate(" + t + ",0)";
}
function ao(t) {
  return "translate(0," + t + ")";
}
function oo(t) {
  return (e) => +t(e);
}
function so(t, e) {
  return e = Math.max(0, t.bandwidth() - e * 2) / 2, t.round() && (e = Math.round(e)), (n) => +t(n) + e;
}
function uo() {
  return !this.__axis;
}
function pr(t, e) {
  var n = [], r = null, i = null, a = 6, o = 6, s = 3, c = typeof window < "u" && window.devicePixelRatio > 1 ? 0 : 0.5, u = t === Je || t === Ce ? -1 : 1, l = t === Ce || t === Pn ? "x" : "y", d = t === Je || t === Qn ? io : ao;
  function h(g) {
    var S = r ?? (e.ticks ? e.ticks.apply(e, n) : e.domain()), k = i ?? (e.tickFormat ? e.tickFormat.apply(e, n) : ro), $ = Math.max(a, 0) + s, b = e.range(), F = +b[0] + c, y = +b[b.length - 1] + c, f = (e.bandwidth ? so : oo)(e.copy(), c), _ = g.selection ? g.selection() : g, m = _.selectAll(".domain").data([null]), p = _.selectAll(".tick").data(S, e).order(), w = p.exit(), N = p.enter().append("g").attr("class", "tick"), Y = p.select("line"), E = p.select("text");
    m = m.merge(m.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor")), p = p.merge(N), Y = Y.merge(N.append("line").attr("stroke", "currentColor").attr(l + "2", u * a)), E = E.merge(N.append("text").attr("fill", "currentColor").attr(l, u * $).attr("dy", t === Je ? "0em" : t === Qn ? "0.71em" : "0.32em")), g !== _ && (m = m.transition(g), p = p.transition(g), Y = Y.transition(g), E = E.transition(g), w = w.transition(g).attr("opacity", Fr).attr("transform", function(Q) {
      return isFinite(Q = f(Q)) ? d(Q + c) : this.getAttribute("transform");
    }), N.attr("opacity", Fr).attr("transform", function(Q) {
      var J = this.parentNode.__axis;
      return d((J && isFinite(J = J(Q)) ? J : f(Q)) + c);
    })), w.remove(), m.attr("d", t === Ce || t === Pn ? o ? "M" + u * o + "," + F + "H" + c + "V" + y + "H" + u * o : "M" + c + "," + F + "V" + y : o ? "M" + F + "," + u * o + "V" + c + "H" + y + "V" + u * o : "M" + F + "," + c + "H" + y), p.attr("opacity", 1).attr("transform", function(Q) {
      return d(f(Q) + c);
    }), Y.attr(l + "2", u * a), E.attr(l, u * $).text(k), _.filter(uo).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", t === Pn ? "start" : t === Ce ? "end" : "middle"), _.each(function() {
      this.__axis = f;
    });
  }
  return h.scale = function(g) {
    return arguments.length ? (e = g, h) : e;
  }, h.ticks = function() {
    return n = Array.from(arguments), h;
  }, h.tickArguments = function(g) {
    return arguments.length ? (n = g == null ? [] : Array.from(g), h) : n.slice();
  }, h.tickValues = function(g) {
    return arguments.length ? (r = g == null ? null : Array.from(g), h) : r && r.slice();
  }, h.tickFormat = function(g) {
    return arguments.length ? (i = g, h) : i;
  }, h.tickSize = function(g) {
    return arguments.length ? (a = o = +g, h) : a;
  }, h.tickSizeInner = function(g) {
    return arguments.length ? (a = +g, h) : a;
  }, h.tickSizeOuter = function(g) {
    return arguments.length ? (o = +g, h) : o;
  }, h.tickPadding = function(g) {
    return arguments.length ? (s = +g, h) : s;
  }, h.offset = function(g) {
    return arguments.length ? (c = +g, h) : c;
  }, h;
}
function co(t) {
  return pr(Je, t);
}
function Oi(t) {
  return pr(Qn, t);
}
function lo(t) {
  return pr(Ce, t);
}
var fo = { value: () => {
} };
function Tn() {
  for (var t = 0, e = arguments.length, n = {}, r; t < e; ++t) {
    if (!(r = arguments[t] + "") || r in n || /[\s.]/.test(r)) throw new Error("illegal type: " + r);
    n[r] = [];
  }
  return new je(n);
}
function je(t) {
  this._ = t;
}
function ho(t, e) {
  return t.trim().split(/^|\s+/).map(function(n) {
    var r = "", i = n.indexOf(".");
    if (i >= 0 && (r = n.slice(i + 1), n = n.slice(0, i)), n && !e.hasOwnProperty(n)) throw new Error("unknown type: " + n);
    return { type: n, name: r };
  });
}
je.prototype = Tn.prototype = {
  constructor: je,
  on: function(t, e) {
    var n = this._, r = ho(t + "", n), i, a = -1, o = r.length;
    if (arguments.length < 2) {
      for (; ++a < o; ) if ((i = (t = r[a]).type) && (i = mo(n[i], t.name))) return i;
      return;
    }
    if (e != null && typeof e != "function") throw new Error("invalid callback: " + e);
    for (; ++a < o; )
      if (i = (t = r[a]).type) n[i] = Yr(n[i], t.name, e);
      else if (e == null) for (i in n) n[i] = Yr(n[i], t.name, null);
    return this;
  },
  copy: function() {
    var t = {}, e = this._;
    for (var n in e) t[n] = e[n].slice();
    return new je(t);
  },
  call: function(t, e) {
    if ((i = arguments.length - 2) > 0) for (var n = new Array(i), r = 0, i, a; r < i; ++r) n[r] = arguments[r + 2];
    if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    for (a = this._[t], r = 0, i = a.length; r < i; ++r) a[r].value.apply(e, n);
  },
  apply: function(t, e, n) {
    if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    for (var r = this._[t], i = 0, a = r.length; i < a; ++i) r[i].value.apply(e, n);
  }
};
function mo(t, e) {
  for (var n = 0, r = t.length, i; n < r; ++n)
    if ((i = t[n]).name === e)
      return i.value;
}
function Yr(t, e, n) {
  for (var r = 0, i = t.length; r < i; ++r)
    if (t[r].name === e) {
      t[r] = fo, t = t.slice(0, r).concat(t.slice(r + 1));
      break;
    }
  return n != null && t.push({ name: e, value: n }), t;
}
var Zn = "http://www.w3.org/1999/xhtml";
const Ir = {
  svg: "http://www.w3.org/2000/svg",
  xhtml: Zn,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};
function Sn(t) {
  var e = t += "", n = e.indexOf(":");
  return n >= 0 && (e = t.slice(0, n)) !== "xmlns" && (t = t.slice(n + 1)), Ir.hasOwnProperty(e) ? { space: Ir[e], local: t } : t;
}
function go(t) {
  return function() {
    var e = this.ownerDocument, n = this.namespaceURI;
    return n === Zn && e.documentElement.namespaceURI === Zn ? e.createElement(t) : e.createElementNS(n, t);
  };
}
function vo(t) {
  return function() {
    return this.ownerDocument.createElementNS(t.space, t.local);
  };
}
function Fi(t) {
  var e = Sn(t);
  return (e.local ? vo : go)(e);
}
function po() {
}
function _r(t) {
  return t == null ? po : function() {
    return this.querySelector(t);
  };
}
function _o(t) {
  typeof t != "function" && (t = _r(t));
  for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i)
    for (var a = e[i], o = a.length, s = r[i] = new Array(o), c, u, l = 0; l < o; ++l)
      (c = a[l]) && (u = t.call(c, c.__data__, l, a)) && ("__data__" in c && (u.__data__ = c.__data__), s[l] = u);
  return new bt(r, this._parents);
}
function yo(t) {
  return t == null ? [] : Array.isArray(t) ? t : Array.from(t);
}
function wo() {
  return [];
}
function Yi(t) {
  return t == null ? wo : function() {
    return this.querySelectorAll(t);
  };
}
function xo(t) {
  return function() {
    return yo(t.apply(this, arguments));
  };
}
function bo(t) {
  typeof t == "function" ? t = xo(t) : t = Yi(t);
  for (var e = this._groups, n = e.length, r = [], i = [], a = 0; a < n; ++a)
    for (var o = e[a], s = o.length, c, u = 0; u < s; ++u)
      (c = o[u]) && (r.push(t.call(c, c.__data__, u, o)), i.push(c));
  return new bt(r, i);
}
function Ii(t) {
  return function() {
    return this.matches(t);
  };
}
function Wi(t) {
  return function(e) {
    return e.matches(t);
  };
}
var Mo = Array.prototype.find;
function To(t) {
  return function() {
    return Mo.call(this.children, t);
  };
}
function So() {
  return this.firstElementChild;
}
function ko(t) {
  return this.select(t == null ? So : To(typeof t == "function" ? t : Wi(t)));
}
var Do = Array.prototype.filter;
function Co() {
  return Array.from(this.children);
}
function $o(t) {
  return function() {
    return Do.call(this.children, t);
  };
}
function Eo(t) {
  return this.selectAll(t == null ? Co : $o(typeof t == "function" ? t : Wi(t)));
}
function Ao(t) {
  typeof t != "function" && (t = Ii(t));
  for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i)
    for (var a = e[i], o = a.length, s = r[i] = [], c, u = 0; u < o; ++u)
      (c = a[u]) && t.call(c, c.__data__, u, a) && s.push(c);
  return new bt(r, this._parents);
}
function Ri(t) {
  return new Array(t.length);
}
function No() {
  return new bt(this._enter || this._groups.map(Ri), this._parents);
}
function un(t, e) {
  this.ownerDocument = t.ownerDocument, this.namespaceURI = t.namespaceURI, this._next = null, this._parent = t, this.__data__ = e;
}
un.prototype = {
  constructor: un,
  appendChild: function(t) {
    return this._parent.insertBefore(t, this._next);
  },
  insertBefore: function(t, e) {
    return this._parent.insertBefore(t, e);
  },
  querySelector: function(t) {
    return this._parent.querySelector(t);
  },
  querySelectorAll: function(t) {
    return this._parent.querySelectorAll(t);
  }
};
function Po(t) {
  return function() {
    return t;
  };
}
function Uo(t, e, n, r, i, a) {
  for (var o = 0, s, c = e.length, u = a.length; o < u; ++o)
    (s = e[o]) ? (s.__data__ = a[o], r[o] = s) : n[o] = new un(t, a[o]);
  for (; o < c; ++o)
    (s = e[o]) && (i[o] = s);
}
function Oo(t, e, n, r, i, a, o) {
  var s, c, u = /* @__PURE__ */ new Map(), l = e.length, d = a.length, h = new Array(l), g;
  for (s = 0; s < l; ++s)
    (c = e[s]) && (h[s] = g = o.call(c, c.__data__, s, e) + "", u.has(g) ? i[s] = c : u.set(g, c));
  for (s = 0; s < d; ++s)
    g = o.call(t, a[s], s, a) + "", (c = u.get(g)) ? (r[s] = c, c.__data__ = a[s], u.delete(g)) : n[s] = new un(t, a[s]);
  for (s = 0; s < l; ++s)
    (c = e[s]) && u.get(h[s]) === c && (i[s] = c);
}
function Fo(t) {
  return t.__data__;
}
function Yo(t, e) {
  if (!arguments.length) return Array.from(this, Fo);
  var n = e ? Oo : Uo, r = this._parents, i = this._groups;
  typeof t != "function" && (t = Po(t));
  for (var a = i.length, o = new Array(a), s = new Array(a), c = new Array(a), u = 0; u < a; ++u) {
    var l = r[u], d = i[u], h = d.length, g = Io(t.call(l, l && l.__data__, u, r)), S = g.length, k = s[u] = new Array(S), $ = o[u] = new Array(S), b = c[u] = new Array(h);
    n(l, d, k, $, b, g, e);
    for (var F = 0, y = 0, f, _; F < S; ++F)
      if (f = k[F]) {
        for (F >= y && (y = F + 1); !(_ = $[y]) && ++y < S; ) ;
        f._next = _ || null;
      }
  }
  return o = new bt(o, r), o._enter = s, o._exit = c, o;
}
function Io(t) {
  return typeof t == "object" && "length" in t ? t : Array.from(t);
}
function Wo() {
  return new bt(this._exit || this._groups.map(Ri), this._parents);
}
function Ro(t, e, n) {
  var r = this.enter(), i = this, a = this.exit();
  return typeof t == "function" ? (r = t(r), r && (r = r.selection())) : r = r.append(t + ""), e != null && (i = e(i), i && (i = i.selection())), n == null ? a.remove() : n(a), r && i ? r.merge(i).order() : i;
}
function zo(t) {
  for (var e = t.selection ? t.selection() : t, n = this._groups, r = e._groups, i = n.length, a = r.length, o = Math.min(i, a), s = new Array(i), c = 0; c < o; ++c)
    for (var u = n[c], l = r[c], d = u.length, h = s[c] = new Array(d), g, S = 0; S < d; ++S)
      (g = u[S] || l[S]) && (h[S] = g);
  for (; c < i; ++c)
    s[c] = n[c];
  return new bt(s, this._parents);
}
function Lo() {
  for (var t = this._groups, e = -1, n = t.length; ++e < n; )
    for (var r = t[e], i = r.length - 1, a = r[i], o; --i >= 0; )
      (o = r[i]) && (a && o.compareDocumentPosition(a) ^ 4 && a.parentNode.insertBefore(o, a), a = o);
  return this;
}
function Ho(t) {
  t || (t = Xo);
  function e(d, h) {
    return d && h ? t(d.__data__, h.__data__) : !d - !h;
  }
  for (var n = this._groups, r = n.length, i = new Array(r), a = 0; a < r; ++a) {
    for (var o = n[a], s = o.length, c = i[a] = new Array(s), u, l = 0; l < s; ++l)
      (u = o[l]) && (c[l] = u);
    c.sort(e);
  }
  return new bt(i, this._parents).order();
}
function Xo(t, e) {
  return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function Vo() {
  var t = arguments[0];
  return arguments[0] = this, t.apply(null, arguments), this;
}
function qo() {
  return Array.from(this);
}
function Bo() {
  for (var t = this._groups, e = 0, n = t.length; e < n; ++e)
    for (var r = t[e], i = 0, a = r.length; i < a; ++i) {
      var o = r[i];
      if (o) return o;
    }
  return null;
}
function Go() {
  let t = 0;
  for (const e of this) ++t;
  return t;
}
function Qo() {
  return !this.node();
}
function Zo(t) {
  for (var e = this._groups, n = 0, r = e.length; n < r; ++n)
    for (var i = e[n], a = 0, o = i.length, s; a < o; ++a)
      (s = i[a]) && t.call(s, s.__data__, a, i);
  return this;
}
function Ko(t) {
  return function() {
    this.removeAttribute(t);
  };
}
function Jo(t) {
  return function() {
    this.removeAttributeNS(t.space, t.local);
  };
}
function jo(t, e) {
  return function() {
    this.setAttribute(t, e);
  };
}
function ts(t, e) {
  return function() {
    this.setAttributeNS(t.space, t.local, e);
  };
}
function es(t, e) {
  return function() {
    var n = e.apply(this, arguments);
    n == null ? this.removeAttribute(t) : this.setAttribute(t, n);
  };
}
function ns(t, e) {
  return function() {
    var n = e.apply(this, arguments);
    n == null ? this.removeAttributeNS(t.space, t.local) : this.setAttributeNS(t.space, t.local, n);
  };
}
function rs(t, e) {
  var n = Sn(t);
  if (arguments.length < 2) {
    var r = this.node();
    return n.local ? r.getAttributeNS(n.space, n.local) : r.getAttribute(n);
  }
  return this.each((e == null ? n.local ? Jo : Ko : typeof e == "function" ? n.local ? ns : es : n.local ? ts : jo)(n, e));
}
function zi(t) {
  return t.ownerDocument && t.ownerDocument.defaultView || t.document && t || t.defaultView;
}
function is(t) {
  return function() {
    this.style.removeProperty(t);
  };
}
function as(t, e, n) {
  return function() {
    this.style.setProperty(t, e, n);
  };
}
function os(t, e, n) {
  return function() {
    var r = e.apply(this, arguments);
    r == null ? this.style.removeProperty(t) : this.style.setProperty(t, r, n);
  };
}
function ss(t, e, n) {
  return arguments.length > 1 ? this.each((e == null ? is : typeof e == "function" ? os : as)(t, e, n ?? "")) : me(this.node(), t);
}
function me(t, e) {
  return t.style.getPropertyValue(e) || zi(t).getComputedStyle(t, null).getPropertyValue(e);
}
function us(t) {
  return function() {
    delete this[t];
  };
}
function cs(t, e) {
  return function() {
    this[t] = e;
  };
}
function ls(t, e) {
  return function() {
    var n = e.apply(this, arguments);
    n == null ? delete this[t] : this[t] = n;
  };
}
function fs(t, e) {
  return arguments.length > 1 ? this.each((e == null ? us : typeof e == "function" ? ls : cs)(t, e)) : this.node()[t];
}
function Li(t) {
  return t.trim().split(/^|\s+/);
}
function yr(t) {
  return t.classList || new Hi(t);
}
function Hi(t) {
  this._node = t, this._names = Li(t.getAttribute("class") || "");
}
Hi.prototype = {
  add: function(t) {
    var e = this._names.indexOf(t);
    e < 0 && (this._names.push(t), this._node.setAttribute("class", this._names.join(" ")));
  },
  remove: function(t) {
    var e = this._names.indexOf(t);
    e >= 0 && (this._names.splice(e, 1), this._node.setAttribute("class", this._names.join(" ")));
  },
  contains: function(t) {
    return this._names.indexOf(t) >= 0;
  }
};
function Xi(t, e) {
  for (var n = yr(t), r = -1, i = e.length; ++r < i; ) n.add(e[r]);
}
function Vi(t, e) {
  for (var n = yr(t), r = -1, i = e.length; ++r < i; ) n.remove(e[r]);
}
function hs(t) {
  return function() {
    Xi(this, t);
  };
}
function ds(t) {
  return function() {
    Vi(this, t);
  };
}
function ms(t, e) {
  return function() {
    (e.apply(this, arguments) ? Xi : Vi)(this, t);
  };
}
function gs(t, e) {
  var n = Li(t + "");
  if (arguments.length < 2) {
    for (var r = yr(this.node()), i = -1, a = n.length; ++i < a; ) if (!r.contains(n[i])) return !1;
    return !0;
  }
  return this.each((typeof e == "function" ? ms : e ? hs : ds)(n, e));
}
function vs() {
  this.textContent = "";
}
function ps(t) {
  return function() {
    this.textContent = t;
  };
}
function _s(t) {
  return function() {
    var e = t.apply(this, arguments);
    this.textContent = e ?? "";
  };
}
function ys(t) {
  return arguments.length ? this.each(t == null ? vs : (typeof t == "function" ? _s : ps)(t)) : this.node().textContent;
}
function ws() {
  this.innerHTML = "";
}
function xs(t) {
  return function() {
    this.innerHTML = t;
  };
}
function bs(t) {
  return function() {
    var e = t.apply(this, arguments);
    this.innerHTML = e ?? "";
  };
}
function Ms(t) {
  return arguments.length ? this.each(t == null ? ws : (typeof t == "function" ? bs : xs)(t)) : this.node().innerHTML;
}
function Ts() {
  this.nextSibling && this.parentNode.appendChild(this);
}
function Ss() {
  return this.each(Ts);
}
function ks() {
  this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function Ds() {
  return this.each(ks);
}
function Cs(t) {
  var e = typeof t == "function" ? t : Fi(t);
  return this.select(function() {
    return this.appendChild(e.apply(this, arguments));
  });
}
function $s() {
  return null;
}
function Es(t, e) {
  var n = typeof t == "function" ? t : Fi(t), r = e == null ? $s : typeof e == "function" ? e : _r(e);
  return this.select(function() {
    return this.insertBefore(n.apply(this, arguments), r.apply(this, arguments) || null);
  });
}
function As() {
  var t = this.parentNode;
  t && t.removeChild(this);
}
function Ns() {
  return this.each(As);
}
function Ps() {
  var t = this.cloneNode(!1), e = this.parentNode;
  return e ? e.insertBefore(t, this.nextSibling) : t;
}
function Us() {
  var t = this.cloneNode(!0), e = this.parentNode;
  return e ? e.insertBefore(t, this.nextSibling) : t;
}
function Os(t) {
  return this.select(t ? Us : Ps);
}
function Fs(t) {
  return arguments.length ? this.property("__data__", t) : this.node().__data__;
}
function Ys(t) {
  return function(e) {
    t.call(this, e, this.__data__);
  };
}
function Is(t) {
  return t.trim().split(/^|\s+/).map(function(e) {
    var n = "", r = e.indexOf(".");
    return r >= 0 && (n = e.slice(r + 1), e = e.slice(0, r)), { type: e, name: n };
  });
}
function Ws(t) {
  return function() {
    var e = this.__on;
    if (e) {
      for (var n = 0, r = -1, i = e.length, a; n < i; ++n)
        a = e[n], (!t.type || a.type === t.type) && a.name === t.name ? this.removeEventListener(a.type, a.listener, a.options) : e[++r] = a;
      ++r ? e.length = r : delete this.__on;
    }
  };
}
function Rs(t, e, n) {
  return function() {
    var r = this.__on, i, a = Ys(e);
    if (r) {
      for (var o = 0, s = r.length; o < s; ++o)
        if ((i = r[o]).type === t.type && i.name === t.name) {
          this.removeEventListener(i.type, i.listener, i.options), this.addEventListener(i.type, i.listener = a, i.options = n), i.value = e;
          return;
        }
    }
    this.addEventListener(t.type, a, n), i = { type: t.type, name: t.name, value: e, listener: a, options: n }, r ? r.push(i) : this.__on = [i];
  };
}
function zs(t, e, n) {
  var r = Is(t + ""), i, a = r.length, o;
  if (arguments.length < 2) {
    var s = this.node().__on;
    if (s) {
      for (var c = 0, u = s.length, l; c < u; ++c)
        for (i = 0, l = s[c]; i < a; ++i)
          if ((o = r[i]).type === l.type && o.name === l.name)
            return l.value;
    }
    return;
  }
  for (s = e ? Rs : Ws, i = 0; i < a; ++i) this.each(s(r[i], e, n));
  return this;
}
function qi(t, e, n) {
  var r = zi(t), i = r.CustomEvent;
  typeof i == "function" ? i = new i(e, n) : (i = r.document.createEvent("Event"), n ? (i.initEvent(e, n.bubbles, n.cancelable), i.detail = n.detail) : i.initEvent(e, !1, !1)), t.dispatchEvent(i);
}
function Ls(t, e) {
  return function() {
    return qi(this, t, e);
  };
}
function Hs(t, e) {
  return function() {
    return qi(this, t, e.apply(this, arguments));
  };
}
function Xs(t, e) {
  return this.each((typeof e == "function" ? Hs : Ls)(t, e));
}
function* Vs() {
  for (var t = this._groups, e = 0, n = t.length; e < n; ++e)
    for (var r = t[e], i = 0, a = r.length, o; i < a; ++i)
      (o = r[i]) && (yield o);
}
var Bi = [null];
function bt(t, e) {
  this._groups = t, this._parents = e;
}
function Ye() {
  return new bt([[document.documentElement]], Bi);
}
function qs() {
  return this;
}
bt.prototype = Ye.prototype = {
  constructor: bt,
  select: _o,
  selectAll: bo,
  selectChild: ko,
  selectChildren: Eo,
  filter: Ao,
  data: Yo,
  enter: No,
  exit: Wo,
  join: Ro,
  merge: zo,
  selection: qs,
  order: Lo,
  sort: Ho,
  call: Vo,
  nodes: qo,
  node: Bo,
  size: Go,
  empty: Qo,
  each: Zo,
  attr: rs,
  style: ss,
  property: fs,
  classed: gs,
  text: ys,
  html: Ms,
  raise: Ss,
  lower: Ds,
  append: Cs,
  insert: Es,
  remove: Ns,
  clone: Os,
  datum: Fs,
  on: zs,
  dispatch: Xs,
  [Symbol.iterator]: Vs
};
function at(t) {
  return typeof t == "string" ? new bt([[document.querySelector(t)]], [document.documentElement]) : new bt([[t]], Bi);
}
function Bs(t) {
  let e;
  for (; e = t.sourceEvent; ) t = e;
  return t;
}
function vt(t, e) {
  if (t = Bs(t), e === void 0 && (e = t.currentTarget), e) {
    var n = e.ownerSVGElement || e;
    if (n.createSVGPoint) {
      var r = n.createSVGPoint();
      return r.x = t.clientX, r.y = t.clientY, r = r.matrixTransform(e.getScreenCTM().inverse()), [r.x, r.y];
    }
    if (e.getBoundingClientRect) {
      var i = e.getBoundingClientRect();
      return [t.clientX - i.left - e.clientLeft, t.clientY - i.top - e.clientTop];
    }
  }
  return [t.pageX, t.pageY];
}
const Gs = { passive: !1 }, Ne = { capture: !0, passive: !1 };
function Un(t) {
  t.stopImmediatePropagation();
}
function he(t) {
  t.preventDefault(), t.stopImmediatePropagation();
}
function Gi(t) {
  var e = t.document.documentElement, n = at(t).on("dragstart.drag", he, Ne);
  "onselectstart" in e ? n.on("selectstart.drag", he, Ne) : (e.__noselect = e.style.MozUserSelect, e.style.MozUserSelect = "none");
}
function Qi(t, e) {
  var n = t.document.documentElement, r = at(t).on("dragstart.drag", null);
  e && (r.on("click.drag", he, Ne), setTimeout(function() {
    r.on("click.drag", null);
  }, 0)), "onselectstart" in n ? r.on("selectstart.drag", null) : (n.style.MozUserSelect = n.__noselect, delete n.__noselect);
}
const Le = (t) => () => t;
function Kn(t, {
  sourceEvent: e,
  subject: n,
  target: r,
  identifier: i,
  active: a,
  x: o,
  y: s,
  dx: c,
  dy: u,
  dispatch: l
}) {
  Object.defineProperties(this, {
    type: { value: t, enumerable: !0, configurable: !0 },
    sourceEvent: { value: e, enumerable: !0, configurable: !0 },
    subject: { value: n, enumerable: !0, configurable: !0 },
    target: { value: r, enumerable: !0, configurable: !0 },
    identifier: { value: i, enumerable: !0, configurable: !0 },
    active: { value: a, enumerable: !0, configurable: !0 },
    x: { value: o, enumerable: !0, configurable: !0 },
    y: { value: s, enumerable: !0, configurable: !0 },
    dx: { value: c, enumerable: !0, configurable: !0 },
    dy: { value: u, enumerable: !0, configurable: !0 },
    _: { value: l }
  });
}
Kn.prototype.on = function() {
  var t = this._.on.apply(this._, arguments);
  return t === this._ ? this : t;
};
function Qs(t) {
  return !t.ctrlKey && !t.button;
}
function Zs() {
  return this.parentNode;
}
function Ks(t, e) {
  return e ?? { x: t.x, y: t.y };
}
function Js() {
  return navigator.maxTouchPoints || "ontouchstart" in this;
}
function tn() {
  var t = Qs, e = Zs, n = Ks, r = Js, i = {}, a = Tn("start", "drag", "end"), o = 0, s, c, u, l, d = 0;
  function h(f) {
    f.on("mousedown.drag", g).filter(r).on("touchstart.drag", $).on("touchmove.drag", b, Gs).on("touchend.drag touchcancel.drag", F).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  function g(f, _) {
    if (!(l || !t.call(this, f, _))) {
      var m = y(this, e.call(this, f, _), f, _, "mouse");
      m && (at(f.view).on("mousemove.drag", S, Ne).on("mouseup.drag", k, Ne), Gi(f.view), Un(f), u = !1, s = f.clientX, c = f.clientY, m("start", f));
    }
  }
  function S(f) {
    if (he(f), !u) {
      var _ = f.clientX - s, m = f.clientY - c;
      u = _ * _ + m * m > d;
    }
    i.mouse("drag", f);
  }
  function k(f) {
    at(f.view).on("mousemove.drag mouseup.drag", null), Qi(f.view, u), he(f), i.mouse("end", f);
  }
  function $(f, _) {
    if (t.call(this, f, _)) {
      var m = f.changedTouches, p = e.call(this, f, _), w = m.length, N, Y;
      for (N = 0; N < w; ++N)
        (Y = y(this, p, f, _, m[N].identifier, m[N])) && (Un(f), Y("start", f, m[N]));
    }
  }
  function b(f) {
    var _ = f.changedTouches, m = _.length, p, w;
    for (p = 0; p < m; ++p)
      (w = i[_[p].identifier]) && (he(f), w("drag", f, _[p]));
  }
  function F(f) {
    var _ = f.changedTouches, m = _.length, p, w;
    for (l && clearTimeout(l), l = setTimeout(function() {
      l = null;
    }, 500), p = 0; p < m; ++p)
      (w = i[_[p].identifier]) && (Un(f), w("end", f, _[p]));
  }
  function y(f, _, m, p, w, N) {
    var Y = a.copy(), E = vt(N || m, _), Q, J, v;
    if ((v = n.call(f, new Kn("beforestart", {
      sourceEvent: m,
      target: h,
      identifier: w,
      active: o,
      x: E[0],
      y: E[1],
      dx: 0,
      dy: 0,
      dispatch: Y
    }), p)) != null)
      return Q = v.x - E[0] || 0, J = v.y - E[1] || 0, function O(x, U, L) {
        var z = E, H;
        switch (x) {
          case "start":
            i[w] = O, H = o++;
            break;
          case "end":
            delete i[w], --o;
          case "drag":
            E = vt(L || U, _), H = o;
            break;
        }
        Y.call(
          x,
          f,
          new Kn(x, {
            sourceEvent: U,
            subject: v,
            target: h,
            identifier: w,
            active: H,
            x: E[0] + Q,
            y: E[1] + J,
            dx: E[0] - z[0],
            dy: E[1] - z[1],
            dispatch: Y
          }),
          p
        );
      };
  }
  return h.filter = function(f) {
    return arguments.length ? (t = typeof f == "function" ? f : Le(!!f), h) : t;
  }, h.container = function(f) {
    return arguments.length ? (e = typeof f == "function" ? f : Le(f), h) : e;
  }, h.subject = function(f) {
    return arguments.length ? (n = typeof f == "function" ? f : Le(f), h) : n;
  }, h.touchable = function(f) {
    return arguments.length ? (r = typeof f == "function" ? f : Le(!!f), h) : r;
  }, h.on = function() {
    var f = a.on.apply(a, arguments);
    return f === a ? h : f;
  }, h.clickDistance = function(f) {
    return arguments.length ? (d = (f = +f) * f, h) : Math.sqrt(d);
  }, h;
}
function wr(t, e, n) {
  t.prototype = e.prototype = n, n.constructor = t;
}
function Zi(t, e) {
  var n = Object.create(t.prototype);
  for (var r in e) n[r] = e[r];
  return n;
}
function Ie() {
}
var Pe = 0.7, cn = 1 / Pe, de = "\\s*([+-]?\\d+)\\s*", Ue = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", Nt = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", js = /^#([0-9a-f]{3,8})$/, tu = new RegExp(`^rgb\\(${de},${de},${de}\\)$`), eu = new RegExp(`^rgb\\(${Nt},${Nt},${Nt}\\)$`), nu = new RegExp(`^rgba\\(${de},${de},${de},${Ue}\\)$`), ru = new RegExp(`^rgba\\(${Nt},${Nt},${Nt},${Ue}\\)$`), iu = new RegExp(`^hsl\\(${Ue},${Nt},${Nt}\\)$`), au = new RegExp(`^hsla\\(${Ue},${Nt},${Nt},${Ue}\\)$`), Wr = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
wr(Ie, ee, {
  copy(t) {
    return Object.assign(new this.constructor(), this, t);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: Rr,
  // Deprecated! Use color.formatHex.
  formatHex: Rr,
  formatHex8: ou,
  formatHsl: su,
  formatRgb: zr,
  toString: zr
});
function Rr() {
  return this.rgb().formatHex();
}
function ou() {
  return this.rgb().formatHex8();
}
function su() {
  return Ki(this).formatHsl();
}
function zr() {
  return this.rgb().formatRgb();
}
function ee(t) {
  var e, n;
  return t = (t + "").trim().toLowerCase(), (e = js.exec(t)) ? (n = e[1].length, e = parseInt(e[1], 16), n === 6 ? Lr(e) : n === 3 ? new yt(e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | e & 240, (e & 15) << 4 | e & 15, 1) : n === 8 ? He(e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, (e & 255) / 255) : n === 4 ? He(e >> 12 & 15 | e >> 8 & 240, e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | e & 240, ((e & 15) << 4 | e & 15) / 255) : null) : (e = tu.exec(t)) ? new yt(e[1], e[2], e[3], 1) : (e = eu.exec(t)) ? new yt(e[1] * 255 / 100, e[2] * 255 / 100, e[3] * 255 / 100, 1) : (e = nu.exec(t)) ? He(e[1], e[2], e[3], e[4]) : (e = ru.exec(t)) ? He(e[1] * 255 / 100, e[2] * 255 / 100, e[3] * 255 / 100, e[4]) : (e = iu.exec(t)) ? Vr(e[1], e[2] / 100, e[3] / 100, 1) : (e = au.exec(t)) ? Vr(e[1], e[2] / 100, e[3] / 100, e[4]) : Wr.hasOwnProperty(t) ? Lr(Wr[t]) : t === "transparent" ? new yt(NaN, NaN, NaN, 0) : null;
}
function Lr(t) {
  return new yt(t >> 16 & 255, t >> 8 & 255, t & 255, 1);
}
function He(t, e, n, r) {
  return r <= 0 && (t = e = n = NaN), new yt(t, e, n, r);
}
function uu(t) {
  return t instanceof Ie || (t = ee(t)), t ? (t = t.rgb(), new yt(t.r, t.g, t.b, t.opacity)) : new yt();
}
function Jn(t, e, n, r) {
  return arguments.length === 1 ? uu(t) : new yt(t, e, n, r ?? 1);
}
function yt(t, e, n, r) {
  this.r = +t, this.g = +e, this.b = +n, this.opacity = +r;
}
wr(yt, Jn, Zi(Ie, {
  brighter(t) {
    return t = t == null ? cn : Math.pow(cn, t), new yt(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  darker(t) {
    return t = t == null ? Pe : Math.pow(Pe, t), new yt(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new yt(Jt(this.r), Jt(this.g), Jt(this.b), ln(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: Hr,
  // Deprecated! Use color.formatHex.
  formatHex: Hr,
  formatHex8: cu,
  formatRgb: Xr,
  toString: Xr
}));
function Hr() {
  return `#${Zt(this.r)}${Zt(this.g)}${Zt(this.b)}`;
}
function cu() {
  return `#${Zt(this.r)}${Zt(this.g)}${Zt(this.b)}${Zt((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function Xr() {
  const t = ln(this.opacity);
  return `${t === 1 ? "rgb(" : "rgba("}${Jt(this.r)}, ${Jt(this.g)}, ${Jt(this.b)}${t === 1 ? ")" : `, ${t})`}`;
}
function ln(t) {
  return isNaN(t) ? 1 : Math.max(0, Math.min(1, t));
}
function Jt(t) {
  return Math.max(0, Math.min(255, Math.round(t) || 0));
}
function Zt(t) {
  return t = Jt(t), (t < 16 ? "0" : "") + t.toString(16);
}
function Vr(t, e, n, r) {
  return r <= 0 ? t = e = n = NaN : n <= 0 || n >= 1 ? t = e = NaN : e <= 0 && (t = NaN), new St(t, e, n, r);
}
function Ki(t) {
  if (t instanceof St) return new St(t.h, t.s, t.l, t.opacity);
  if (t instanceof Ie || (t = ee(t)), !t) return new St();
  if (t instanceof St) return t;
  t = t.rgb();
  var e = t.r / 255, n = t.g / 255, r = t.b / 255, i = Math.min(e, n, r), a = Math.max(e, n, r), o = NaN, s = a - i, c = (a + i) / 2;
  return s ? (e === a ? o = (n - r) / s + (n < r) * 6 : n === a ? o = (r - e) / s + 2 : o = (e - n) / s + 4, s /= c < 0.5 ? a + i : 2 - a - i, o *= 60) : s = c > 0 && c < 1 ? 0 : o, new St(o, s, c, t.opacity);
}
function lu(t, e, n, r) {
  return arguments.length === 1 ? Ki(t) : new St(t, e, n, r ?? 1);
}
function St(t, e, n, r) {
  this.h = +t, this.s = +e, this.l = +n, this.opacity = +r;
}
wr(St, lu, Zi(Ie, {
  brighter(t) {
    return t = t == null ? cn : Math.pow(cn, t), new St(this.h, this.s, this.l * t, this.opacity);
  },
  darker(t) {
    return t = t == null ? Pe : Math.pow(Pe, t), new St(this.h, this.s, this.l * t, this.opacity);
  },
  rgb() {
    var t = this.h % 360 + (this.h < 0) * 360, e = isNaN(t) || isNaN(this.s) ? 0 : this.s, n = this.l, r = n + (n < 0.5 ? n : 1 - n) * e, i = 2 * n - r;
    return new yt(
      On(t >= 240 ? t - 240 : t + 120, i, r),
      On(t, i, r),
      On(t < 120 ? t + 240 : t - 120, i, r),
      this.opacity
    );
  },
  clamp() {
    return new St(qr(this.h), Xe(this.s), Xe(this.l), ln(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const t = ln(this.opacity);
    return `${t === 1 ? "hsl(" : "hsla("}${qr(this.h)}, ${Xe(this.s) * 100}%, ${Xe(this.l) * 100}%${t === 1 ? ")" : `, ${t})`}`;
  }
}));
function qr(t) {
  return t = (t || 0) % 360, t < 0 ? t + 360 : t;
}
function Xe(t) {
  return Math.max(0, Math.min(1, t || 0));
}
function On(t, e, n) {
  return (t < 60 ? e + (n - e) * t / 60 : t < 180 ? n : t < 240 ? e + (n - e) * (240 - t) / 60 : e) * 255;
}
const xr = (t) => () => t;
function fu(t, e) {
  return function(n) {
    return t + n * e;
  };
}
function hu(t, e, n) {
  return t = Math.pow(t, n), e = Math.pow(e, n) - t, n = 1 / n, function(r) {
    return Math.pow(t + r * e, n);
  };
}
function du(t) {
  return (t = +t) == 1 ? Ji : function(e, n) {
    return n - e ? hu(e, n, t) : xr(isNaN(e) ? n : e);
  };
}
function Ji(t, e) {
  var n = e - t;
  return n ? fu(t, n) : xr(isNaN(t) ? e : t);
}
const fn = function t(e) {
  var n = du(e);
  function r(i, a) {
    var o = n((i = Jn(i)).r, (a = Jn(a)).r), s = n(i.g, a.g), c = n(i.b, a.b), u = Ji(i.opacity, a.opacity);
    return function(l) {
      return i.r = o(l), i.g = s(l), i.b = c(l), i.opacity = u(l), i + "";
    };
  }
  return r.gamma = t, r;
}(1);
function mu(t, e) {
  e || (e = []);
  var n = t ? Math.min(e.length, t.length) : 0, r = e.slice(), i;
  return function(a) {
    for (i = 0; i < n; ++i) r[i] = t[i] * (1 - a) + e[i] * a;
    return r;
  };
}
function gu(t) {
  return ArrayBuffer.isView(t) && !(t instanceof DataView);
}
function vu(t, e) {
  var n = e ? e.length : 0, r = t ? Math.min(n, t.length) : 0, i = new Array(r), a = new Array(n), o;
  for (o = 0; o < r; ++o) i[o] = br(t[o], e[o]);
  for (; o < n; ++o) a[o] = e[o];
  return function(s) {
    for (o = 0; o < r; ++o) a[o] = i[o](s);
    return a;
  };
}
function pu(t, e) {
  var n = /* @__PURE__ */ new Date();
  return t = +t, e = +e, function(r) {
    return n.setTime(t * (1 - r) + e * r), n;
  };
}
function Tt(t, e) {
  return t = +t, e = +e, function(n) {
    return t * (1 - n) + e * n;
  };
}
function _u(t, e) {
  var n = {}, r = {}, i;
  (t === null || typeof t != "object") && (t = {}), (e === null || typeof e != "object") && (e = {});
  for (i in e)
    i in t ? n[i] = br(t[i], e[i]) : r[i] = e[i];
  return function(a) {
    for (i in n) r[i] = n[i](a);
    return r;
  };
}
var jn = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, Fn = new RegExp(jn.source, "g");
function yu(t) {
  return function() {
    return t;
  };
}
function wu(t) {
  return function(e) {
    return t(e) + "";
  };
}
function ji(t, e) {
  var n = jn.lastIndex = Fn.lastIndex = 0, r, i, a, o = -1, s = [], c = [];
  for (t = t + "", e = e + ""; (r = jn.exec(t)) && (i = Fn.exec(e)); )
    (a = i.index) > n && (a = e.slice(n, a), s[o] ? s[o] += a : s[++o] = a), (r = r[0]) === (i = i[0]) ? s[o] ? s[o] += i : s[++o] = i : (s[++o] = null, c.push({ i: o, x: Tt(r, i) })), n = Fn.lastIndex;
  return n < e.length && (a = e.slice(n), s[o] ? s[o] += a : s[++o] = a), s.length < 2 ? c[0] ? wu(c[0].x) : yu(e) : (e = c.length, function(u) {
    for (var l = 0, d; l < e; ++l) s[(d = c[l]).i] = d.x(u);
    return s.join("");
  });
}
function br(t, e) {
  var n = typeof e, r;
  return e == null || n === "boolean" ? xr(e) : (n === "number" ? Tt : n === "string" ? (r = ee(e)) ? (e = r, fn) : ji : e instanceof ee ? fn : e instanceof Date ? pu : gu(e) ? mu : Array.isArray(e) ? vu : typeof e.valueOf != "function" && typeof e.toString != "function" || isNaN(e) ? _u : Tt)(t, e);
}
function xu(t, e) {
  return t = +t, e = +e, function(n) {
    return Math.round(t * (1 - n) + e * n);
  };
}
var Br = 180 / Math.PI, tr = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};
function ta(t, e, n, r, i, a) {
  var o, s, c;
  return (o = Math.sqrt(t * t + e * e)) && (t /= o, e /= o), (c = t * n + e * r) && (n -= t * c, r -= e * c), (s = Math.sqrt(n * n + r * r)) && (n /= s, r /= s, c /= s), t * r < e * n && (t = -t, e = -e, c = -c, o = -o), {
    translateX: i,
    translateY: a,
    rotate: Math.atan2(e, t) * Br,
    skewX: Math.atan(c) * Br,
    scaleX: o,
    scaleY: s
  };
}
var Ve;
function bu(t) {
  const e = new (typeof DOMMatrix == "function" ? DOMMatrix : WebKitCSSMatrix)(t + "");
  return e.isIdentity ? tr : ta(e.a, e.b, e.c, e.d, e.e, e.f);
}
function Mu(t) {
  return t == null || (Ve || (Ve = document.createElementNS("http://www.w3.org/2000/svg", "g")), Ve.setAttribute("transform", t), !(t = Ve.transform.baseVal.consolidate())) ? tr : (t = t.matrix, ta(t.a, t.b, t.c, t.d, t.e, t.f));
}
function ea(t, e, n, r) {
  function i(u) {
    return u.length ? u.pop() + " " : "";
  }
  function a(u, l, d, h, g, S) {
    if (u !== d || l !== h) {
      var k = g.push("translate(", null, e, null, n);
      S.push({ i: k - 4, x: Tt(u, d) }, { i: k - 2, x: Tt(l, h) });
    } else (d || h) && g.push("translate(" + d + e + h + n);
  }
  function o(u, l, d, h) {
    u !== l ? (u - l > 180 ? l += 360 : l - u > 180 && (u += 360), h.push({ i: d.push(i(d) + "rotate(", null, r) - 2, x: Tt(u, l) })) : l && d.push(i(d) + "rotate(" + l + r);
  }
  function s(u, l, d, h) {
    u !== l ? h.push({ i: d.push(i(d) + "skewX(", null, r) - 2, x: Tt(u, l) }) : l && d.push(i(d) + "skewX(" + l + r);
  }
  function c(u, l, d, h, g, S) {
    if (u !== d || l !== h) {
      var k = g.push(i(g) + "scale(", null, ",", null, ")");
      S.push({ i: k - 4, x: Tt(u, d) }, { i: k - 2, x: Tt(l, h) });
    } else (d !== 1 || h !== 1) && g.push(i(g) + "scale(" + d + "," + h + ")");
  }
  return function(u, l) {
    var d = [], h = [];
    return u = t(u), l = t(l), a(u.translateX, u.translateY, l.translateX, l.translateY, d, h), o(u.rotate, l.rotate, d, h), s(u.skewX, l.skewX, d, h), c(u.scaleX, u.scaleY, l.scaleX, l.scaleY, d, h), u = l = null, function(g) {
      for (var S = -1, k = h.length, $; ++S < k; ) d[($ = h[S]).i] = $.x(g);
      return d.join("");
    };
  };
}
var Tu = ea(bu, "px, ", "px)", "deg)"), Su = ea(Mu, ", ", ")", ")"), ku = 1e-12;
function Gr(t) {
  return ((t = Math.exp(t)) + 1 / t) / 2;
}
function Du(t) {
  return ((t = Math.exp(t)) - 1 / t) / 2;
}
function Cu(t) {
  return ((t = Math.exp(2 * t)) - 1) / (t + 1);
}
const $u = function t(e, n, r) {
  function i(a, o) {
    var s = a[0], c = a[1], u = a[2], l = o[0], d = o[1], h = o[2], g = l - s, S = d - c, k = g * g + S * S, $, b;
    if (k < ku)
      b = Math.log(h / u) / e, $ = function(p) {
        return [
          s + p * g,
          c + p * S,
          u * Math.exp(e * p * b)
        ];
      };
    else {
      var F = Math.sqrt(k), y = (h * h - u * u + r * k) / (2 * u * n * F), f = (h * h - u * u - r * k) / (2 * h * n * F), _ = Math.log(Math.sqrt(y * y + 1) - y), m = Math.log(Math.sqrt(f * f + 1) - f);
      b = (m - _) / e, $ = function(p) {
        var w = p * b, N = Gr(_), Y = u / (n * F) * (N * Cu(e * w + _) - Du(_));
        return [
          s + Y * g,
          c + Y * S,
          u * N / Gr(e * w + _)
        ];
      };
    }
    return $.duration = b * 1e3 * e / Math.SQRT2, $;
  }
  return i.rho = function(a) {
    var o = Math.max(1e-3, +a), s = o * o, c = s * s;
    return t(o, s, c);
  }, i;
}(Math.SQRT2, 2, 4);
var ge = 0, $e = 0, we = 0, na = 1e3, hn, Ee, dn = 0, ne = 0, kn = 0, Oe = typeof performance == "object" && performance.now ? performance : Date, ra = typeof window == "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(t) {
  setTimeout(t, 17);
};
function Mr() {
  return ne || (ra(Eu), ne = Oe.now() + kn);
}
function Eu() {
  ne = 0;
}
function mn() {
  this._call = this._time = this._next = null;
}
mn.prototype = ia.prototype = {
  constructor: mn,
  restart: function(t, e, n) {
    if (typeof t != "function") throw new TypeError("callback is not a function");
    n = (n == null ? Mr() : +n) + (e == null ? 0 : +e), !this._next && Ee !== this && (Ee ? Ee._next = this : hn = this, Ee = this), this._call = t, this._time = n, er();
  },
  stop: function() {
    this._call && (this._call = null, this._time = 1 / 0, er());
  }
};
function ia(t, e, n) {
  var r = new mn();
  return r.restart(t, e, n), r;
}
function Au() {
  Mr(), ++ge;
  for (var t = hn, e; t; )
    (e = ne - t._time) >= 0 && t._call.call(void 0, e), t = t._next;
  --ge;
}
function Qr() {
  ne = (dn = Oe.now()) + kn, ge = $e = 0;
  try {
    Au();
  } finally {
    ge = 0, Pu(), ne = 0;
  }
}
function Nu() {
  var t = Oe.now(), e = t - dn;
  e > na && (kn -= e, dn = t);
}
function Pu() {
  for (var t, e = hn, n, r = 1 / 0; e; )
    e._call ? (r > e._time && (r = e._time), t = e, e = e._next) : (n = e._next, e._next = null, e = t ? t._next = n : hn = n);
  Ee = t, er(r);
}
function er(t) {
  if (!ge) {
    $e && ($e = clearTimeout($e));
    var e = t - ne;
    e > 24 ? (t < 1 / 0 && ($e = setTimeout(Qr, t - Oe.now() - kn)), we && (we = clearInterval(we))) : (we || (dn = Oe.now(), we = setInterval(Nu, na)), ge = 1, ra(Qr));
  }
}
function Zr(t, e, n) {
  var r = new mn();
  return e = e == null ? 0 : +e, r.restart((i) => {
    r.stop(), t(i + e);
  }, e, n), r;
}
var Uu = Tn("start", "end", "cancel", "interrupt"), Ou = [], aa = 0, Kr = 1, nr = 2, en = 3, Jr = 4, rr = 5, nn = 6;
function Dn(t, e, n, r, i, a) {
  var o = t.__transition;
  if (!o) t.__transition = {};
  else if (n in o) return;
  Fu(t, n, {
    name: e,
    index: r,
    // For context during callback.
    group: i,
    // For context during callback.
    on: Uu,
    tween: Ou,
    time: a.time,
    delay: a.delay,
    duration: a.duration,
    ease: a.ease,
    timer: null,
    state: aa
  });
}
function Tr(t, e) {
  var n = Dt(t, e);
  if (n.state > aa) throw new Error("too late; already scheduled");
  return n;
}
function Ut(t, e) {
  var n = Dt(t, e);
  if (n.state > en) throw new Error("too late; already running");
  return n;
}
function Dt(t, e) {
  var n = t.__transition;
  if (!n || !(n = n[e])) throw new Error("transition not found");
  return n;
}
function Fu(t, e, n) {
  var r = t.__transition, i;
  r[e] = n, n.timer = ia(a, 0, n.time);
  function a(u) {
    n.state = Kr, n.timer.restart(o, n.delay, n.time), n.delay <= u && o(u - n.delay);
  }
  function o(u) {
    var l, d, h, g;
    if (n.state !== Kr) return c();
    for (l in r)
      if (g = r[l], g.name === n.name) {
        if (g.state === en) return Zr(o);
        g.state === Jr ? (g.state = nn, g.timer.stop(), g.on.call("interrupt", t, t.__data__, g.index, g.group), delete r[l]) : +l < e && (g.state = nn, g.timer.stop(), g.on.call("cancel", t, t.__data__, g.index, g.group), delete r[l]);
      }
    if (Zr(function() {
      n.state === en && (n.state = Jr, n.timer.restart(s, n.delay, n.time), s(u));
    }), n.state = nr, n.on.call("start", t, t.__data__, n.index, n.group), n.state === nr) {
      for (n.state = en, i = new Array(h = n.tween.length), l = 0, d = -1; l < h; ++l)
        (g = n.tween[l].value.call(t, t.__data__, n.index, n.group)) && (i[++d] = g);
      i.length = d + 1;
    }
  }
  function s(u) {
    for (var l = u < n.duration ? n.ease.call(null, u / n.duration) : (n.timer.restart(c), n.state = rr, 1), d = -1, h = i.length; ++d < h; )
      i[d].call(t, l);
    n.state === rr && (n.on.call("end", t, t.__data__, n.index, n.group), c());
  }
  function c() {
    n.state = nn, n.timer.stop(), delete r[e];
    for (var u in r) return;
    delete t.__transition;
  }
}
function rn(t, e) {
  var n = t.__transition, r, i, a = !0, o;
  if (n) {
    e = e == null ? null : e + "";
    for (o in n) {
      if ((r = n[o]).name !== e) {
        a = !1;
        continue;
      }
      i = r.state > nr && r.state < rr, r.state = nn, r.timer.stop(), r.on.call(i ? "interrupt" : "cancel", t, t.__data__, r.index, r.group), delete n[o];
    }
    a && delete t.__transition;
  }
}
function Yu(t) {
  return this.each(function() {
    rn(this, t);
  });
}
function Iu(t, e) {
  var n, r;
  return function() {
    var i = Ut(this, t), a = i.tween;
    if (a !== n) {
      r = n = a;
      for (var o = 0, s = r.length; o < s; ++o)
        if (r[o].name === e) {
          r = r.slice(), r.splice(o, 1);
          break;
        }
    }
    i.tween = r;
  };
}
function Wu(t, e, n) {
  var r, i;
  if (typeof n != "function") throw new Error();
  return function() {
    var a = Ut(this, t), o = a.tween;
    if (o !== r) {
      i = (r = o).slice();
      for (var s = { name: e, value: n }, c = 0, u = i.length; c < u; ++c)
        if (i[c].name === e) {
          i[c] = s;
          break;
        }
      c === u && i.push(s);
    }
    a.tween = i;
  };
}
function Ru(t, e) {
  var n = this._id;
  if (t += "", arguments.length < 2) {
    for (var r = Dt(this.node(), n).tween, i = 0, a = r.length, o; i < a; ++i)
      if ((o = r[i]).name === t)
        return o.value;
    return null;
  }
  return this.each((e == null ? Iu : Wu)(n, t, e));
}
function Sr(t, e, n) {
  var r = t._id;
  return t.each(function() {
    var i = Ut(this, r);
    (i.value || (i.value = {}))[e] = n.apply(this, arguments);
  }), function(i) {
    return Dt(i, r).value[e];
  };
}
function oa(t, e) {
  var n;
  return (typeof e == "number" ? Tt : e instanceof ee ? fn : (n = ee(e)) ? (e = n, fn) : ji)(t, e);
}
function zu(t) {
  return function() {
    this.removeAttribute(t);
  };
}
function Lu(t) {
  return function() {
    this.removeAttributeNS(t.space, t.local);
  };
}
function Hu(t, e, n) {
  var r, i = n + "", a;
  return function() {
    var o = this.getAttribute(t);
    return o === i ? null : o === r ? a : a = e(r = o, n);
  };
}
function Xu(t, e, n) {
  var r, i = n + "", a;
  return function() {
    var o = this.getAttributeNS(t.space, t.local);
    return o === i ? null : o === r ? a : a = e(r = o, n);
  };
}
function Vu(t, e, n) {
  var r, i, a;
  return function() {
    var o, s = n(this), c;
    return s == null ? void this.removeAttribute(t) : (o = this.getAttribute(t), c = s + "", o === c ? null : o === r && c === i ? a : (i = c, a = e(r = o, s)));
  };
}
function qu(t, e, n) {
  var r, i, a;
  return function() {
    var o, s = n(this), c;
    return s == null ? void this.removeAttributeNS(t.space, t.local) : (o = this.getAttributeNS(t.space, t.local), c = s + "", o === c ? null : o === r && c === i ? a : (i = c, a = e(r = o, s)));
  };
}
function Bu(t, e) {
  var n = Sn(t), r = n === "transform" ? Su : oa;
  return this.attrTween(t, typeof e == "function" ? (n.local ? qu : Vu)(n, r, Sr(this, "attr." + t, e)) : e == null ? (n.local ? Lu : zu)(n) : (n.local ? Xu : Hu)(n, r, e));
}
function Gu(t, e) {
  return function(n) {
    this.setAttribute(t, e.call(this, n));
  };
}
function Qu(t, e) {
  return function(n) {
    this.setAttributeNS(t.space, t.local, e.call(this, n));
  };
}
function Zu(t, e) {
  var n, r;
  function i() {
    var a = e.apply(this, arguments);
    return a !== r && (n = (r = a) && Qu(t, a)), n;
  }
  return i._value = e, i;
}
function Ku(t, e) {
  var n, r;
  function i() {
    var a = e.apply(this, arguments);
    return a !== r && (n = (r = a) && Gu(t, a)), n;
  }
  return i._value = e, i;
}
function Ju(t, e) {
  var n = "attr." + t;
  if (arguments.length < 2) return (n = this.tween(n)) && n._value;
  if (e == null) return this.tween(n, null);
  if (typeof e != "function") throw new Error();
  var r = Sn(t);
  return this.tween(n, (r.local ? Zu : Ku)(r, e));
}
function ju(t, e) {
  return function() {
    Tr(this, t).delay = +e.apply(this, arguments);
  };
}
function tc(t, e) {
  return e = +e, function() {
    Tr(this, t).delay = e;
  };
}
function ec(t) {
  var e = this._id;
  return arguments.length ? this.each((typeof t == "function" ? ju : tc)(e, t)) : Dt(this.node(), e).delay;
}
function nc(t, e) {
  return function() {
    Ut(this, t).duration = +e.apply(this, arguments);
  };
}
function rc(t, e) {
  return e = +e, function() {
    Ut(this, t).duration = e;
  };
}
function ic(t) {
  var e = this._id;
  return arguments.length ? this.each((typeof t == "function" ? nc : rc)(e, t)) : Dt(this.node(), e).duration;
}
function ac(t, e) {
  if (typeof e != "function") throw new Error();
  return function() {
    Ut(this, t).ease = e;
  };
}
function oc(t) {
  var e = this._id;
  return arguments.length ? this.each(ac(e, t)) : Dt(this.node(), e).ease;
}
function sc(t, e) {
  return function() {
    var n = e.apply(this, arguments);
    if (typeof n != "function") throw new Error();
    Ut(this, t).ease = n;
  };
}
function uc(t) {
  if (typeof t != "function") throw new Error();
  return this.each(sc(this._id, t));
}
function cc(t) {
  typeof t != "function" && (t = Ii(t));
  for (var e = this._groups, n = e.length, r = new Array(n), i = 0; i < n; ++i)
    for (var a = e[i], o = a.length, s = r[i] = [], c, u = 0; u < o; ++u)
      (c = a[u]) && t.call(c, c.__data__, u, a) && s.push(c);
  return new zt(r, this._parents, this._name, this._id);
}
function lc(t) {
  if (t._id !== this._id) throw new Error();
  for (var e = this._groups, n = t._groups, r = e.length, i = n.length, a = Math.min(r, i), o = new Array(r), s = 0; s < a; ++s)
    for (var c = e[s], u = n[s], l = c.length, d = o[s] = new Array(l), h, g = 0; g < l; ++g)
      (h = c[g] || u[g]) && (d[g] = h);
  for (; s < r; ++s)
    o[s] = e[s];
  return new zt(o, this._parents, this._name, this._id);
}
function fc(t) {
  return (t + "").trim().split(/^|\s+/).every(function(e) {
    var n = e.indexOf(".");
    return n >= 0 && (e = e.slice(0, n)), !e || e === "start";
  });
}
function hc(t, e, n) {
  var r, i, a = fc(e) ? Tr : Ut;
  return function() {
    var o = a(this, t), s = o.on;
    s !== r && (i = (r = s).copy()).on(e, n), o.on = i;
  };
}
function dc(t, e) {
  var n = this._id;
  return arguments.length < 2 ? Dt(this.node(), n).on.on(t) : this.each(hc(n, t, e));
}
function mc(t) {
  return function() {
    var e = this.parentNode;
    for (var n in this.__transition) if (+n !== t) return;
    e && e.removeChild(this);
  };
}
function gc() {
  return this.on("end.remove", mc(this._id));
}
function vc(t) {
  var e = this._name, n = this._id;
  typeof t != "function" && (t = _r(t));
  for (var r = this._groups, i = r.length, a = new Array(i), o = 0; o < i; ++o)
    for (var s = r[o], c = s.length, u = a[o] = new Array(c), l, d, h = 0; h < c; ++h)
      (l = s[h]) && (d = t.call(l, l.__data__, h, s)) && ("__data__" in l && (d.__data__ = l.__data__), u[h] = d, Dn(u[h], e, n, h, u, Dt(l, n)));
  return new zt(a, this._parents, e, n);
}
function pc(t) {
  var e = this._name, n = this._id;
  typeof t != "function" && (t = Yi(t));
  for (var r = this._groups, i = r.length, a = [], o = [], s = 0; s < i; ++s)
    for (var c = r[s], u = c.length, l, d = 0; d < u; ++d)
      if (l = c[d]) {
        for (var h = t.call(l, l.__data__, d, c), g, S = Dt(l, n), k = 0, $ = h.length; k < $; ++k)
          (g = h[k]) && Dn(g, e, n, k, h, S);
        a.push(h), o.push(l);
      }
  return new zt(a, o, e, n);
}
var _c = Ye.prototype.constructor;
function yc() {
  return new _c(this._groups, this._parents);
}
function wc(t, e) {
  var n, r, i;
  return function() {
    var a = me(this, t), o = (this.style.removeProperty(t), me(this, t));
    return a === o ? null : a === n && o === r ? i : i = e(n = a, r = o);
  };
}
function sa(t) {
  return function() {
    this.style.removeProperty(t);
  };
}
function xc(t, e, n) {
  var r, i = n + "", a;
  return function() {
    var o = me(this, t);
    return o === i ? null : o === r ? a : a = e(r = o, n);
  };
}
function bc(t, e, n) {
  var r, i, a;
  return function() {
    var o = me(this, t), s = n(this), c = s + "";
    return s == null && (c = s = (this.style.removeProperty(t), me(this, t))), o === c ? null : o === r && c === i ? a : (i = c, a = e(r = o, s));
  };
}
function Mc(t, e) {
  var n, r, i, a = "style." + e, o = "end." + a, s;
  return function() {
    var c = Ut(this, t), u = c.on, l = c.value[a] == null ? s || (s = sa(e)) : void 0;
    (u !== n || i !== l) && (r = (n = u).copy()).on(o, i = l), c.on = r;
  };
}
function Tc(t, e, n) {
  var r = (t += "") == "transform" ? Tu : oa;
  return e == null ? this.styleTween(t, wc(t, r)).on("end.style." + t, sa(t)) : typeof e == "function" ? this.styleTween(t, bc(t, r, Sr(this, "style." + t, e))).each(Mc(this._id, t)) : this.styleTween(t, xc(t, r, e), n).on("end.style." + t, null);
}
function Sc(t, e, n) {
  return function(r) {
    this.style.setProperty(t, e.call(this, r), n);
  };
}
function kc(t, e, n) {
  var r, i;
  function a() {
    var o = e.apply(this, arguments);
    return o !== i && (r = (i = o) && Sc(t, o, n)), r;
  }
  return a._value = e, a;
}
function Dc(t, e, n) {
  var r = "style." + (t += "");
  if (arguments.length < 2) return (r = this.tween(r)) && r._value;
  if (e == null) return this.tween(r, null);
  if (typeof e != "function") throw new Error();
  return this.tween(r, kc(t, e, n ?? ""));
}
function Cc(t) {
  return function() {
    this.textContent = t;
  };
}
function $c(t) {
  return function() {
    var e = t(this);
    this.textContent = e ?? "";
  };
}
function Ec(t) {
  return this.tween("text", typeof t == "function" ? $c(Sr(this, "text", t)) : Cc(t == null ? "" : t + ""));
}
function Ac(t) {
  return function(e) {
    this.textContent = t.call(this, e);
  };
}
function Nc(t) {
  var e, n;
  function r() {
    var i = t.apply(this, arguments);
    return i !== n && (e = (n = i) && Ac(i)), e;
  }
  return r._value = t, r;
}
function Pc(t) {
  var e = "text";
  if (arguments.length < 1) return (e = this.tween(e)) && e._value;
  if (t == null) return this.tween(e, null);
  if (typeof t != "function") throw new Error();
  return this.tween(e, Nc(t));
}
function Uc() {
  for (var t = this._name, e = this._id, n = ua(), r = this._groups, i = r.length, a = 0; a < i; ++a)
    for (var o = r[a], s = o.length, c, u = 0; u < s; ++u)
      if (c = o[u]) {
        var l = Dt(c, e);
        Dn(c, t, n, u, o, {
          time: l.time + l.delay + l.duration,
          delay: 0,
          duration: l.duration,
          ease: l.ease
        });
      }
  return new zt(r, this._parents, t, n);
}
function Oc() {
  var t, e, n = this, r = n._id, i = n.size();
  return new Promise(function(a, o) {
    var s = { value: o }, c = { value: function() {
      --i === 0 && a();
    } };
    n.each(function() {
      var u = Ut(this, r), l = u.on;
      l !== t && (e = (t = l).copy(), e._.cancel.push(s), e._.interrupt.push(s), e._.end.push(c)), u.on = e;
    }), i === 0 && a();
  });
}
var Fc = 0;
function zt(t, e, n, r) {
  this._groups = t, this._parents = e, this._name = n, this._id = r;
}
function ua() {
  return ++Fc;
}
var Yt = Ye.prototype;
zt.prototype = {
  constructor: zt,
  select: vc,
  selectAll: pc,
  selectChild: Yt.selectChild,
  selectChildren: Yt.selectChildren,
  filter: cc,
  merge: lc,
  selection: yc,
  transition: Uc,
  call: Yt.call,
  nodes: Yt.nodes,
  node: Yt.node,
  size: Yt.size,
  empty: Yt.empty,
  each: Yt.each,
  on: dc,
  attr: Bu,
  attrTween: Ju,
  style: Tc,
  styleTween: Dc,
  text: Ec,
  textTween: Pc,
  remove: gc,
  tween: Ru,
  delay: ec,
  duration: ic,
  ease: oc,
  easeVarying: uc,
  end: Oc,
  [Symbol.iterator]: Yt[Symbol.iterator]
};
function Yc(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}
var Ic = {
  time: null,
  // Set on use.
  delay: 0,
  duration: 250,
  ease: Yc
};
function Wc(t, e) {
  for (var n; !(n = t.__transition) || !(n = n[e]); )
    if (!(t = t.parentNode))
      throw new Error(`transition ${e} not found`);
  return n;
}
function Rc(t) {
  var e, n;
  t instanceof zt ? (e = t._id, t = t._name) : (e = ua(), (n = Ic).time = Mr(), t = t == null ? null : t + "");
  for (var r = this._groups, i = r.length, a = 0; a < i; ++a)
    for (var o = r[a], s = o.length, c, u = 0; u < s; ++u)
      (c = o[u]) && Dn(c, t, e, u, o, n || Wc(c, e));
  return new zt(r, this._parents, t, e);
}
Ye.prototype.interrupt = Yu;
Ye.prototype.transition = Rc;
const ir = Math.PI, ar = 2 * ir, Gt = 1e-6, zc = ar - Gt;
function or() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null, this._ = "";
}
function ca() {
  return new or();
}
or.prototype = ca.prototype = {
  constructor: or,
  moveTo: function(t, e) {
    this._ += "M" + (this._x0 = this._x1 = +t) + "," + (this._y0 = this._y1 = +e);
  },
  closePath: function() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._ += "Z");
  },
  lineTo: function(t, e) {
    this._ += "L" + (this._x1 = +t) + "," + (this._y1 = +e);
  },
  quadraticCurveTo: function(t, e, n, r) {
    this._ += "Q" + +t + "," + +e + "," + (this._x1 = +n) + "," + (this._y1 = +r);
  },
  bezierCurveTo: function(t, e, n, r, i, a) {
    this._ += "C" + +t + "," + +e + "," + +n + "," + +r + "," + (this._x1 = +i) + "," + (this._y1 = +a);
  },
  arcTo: function(t, e, n, r, i) {
    t = +t, e = +e, n = +n, r = +r, i = +i;
    var a = this._x1, o = this._y1, s = n - t, c = r - e, u = a - t, l = o - e, d = u * u + l * l;
    if (i < 0) throw new Error("negative radius: " + i);
    if (this._x1 === null)
      this._ += "M" + (this._x1 = t) + "," + (this._y1 = e);
    else if (d > Gt) if (!(Math.abs(l * s - c * u) > Gt) || !i)
      this._ += "L" + (this._x1 = t) + "," + (this._y1 = e);
    else {
      var h = n - a, g = r - o, S = s * s + c * c, k = h * h + g * g, $ = Math.sqrt(S), b = Math.sqrt(d), F = i * Math.tan((ir - Math.acos((S + d - k) / (2 * $ * b))) / 2), y = F / b, f = F / $;
      Math.abs(y - 1) > Gt && (this._ += "L" + (t + y * u) + "," + (e + y * l)), this._ += "A" + i + "," + i + ",0,0," + +(l * h > u * g) + "," + (this._x1 = t + f * s) + "," + (this._y1 = e + f * c);
    }
  },
  arc: function(t, e, n, r, i, a) {
    t = +t, e = +e, n = +n, a = !!a;
    var o = n * Math.cos(r), s = n * Math.sin(r), c = t + o, u = e + s, l = 1 ^ a, d = a ? r - i : i - r;
    if (n < 0) throw new Error("negative radius: " + n);
    this._x1 === null ? this._ += "M" + c + "," + u : (Math.abs(this._x1 - c) > Gt || Math.abs(this._y1 - u) > Gt) && (this._ += "L" + c + "," + u), n && (d < 0 && (d = d % ar + ar), d > zc ? this._ += "A" + n + "," + n + ",0,1," + l + "," + (t - o) + "," + (e - s) + "A" + n + "," + n + ",0,1," + l + "," + (this._x1 = c) + "," + (this._y1 = u) : d > Gt && (this._ += "A" + n + "," + n + ",0," + +(d >= ir) + "," + l + "," + (this._x1 = t + n * Math.cos(i)) + "," + (this._y1 = e + n * Math.sin(i))));
  },
  rect: function(t, e, n, r) {
    this._ += "M" + (this._x0 = this._x1 = +t) + "," + (this._y0 = this._y1 = +e) + "h" + +n + "v" + +r + "h" + -n + "Z";
  },
  toString: function() {
    return this._;
  }
};
function Lc(t) {
  return Math.abs(t = Math.round(t)) >= 1e21 ? t.toLocaleString("en").replace(/,/g, "") : t.toString(10);
}
function gn(t, e) {
  if ((n = (t = e ? t.toExponential(e - 1) : t.toExponential()).indexOf("e")) < 0) return null;
  var n, r = t.slice(0, n);
  return [
    r.length > 1 ? r[0] + r.slice(2) : r,
    +t.slice(n + 1)
  ];
}
function ve(t) {
  return t = gn(Math.abs(t)), t ? t[1] : NaN;
}
function Hc(t, e) {
  return function(n, r) {
    for (var i = n.length, a = [], o = 0, s = t[0], c = 0; i > 0 && s > 0 && (c + s + 1 > r && (s = Math.max(1, r - c)), a.push(n.substring(i -= s, i + s)), !((c += s + 1) > r)); )
      s = t[o = (o + 1) % t.length];
    return a.reverse().join(e);
  };
}
function Xc(t) {
  return function(e) {
    return e.replace(/[0-9]/g, function(n) {
      return t[+n];
    });
  };
}
var Vc = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function vn(t) {
  if (!(e = Vc.exec(t))) throw new Error("invalid format: " + t);
  var e;
  return new kr({
    fill: e[1],
    align: e[2],
    sign: e[3],
    symbol: e[4],
    zero: e[5],
    width: e[6],
    comma: e[7],
    precision: e[8] && e[8].slice(1),
    trim: e[9],
    type: e[10]
  });
}
vn.prototype = kr.prototype;
function kr(t) {
  this.fill = t.fill === void 0 ? " " : t.fill + "", this.align = t.align === void 0 ? ">" : t.align + "", this.sign = t.sign === void 0 ? "-" : t.sign + "", this.symbol = t.symbol === void 0 ? "" : t.symbol + "", this.zero = !!t.zero, this.width = t.width === void 0 ? void 0 : +t.width, this.comma = !!t.comma, this.precision = t.precision === void 0 ? void 0 : +t.precision, this.trim = !!t.trim, this.type = t.type === void 0 ? "" : t.type + "";
}
kr.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function qc(t) {
  t: for (var e = t.length, n = 1, r = -1, i; n < e; ++n)
    switch (t[n]) {
      case ".":
        r = i = n;
        break;
      case "0":
        r === 0 && (r = n), i = n;
        break;
      default:
        if (!+t[n]) break t;
        r > 0 && (r = 0);
        break;
    }
  return r > 0 ? t.slice(0, r) + t.slice(i + 1) : t;
}
var la;
function Bc(t, e) {
  var n = gn(t, e);
  if (!n) return t + "";
  var r = n[0], i = n[1], a = i - (la = Math.max(-8, Math.min(8, Math.floor(i / 3))) * 3) + 1, o = r.length;
  return a === o ? r : a > o ? r + new Array(a - o + 1).join("0") : a > 0 ? r.slice(0, a) + "." + r.slice(a) : "0." + new Array(1 - a).join("0") + gn(t, Math.max(0, e + a - 1))[0];
}
function jr(t, e) {
  var n = gn(t, e);
  if (!n) return t + "";
  var r = n[0], i = n[1];
  return i < 0 ? "0." + new Array(-i).join("0") + r : r.length > i + 1 ? r.slice(0, i + 1) + "." + r.slice(i + 1) : r + new Array(i - r.length + 2).join("0");
}
const ti = {
  "%": (t, e) => (t * 100).toFixed(e),
  b: (t) => Math.round(t).toString(2),
  c: (t) => t + "",
  d: Lc,
  e: (t, e) => t.toExponential(e),
  f: (t, e) => t.toFixed(e),
  g: (t, e) => t.toPrecision(e),
  o: (t) => Math.round(t).toString(8),
  p: (t, e) => jr(t * 100, e),
  r: jr,
  s: Bc,
  X: (t) => Math.round(t).toString(16).toUpperCase(),
  x: (t) => Math.round(t).toString(16)
};
function ei(t) {
  return t;
}
var ni = Array.prototype.map, ri = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function Gc(t) {
  var e = t.grouping === void 0 || t.thousands === void 0 ? ei : Hc(ni.call(t.grouping, Number), t.thousands + ""), n = t.currency === void 0 ? "" : t.currency[0] + "", r = t.currency === void 0 ? "" : t.currency[1] + "", i = t.decimal === void 0 ? "." : t.decimal + "", a = t.numerals === void 0 ? ei : Xc(ni.call(t.numerals, String)), o = t.percent === void 0 ? "%" : t.percent + "", s = t.minus === void 0 ? "−" : t.minus + "", c = t.nan === void 0 ? "NaN" : t.nan + "";
  function u(d) {
    d = vn(d);
    var h = d.fill, g = d.align, S = d.sign, k = d.symbol, $ = d.zero, b = d.width, F = d.comma, y = d.precision, f = d.trim, _ = d.type;
    _ === "n" ? (F = !0, _ = "g") : ti[_] || (y === void 0 && (y = 12), f = !0, _ = "g"), ($ || h === "0" && g === "=") && ($ = !0, h = "0", g = "=");
    var m = k === "$" ? n : k === "#" && /[boxX]/.test(_) ? "0" + _.toLowerCase() : "", p = k === "$" ? r : /[%p]/.test(_) ? o : "", w = ti[_], N = /[defgprs%]/.test(_);
    y = y === void 0 ? 6 : /[gprs]/.test(_) ? Math.max(1, Math.min(21, y)) : Math.max(0, Math.min(20, y));
    function Y(E) {
      var Q = m, J = p, v, O, x;
      if (_ === "c")
        J = w(E) + J, E = "";
      else {
        E = +E;
        var U = E < 0 || 1 / E < 0;
        if (E = isNaN(E) ? c : w(Math.abs(E), y), f && (E = qc(E)), U && +E == 0 && S !== "+" && (U = !1), Q = (U ? S === "(" ? S : s : S === "-" || S === "(" ? "" : S) + Q, J = (_ === "s" ? ri[8 + la / 3] : "") + J + (U && S === "(" ? ")" : ""), N) {
          for (v = -1, O = E.length; ++v < O; )
            if (x = E.charCodeAt(v), 48 > x || x > 57) {
              J = (x === 46 ? i + E.slice(v + 1) : E.slice(v)) + J, E = E.slice(0, v);
              break;
            }
        }
      }
      F && !$ && (E = e(E, 1 / 0));
      var L = Q.length + E.length + J.length, z = L < b ? new Array(b - L + 1).join(h) : "";
      switch (F && $ && (E = e(z + E, z.length ? b - J.length : 1 / 0), z = ""), g) {
        case "<":
          E = Q + E + J + z;
          break;
        case "=":
          E = Q + z + E + J;
          break;
        case "^":
          E = z.slice(0, L = z.length >> 1) + Q + E + J + z.slice(L);
          break;
        default:
          E = z + Q + E + J;
          break;
      }
      return a(E);
    }
    return Y.toString = function() {
      return d + "";
    }, Y;
  }
  function l(d, h) {
    var g = u((d = vn(d), d.type = "f", d)), S = Math.max(-8, Math.min(8, Math.floor(ve(h) / 3))) * 3, k = Math.pow(10, -S), $ = ri[8 + S / 3];
    return function(b) {
      return g(k * b) + $;
    };
  }
  return {
    format: u,
    formatPrefix: l
  };
}
var qe, Dr, fa;
Qc({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function Qc(t) {
  return qe = Gc(t), Dr = qe.format, fa = qe.formatPrefix, qe;
}
function Zc(t) {
  return Math.max(0, -ve(Math.abs(t)));
}
function Kc(t, e) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(ve(e) / 3))) * 3 - ve(Math.abs(t)));
}
function Jc(t, e) {
  return t = Math.abs(t), e = Math.abs(e) - t, Math.max(0, ve(e) - ve(t)) + 1;
}
function ha(t, e) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(t);
      break;
    default:
      this.range(e).domain(t);
      break;
  }
  return this;
}
function jc(t) {
  return function() {
    return t;
  };
}
function tl(t) {
  return +t;
}
var ii = [0, 1];
function fe(t) {
  return t;
}
function sr(t, e) {
  return (e -= t = +t) ? function(n) {
    return (n - t) / e;
  } : jc(isNaN(e) ? NaN : 0.5);
}
function el(t, e) {
  var n;
  return t > e && (n = t, t = e, e = n), function(r) {
    return Math.max(t, Math.min(e, r));
  };
}
function nl(t, e, n) {
  var r = t[0], i = t[1], a = e[0], o = e[1];
  return i < r ? (r = sr(i, r), a = n(o, a)) : (r = sr(r, i), a = n(a, o)), function(s) {
    return a(r(s));
  };
}
function rl(t, e, n) {
  var r = Math.min(t.length, e.length) - 1, i = new Array(r), a = new Array(r), o = -1;
  for (t[r] < t[0] && (t = t.slice().reverse(), e = e.slice().reverse()); ++o < r; )
    i[o] = sr(t[o], t[o + 1]), a[o] = n(e[o], e[o + 1]);
  return function(s) {
    var c = Ka(t, s, 1, r) - 1;
    return a[c](i[c](s));
  };
}
function da(t, e) {
  return e.domain(t.domain()).range(t.range()).interpolate(t.interpolate()).clamp(t.clamp()).unknown(t.unknown());
}
function il() {
  var t = ii, e = ii, n = br, r, i, a, o = fe, s, c, u;
  function l() {
    var h = Math.min(t.length, e.length);
    return o !== fe && (o = el(t[0], t[h - 1])), s = h > 2 ? rl : nl, c = u = null, d;
  }
  function d(h) {
    return h == null || isNaN(h = +h) ? a : (c || (c = s(t.map(r), e, n)))(r(o(h)));
  }
  return d.invert = function(h) {
    return o(i((u || (u = s(e, t.map(r), Tt)))(h)));
  }, d.domain = function(h) {
    return arguments.length ? (t = Array.from(h, tl), l()) : t.slice();
  }, d.range = function(h) {
    return arguments.length ? (e = Array.from(h), l()) : e.slice();
  }, d.rangeRound = function(h) {
    return e = Array.from(h), n = xu, l();
  }, d.clamp = function(h) {
    return arguments.length ? (o = h ? !0 : fe, l()) : o !== fe;
  }, d.interpolate = function(h) {
    return arguments.length ? (n = h, l()) : n;
  }, d.unknown = function(h) {
    return arguments.length ? (a = h, d) : a;
  }, function(h, g) {
    return r = h, i = g, l();
  };
}
function ma() {
  return il()(fe, fe);
}
function al(t, e, n, r) {
  var i = Gn(t, e, n), a;
  switch (r = vn(r ?? ",f"), r.type) {
    case "s": {
      var o = Math.max(Math.abs(t), Math.abs(e));
      return r.precision == null && !isNaN(a = Kc(i, o)) && (r.precision = a), fa(r, o);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      r.precision == null && !isNaN(a = Jc(i, Math.max(Math.abs(t), Math.abs(e)))) && (r.precision = a - (r.type === "e"));
      break;
    }
    case "f":
    case "%": {
      r.precision == null && !isNaN(a = Zc(i)) && (r.precision = a - (r.type === "%") * 2);
      break;
    }
  }
  return Dr(r);
}
function ol(t) {
  var e = t.domain;
  return t.ticks = function(n) {
    var r = e();
    return eo(r[0], r[r.length - 1], n ?? 10);
  }, t.tickFormat = function(n, r) {
    var i = e();
    return al(i[0], i[i.length - 1], n ?? 10, r);
  }, t.nice = function(n) {
    n == null && (n = 10);
    var r = e(), i = 0, a = r.length - 1, o = r[i], s = r[a], c, u, l = 10;
    for (s < o && (u = o, o = s, s = u, u = i, i = a, a = u); l-- > 0; ) {
      if (u = Bn(o, s, n), u === c)
        return r[i] = o, r[a] = s, e(r);
      if (u > 0)
        o = Math.floor(o / u) * u, s = Math.ceil(s / u) * u;
      else if (u < 0)
        o = Math.ceil(o * u) / u, s = Math.floor(s * u) / u;
      else
        break;
      c = u;
    }
    return t;
  }, t;
}
function Lt() {
  var t = ma();
  return t.copy = function() {
    return da(t, Lt());
  }, ha.apply(t, arguments), ol(t);
}
function sl(t, e) {
  t = t.slice();
  var n = 0, r = t.length - 1, i = t[n], a = t[r], o;
  return a < i && (o = n, n = r, r = o, o = i, i = a, a = o), t[n] = e.floor(i), t[r] = e.ceil(a), t;
}
var Yn = /* @__PURE__ */ new Date(), In = /* @__PURE__ */ new Date();
function _t(t, e, n, r) {
  function i(a) {
    return t(a = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+a)), a;
  }
  return i.floor = function(a) {
    return t(a = /* @__PURE__ */ new Date(+a)), a;
  }, i.ceil = function(a) {
    return t(a = new Date(a - 1)), e(a, 1), t(a), a;
  }, i.round = function(a) {
    var o = i(a), s = i.ceil(a);
    return a - o < s - a ? o : s;
  }, i.offset = function(a, o) {
    return e(a = /* @__PURE__ */ new Date(+a), o == null ? 1 : Math.floor(o)), a;
  }, i.range = function(a, o, s) {
    var c = [], u;
    if (a = i.ceil(a), s = s == null ? 1 : Math.floor(s), !(a < o) || !(s > 0)) return c;
    do
      c.push(u = /* @__PURE__ */ new Date(+a)), e(a, s), t(a);
    while (u < a && a < o);
    return c;
  }, i.filter = function(a) {
    return _t(function(o) {
      if (o >= o) for (; t(o), !a(o); ) o.setTime(o - 1);
    }, function(o, s) {
      if (o >= o)
        if (s < 0) for (; ++s <= 0; )
          for (; e(o, -1), !a(o); )
            ;
        else for (; --s >= 0; )
          for (; e(o, 1), !a(o); )
            ;
    });
  }, n && (i.count = function(a, o) {
    return Yn.setTime(+a), In.setTime(+o), t(Yn), t(In), Math.floor(n(Yn, In));
  }, i.every = function(a) {
    return a = Math.floor(a), !isFinite(a) || !(a > 0) ? null : a > 1 ? i.filter(r ? function(o) {
      return r(o) % a === 0;
    } : function(o) {
      return i.count(0, o) % a === 0;
    }) : i;
  }), i;
}
var pn = _t(function() {
}, function(t, e) {
  t.setTime(+t + e);
}, function(t, e) {
  return e - t;
});
pn.every = function(t) {
  return t = Math.floor(t), !isFinite(t) || !(t > 0) ? null : t > 1 ? _t(function(e) {
    e.setTime(Math.floor(e / t) * t);
  }, function(e, n) {
    e.setTime(+e + n * t);
  }, function(e, n) {
    return (n - e) / t;
  }) : pn;
};
pn.range;
const It = 1e3, At = It * 60, Kt = At * 60, re = Kt * 24, Cr = re * 7, ai = re * 30, Wn = re * 365;
var Vt = _t(function(t) {
  t.setTime(t - t.getMilliseconds());
}, function(t, e) {
  t.setTime(+t + e * It);
}, function(t, e) {
  return (e - t) / It;
}, function(t) {
  return t.getUTCSeconds();
});
Vt.range;
var We = _t(function(t) {
  t.setTime(t - t.getMilliseconds() - t.getSeconds() * It);
}, function(t, e) {
  t.setTime(+t + e * At);
}, function(t, e) {
  return (e - t) / At;
}, function(t) {
  return t.getMinutes();
});
We.range;
var Re = _t(function(t) {
  t.setTime(t - t.getMilliseconds() - t.getSeconds() * It - t.getMinutes() * At);
}, function(t, e) {
  t.setTime(+t + e * Kt);
}, function(t, e) {
  return (e - t) / Kt;
}, function(t) {
  return t.getHours();
});
Re.range;
var ae = _t(
  (t) => t.setHours(0, 0, 0, 0),
  (t, e) => t.setDate(t.getDate() + e),
  (t, e) => (e - t - (e.getTimezoneOffset() - t.getTimezoneOffset()) * At) / re,
  (t) => t.getDate() - 1
);
ae.range;
function oe(t) {
  return _t(function(e) {
    e.setDate(e.getDate() - (e.getDay() + 7 - t) % 7), e.setHours(0, 0, 0, 0);
  }, function(e, n) {
    e.setDate(e.getDate() + n * 7);
  }, function(e, n) {
    return (n - e - (n.getTimezoneOffset() - e.getTimezoneOffset()) * At) / Cr;
  });
}
var ze = oe(0), _n = oe(1), ul = oe(2), cl = oe(3), pe = oe(4), ll = oe(5), fl = oe(6);
ze.range;
_n.range;
ul.range;
cl.range;
pe.range;
ll.range;
fl.range;
var Cn = _t(function(t) {
  t.setDate(1), t.setHours(0, 0, 0, 0);
}, function(t, e) {
  t.setMonth(t.getMonth() + e);
}, function(t, e) {
  return e.getMonth() - t.getMonth() + (e.getFullYear() - t.getFullYear()) * 12;
}, function(t) {
  return t.getMonth();
});
Cn.range;
var kt = _t(function(t) {
  t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
}, function(t, e) {
  t.setFullYear(t.getFullYear() + e);
}, function(t, e) {
  return e.getFullYear() - t.getFullYear();
}, function(t) {
  return t.getFullYear();
});
kt.every = function(t) {
  return !isFinite(t = Math.floor(t)) || !(t > 0) ? null : _t(function(e) {
    e.setFullYear(Math.floor(e.getFullYear() / t) * t), e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
  }, function(e, n) {
    e.setFullYear(e.getFullYear() + n * t);
  });
};
kt.range;
var $r = _t(function(t) {
  t.setUTCHours(0, 0, 0, 0);
}, function(t, e) {
  t.setUTCDate(t.getUTCDate() + e);
}, function(t, e) {
  return (e - t) / re;
}, function(t) {
  return t.getUTCDate() - 1;
});
$r.range;
function se(t) {
  return _t(function(e) {
    e.setUTCDate(e.getUTCDate() - (e.getUTCDay() + 7 - t) % 7), e.setUTCHours(0, 0, 0, 0);
  }, function(e, n) {
    e.setUTCDate(e.getUTCDate() + n * 7);
  }, function(e, n) {
    return (n - e) / Cr;
  });
}
var ga = se(0), yn = se(1), hl = se(2), dl = se(3), _e = se(4), ml = se(5), gl = se(6);
ga.range;
yn.range;
hl.range;
dl.range;
_e.range;
ml.range;
gl.range;
var ie = _t(function(t) {
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
}, function(t, e) {
  t.setUTCFullYear(t.getUTCFullYear() + e);
}, function(t, e) {
  return e.getUTCFullYear() - t.getUTCFullYear();
}, function(t) {
  return t.getUTCFullYear();
});
ie.every = function(t) {
  return !isFinite(t = Math.floor(t)) || !(t > 0) ? null : _t(function(e) {
    e.setUTCFullYear(Math.floor(e.getUTCFullYear() / t) * t), e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
  }, function(e, n) {
    e.setUTCFullYear(e.getUTCFullYear() + n * t);
  });
};
ie.range;
function vl(t, e, n, r, i, a) {
  const o = [
    [Vt, 1, It],
    [Vt, 5, 5 * It],
    [Vt, 15, 15 * It],
    [Vt, 30, 30 * It],
    [a, 1, At],
    [a, 5, 5 * At],
    [a, 15, 15 * At],
    [a, 30, 30 * At],
    [i, 1, Kt],
    [i, 3, 3 * Kt],
    [i, 6, 6 * Kt],
    [i, 12, 12 * Kt],
    [r, 1, re],
    [r, 2, 2 * re],
    [n, 1, Cr],
    [e, 1, ai],
    [e, 3, 3 * ai],
    [t, 1, Wn]
  ];
  function s(u, l, d) {
    const h = l < u;
    h && ([u, l] = [l, u]);
    const g = d && typeof d.range == "function" ? d : c(u, l, d), S = g ? g.range(u, +l + 1) : [];
    return h ? S.reverse() : S;
  }
  function c(u, l, d) {
    const h = Math.abs(l - u) / d, g = vr(([, , $]) => $).right(o, h);
    if (g === o.length) return t.every(Gn(u / Wn, l / Wn, d));
    if (g === 0) return pn.every(Math.max(Gn(u, l, d), 1));
    const [S, k] = o[h / o[g - 1][2] < o[g][2] / h ? g - 1 : g];
    return S.every(k);
  }
  return [s, c];
}
const [pl, _l] = vl(kt, Cn, ze, ae, Re, We);
function Rn(t) {
  if (0 <= t.y && t.y < 100) {
    var e = new Date(-1, t.m, t.d, t.H, t.M, t.S, t.L);
    return e.setFullYear(t.y), e;
  }
  return new Date(t.y, t.m, t.d, t.H, t.M, t.S, t.L);
}
function zn(t) {
  if (0 <= t.y && t.y < 100) {
    var e = new Date(Date.UTC(-1, t.m, t.d, t.H, t.M, t.S, t.L));
    return e.setUTCFullYear(t.y), e;
  }
  return new Date(Date.UTC(t.y, t.m, t.d, t.H, t.M, t.S, t.L));
}
function xe(t, e, n) {
  return { y: t, m: e, d: n, H: 0, M: 0, S: 0, L: 0 };
}
function yl(t) {
  var e = t.dateTime, n = t.date, r = t.time, i = t.periods, a = t.days, o = t.shortDays, s = t.months, c = t.shortMonths, u = be(i), l = Me(i), d = be(a), h = Me(a), g = be(o), S = Me(o), k = be(s), $ = Me(s), b = be(c), F = Me(c), y = {
    a: U,
    A: L,
    b: z,
    B: H,
    c: null,
    d: fi,
    e: fi,
    f: Ll,
    g: Jl,
    G: tf,
    H: Wl,
    I: Rl,
    j: zl,
    L: va,
    m: Hl,
    M: Xl,
    p: T,
    q: A,
    Q: mi,
    s: gi,
    S: Vl,
    u: ql,
    U: Bl,
    V: Gl,
    w: Ql,
    W: Zl,
    x: null,
    X: null,
    y: Kl,
    Y: jl,
    Z: ef,
    "%": di
  }, f = {
    a: R,
    A: X,
    b: it,
    B: ut,
    c: null,
    d: hi,
    e: hi,
    f: of,
    g: vf,
    G: _f,
    H: nf,
    I: rf,
    j: af,
    L: _a,
    m: sf,
    M: uf,
    p: ct,
    q: lt,
    Q: mi,
    s: gi,
    S: cf,
    u: lf,
    U: ff,
    V: hf,
    w: df,
    W: mf,
    x: null,
    X: null,
    y: gf,
    Y: pf,
    Z: yf,
    "%": di
  }, _ = {
    a: Y,
    A: E,
    b: Q,
    B: J,
    c: v,
    d: ci,
    e: ci,
    f: Ol,
    g: ui,
    G: si,
    H: li,
    I: li,
    j: Al,
    L: Ul,
    m: El,
    M: Nl,
    p: N,
    q: $l,
    Q: Yl,
    s: Il,
    S: Pl,
    u: Tl,
    U: Sl,
    V: kl,
    w: Ml,
    W: Dl,
    x: O,
    X: x,
    y: ui,
    Y: si,
    Z: Cl,
    "%": Fl
  };
  y.x = m(n, y), y.X = m(r, y), y.c = m(e, y), f.x = m(n, f), f.X = m(r, f), f.c = m(e, f);
  function m(P, Z) {
    return function(K) {
      var D = [], mt = -1, M = 0, V = P.length, W, j, st;
      for (K instanceof Date || (K = /* @__PURE__ */ new Date(+K)); ++mt < V; )
        P.charCodeAt(mt) === 37 && (D.push(P.slice(M, mt)), (j = oi[W = P.charAt(++mt)]) != null ? W = P.charAt(++mt) : j = W === "e" ? " " : "0", (st = Z[W]) && (W = st(K, j)), D.push(W), M = mt + 1);
      return D.push(P.slice(M, mt)), D.join("");
    };
  }
  function p(P, Z) {
    return function(K) {
      var D = xe(1900, void 0, 1), mt = w(D, P, K += "", 0), M, V;
      if (mt != K.length) return null;
      if ("Q" in D) return new Date(D.Q);
      if ("s" in D) return new Date(D.s * 1e3 + ("L" in D ? D.L : 0));
      if (Z && !("Z" in D) && (D.Z = 0), "p" in D && (D.H = D.H % 12 + D.p * 12), D.m === void 0 && (D.m = "q" in D ? D.q : 0), "V" in D) {
        if (D.V < 1 || D.V > 53) return null;
        "w" in D || (D.w = 1), "Z" in D ? (M = zn(xe(D.y, 0, 1)), V = M.getUTCDay(), M = V > 4 || V === 0 ? yn.ceil(M) : yn(M), M = $r.offset(M, (D.V - 1) * 7), D.y = M.getUTCFullYear(), D.m = M.getUTCMonth(), D.d = M.getUTCDate() + (D.w + 6) % 7) : (M = Rn(xe(D.y, 0, 1)), V = M.getDay(), M = V > 4 || V === 0 ? _n.ceil(M) : _n(M), M = ae.offset(M, (D.V - 1) * 7), D.y = M.getFullYear(), D.m = M.getMonth(), D.d = M.getDate() + (D.w + 6) % 7);
      } else ("W" in D || "U" in D) && ("w" in D || (D.w = "u" in D ? D.u % 7 : "W" in D ? 1 : 0), V = "Z" in D ? zn(xe(D.y, 0, 1)).getUTCDay() : Rn(xe(D.y, 0, 1)).getDay(), D.m = 0, D.d = "W" in D ? (D.w + 6) % 7 + D.W * 7 - (V + 5) % 7 : D.w + D.U * 7 - (V + 6) % 7);
      return "Z" in D ? (D.H += D.Z / 100 | 0, D.M += D.Z % 100, zn(D)) : Rn(D);
    };
  }
  function w(P, Z, K, D) {
    for (var mt = 0, M = Z.length, V = K.length, W, j; mt < M; ) {
      if (D >= V) return -1;
      if (W = Z.charCodeAt(mt++), W === 37) {
        if (W = Z.charAt(mt++), j = _[W in oi ? Z.charAt(mt++) : W], !j || (D = j(P, K, D)) < 0) return -1;
      } else if (W != K.charCodeAt(D++))
        return -1;
    }
    return D;
  }
  function N(P, Z, K) {
    var D = u.exec(Z.slice(K));
    return D ? (P.p = l.get(D[0].toLowerCase()), K + D[0].length) : -1;
  }
  function Y(P, Z, K) {
    var D = g.exec(Z.slice(K));
    return D ? (P.w = S.get(D[0].toLowerCase()), K + D[0].length) : -1;
  }
  function E(P, Z, K) {
    var D = d.exec(Z.slice(K));
    return D ? (P.w = h.get(D[0].toLowerCase()), K + D[0].length) : -1;
  }
  function Q(P, Z, K) {
    var D = b.exec(Z.slice(K));
    return D ? (P.m = F.get(D[0].toLowerCase()), K + D[0].length) : -1;
  }
  function J(P, Z, K) {
    var D = k.exec(Z.slice(K));
    return D ? (P.m = $.get(D[0].toLowerCase()), K + D[0].length) : -1;
  }
  function v(P, Z, K) {
    return w(P, e, Z, K);
  }
  function O(P, Z, K) {
    return w(P, n, Z, K);
  }
  function x(P, Z, K) {
    return w(P, r, Z, K);
  }
  function U(P) {
    return o[P.getDay()];
  }
  function L(P) {
    return a[P.getDay()];
  }
  function z(P) {
    return c[P.getMonth()];
  }
  function H(P) {
    return s[P.getMonth()];
  }
  function T(P) {
    return i[+(P.getHours() >= 12)];
  }
  function A(P) {
    return 1 + ~~(P.getMonth() / 3);
  }
  function R(P) {
    return o[P.getUTCDay()];
  }
  function X(P) {
    return a[P.getUTCDay()];
  }
  function it(P) {
    return c[P.getUTCMonth()];
  }
  function ut(P) {
    return s[P.getUTCMonth()];
  }
  function ct(P) {
    return i[+(P.getUTCHours() >= 12)];
  }
  function lt(P) {
    return 1 + ~~(P.getUTCMonth() / 3);
  }
  return {
    format: function(P) {
      var Z = m(P += "", y);
      return Z.toString = function() {
        return P;
      }, Z;
    },
    parse: function(P) {
      var Z = p(P += "", !1);
      return Z.toString = function() {
        return P;
      }, Z;
    },
    utcFormat: function(P) {
      var Z = m(P += "", f);
      return Z.toString = function() {
        return P;
      }, Z;
    },
    utcParse: function(P) {
      var Z = p(P += "", !0);
      return Z.toString = function() {
        return P;
      }, Z;
    }
  };
}
var oi = { "-": "", _: " ", 0: "0" }, ht = /^\s*\d+/, wl = /^%/, xl = /[\\^$*+?|[\]().{}]/g;
function tt(t, e, n) {
  var r = t < 0 ? "-" : "", i = (r ? -t : t) + "", a = i.length;
  return r + (a < n ? new Array(n - a + 1).join(e) + i : i);
}
function bl(t) {
  return t.replace(xl, "\\$&");
}
function be(t) {
  return new RegExp("^(?:" + t.map(bl).join("|") + ")", "i");
}
function Me(t) {
  return new Map(t.map((e, n) => [e.toLowerCase(), n]));
}
function Ml(t, e, n) {
  var r = ht.exec(e.slice(n, n + 1));
  return r ? (t.w = +r[0], n + r[0].length) : -1;
}
function Tl(t, e, n) {
  var r = ht.exec(e.slice(n, n + 1));
  return r ? (t.u = +r[0], n + r[0].length) : -1;
}
function Sl(t, e, n) {
  var r = ht.exec(e.slice(n, n + 2));
  return r ? (t.U = +r[0], n + r[0].length) : -1;
}
function kl(t, e, n) {
  var r = ht.exec(e.slice(n, n + 2));
  return r ? (t.V = +r[0], n + r[0].length) : -1;
}
function Dl(t, e, n) {
  var r = ht.exec(e.slice(n, n + 2));
  return r ? (t.W = +r[0], n + r[0].length) : -1;
}
function si(t, e, n) {
  var r = ht.exec(e.slice(n, n + 4));
  return r ? (t.y = +r[0], n + r[0].length) : -1;
}
function ui(t, e, n) {
  var r = ht.exec(e.slice(n, n + 2));
  return r ? (t.y = +r[0] + (+r[0] > 68 ? 1900 : 2e3), n + r[0].length) : -1;
}
function Cl(t, e, n) {
  var r = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(e.slice(n, n + 6));
  return r ? (t.Z = r[1] ? 0 : -(r[2] + (r[3] || "00")), n + r[0].length) : -1;
}
function $l(t, e, n) {
  var r = ht.exec(e.slice(n, n + 1));
  return r ? (t.q = r[0] * 3 - 3, n + r[0].length) : -1;
}
function El(t, e, n) {
  var r = ht.exec(e.slice(n, n + 2));
  return r ? (t.m = r[0] - 1, n + r[0].length) : -1;
}
function ci(t, e, n) {
  var r = ht.exec(e.slice(n, n + 2));
  return r ? (t.d = +r[0], n + r[0].length) : -1;
}
function Al(t, e, n) {
  var r = ht.exec(e.slice(n, n + 3));
  return r ? (t.m = 0, t.d = +r[0], n + r[0].length) : -1;
}
function li(t, e, n) {
  var r = ht.exec(e.slice(n, n + 2));
  return r ? (t.H = +r[0], n + r[0].length) : -1;
}
function Nl(t, e, n) {
  var r = ht.exec(e.slice(n, n + 2));
  return r ? (t.M = +r[0], n + r[0].length) : -1;
}
function Pl(t, e, n) {
  var r = ht.exec(e.slice(n, n + 2));
  return r ? (t.S = +r[0], n + r[0].length) : -1;
}
function Ul(t, e, n) {
  var r = ht.exec(e.slice(n, n + 3));
  return r ? (t.L = +r[0], n + r[0].length) : -1;
}
function Ol(t, e, n) {
  var r = ht.exec(e.slice(n, n + 6));
  return r ? (t.L = Math.floor(r[0] / 1e3), n + r[0].length) : -1;
}
function Fl(t, e, n) {
  var r = wl.exec(e.slice(n, n + 1));
  return r ? n + r[0].length : -1;
}
function Yl(t, e, n) {
  var r = ht.exec(e.slice(n));
  return r ? (t.Q = +r[0], n + r[0].length) : -1;
}
function Il(t, e, n) {
  var r = ht.exec(e.slice(n));
  return r ? (t.s = +r[0], n + r[0].length) : -1;
}
function fi(t, e) {
  return tt(t.getDate(), e, 2);
}
function Wl(t, e) {
  return tt(t.getHours(), e, 2);
}
function Rl(t, e) {
  return tt(t.getHours() % 12 || 12, e, 2);
}
function zl(t, e) {
  return tt(1 + ae.count(kt(t), t), e, 3);
}
function va(t, e) {
  return tt(t.getMilliseconds(), e, 3);
}
function Ll(t, e) {
  return va(t, e) + "000";
}
function Hl(t, e) {
  return tt(t.getMonth() + 1, e, 2);
}
function Xl(t, e) {
  return tt(t.getMinutes(), e, 2);
}
function Vl(t, e) {
  return tt(t.getSeconds(), e, 2);
}
function ql(t) {
  var e = t.getDay();
  return e === 0 ? 7 : e;
}
function Bl(t, e) {
  return tt(ze.count(kt(t) - 1, t), e, 2);
}
function pa(t) {
  var e = t.getDay();
  return e >= 4 || e === 0 ? pe(t) : pe.ceil(t);
}
function Gl(t, e) {
  return t = pa(t), tt(pe.count(kt(t), t) + (kt(t).getDay() === 4), e, 2);
}
function Ql(t) {
  return t.getDay();
}
function Zl(t, e) {
  return tt(_n.count(kt(t) - 1, t), e, 2);
}
function Kl(t, e) {
  return tt(t.getFullYear() % 100, e, 2);
}
function Jl(t, e) {
  return t = pa(t), tt(t.getFullYear() % 100, e, 2);
}
function jl(t, e) {
  return tt(t.getFullYear() % 1e4, e, 4);
}
function tf(t, e) {
  var n = t.getDay();
  return t = n >= 4 || n === 0 ? pe(t) : pe.ceil(t), tt(t.getFullYear() % 1e4, e, 4);
}
function ef(t) {
  var e = t.getTimezoneOffset();
  return (e > 0 ? "-" : (e *= -1, "+")) + tt(e / 60 | 0, "0", 2) + tt(e % 60, "0", 2);
}
function hi(t, e) {
  return tt(t.getUTCDate(), e, 2);
}
function nf(t, e) {
  return tt(t.getUTCHours(), e, 2);
}
function rf(t, e) {
  return tt(t.getUTCHours() % 12 || 12, e, 2);
}
function af(t, e) {
  return tt(1 + $r.count(ie(t), t), e, 3);
}
function _a(t, e) {
  return tt(t.getUTCMilliseconds(), e, 3);
}
function of(t, e) {
  return _a(t, e) + "000";
}
function sf(t, e) {
  return tt(t.getUTCMonth() + 1, e, 2);
}
function uf(t, e) {
  return tt(t.getUTCMinutes(), e, 2);
}
function cf(t, e) {
  return tt(t.getUTCSeconds(), e, 2);
}
function lf(t) {
  var e = t.getUTCDay();
  return e === 0 ? 7 : e;
}
function ff(t, e) {
  return tt(ga.count(ie(t) - 1, t), e, 2);
}
function ya(t) {
  var e = t.getUTCDay();
  return e >= 4 || e === 0 ? _e(t) : _e.ceil(t);
}
function hf(t, e) {
  return t = ya(t), tt(_e.count(ie(t), t) + (ie(t).getUTCDay() === 4), e, 2);
}
function df(t) {
  return t.getUTCDay();
}
function mf(t, e) {
  return tt(yn.count(ie(t) - 1, t), e, 2);
}
function gf(t, e) {
  return tt(t.getUTCFullYear() % 100, e, 2);
}
function vf(t, e) {
  return t = ya(t), tt(t.getUTCFullYear() % 100, e, 2);
}
function pf(t, e) {
  return tt(t.getUTCFullYear() % 1e4, e, 4);
}
function _f(t, e) {
  var n = t.getUTCDay();
  return t = n >= 4 || n === 0 ? _e(t) : _e.ceil(t), tt(t.getUTCFullYear() % 1e4, e, 4);
}
function yf() {
  return "+0000";
}
function di() {
  return "%";
}
function mi(t) {
  return +t;
}
function gi(t) {
  return Math.floor(+t / 1e3);
}
var ue, Ot;
wf({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function wf(t) {
  return ue = yl(t), Ot = ue.format, ue.parse, ue.utcFormat, ue.utcParse, ue;
}
function xf(t) {
  return new Date(t);
}
function bf(t) {
  return t instanceof Date ? +t : +/* @__PURE__ */ new Date(+t);
}
function wa(t, e, n, r, i, a, o, s, c, u) {
  var l = ma(), d = l.invert, h = l.domain, g = u(".%L"), S = u(":%S"), k = u("%I:%M"), $ = u("%I %p"), b = u("%a %d"), F = u("%b %d"), y = u("%B"), f = u("%Y");
  function _(m) {
    return (c(m) < m ? g : s(m) < m ? S : o(m) < m ? k : a(m) < m ? $ : r(m) < m ? i(m) < m ? b : F : n(m) < m ? y : f)(m);
  }
  return l.invert = function(m) {
    return new Date(d(m));
  }, l.domain = function(m) {
    return arguments.length ? h(Array.from(m, bf)) : h().map(xf);
  }, l.ticks = function(m) {
    var p = h();
    return t(p[0], p[p.length - 1], m ?? 10);
  }, l.tickFormat = function(m, p) {
    return p == null ? _ : u(p);
  }, l.nice = function(m) {
    var p = h();
    return (!m || typeof m.range != "function") && (m = e(p[0], p[p.length - 1], m ?? 10)), m ? h(sl(p, m)) : l;
  }, l.copy = function() {
    return da(l, wa(t, e, n, r, i, a, o, s, c, u));
  }, l;
}
function wt() {
  return ha.apply(wa(pl, _l, kt, Cn, ze, ae, Re, We, Vt, Ot).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function $t(t) {
  return function() {
    return t;
  };
}
const vi = 1e-12;
function xa(t) {
  return typeof t == "object" && "length" in t ? t : Array.from(t);
}
function ba(t) {
  this._context = t;
}
ba.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
        break;
      case 1:
        this._point = 2;
      default:
        this._context.lineTo(t, e);
        break;
    }
  }
};
function Mf(t) {
  return new ba(t);
}
function Tf(t) {
  return t[0];
}
function Sf(t) {
  return t[1];
}
function Ma(t, e) {
  var n = $t(!0), r = null, i = Mf, a = null;
  t = typeof t == "function" ? t : t === void 0 ? Tf : $t(t), e = typeof e == "function" ? e : e === void 0 ? Sf : $t(e);
  function o(s) {
    var c, u = (s = xa(s)).length, l, d = !1, h;
    for (r == null && (a = i(h = ca())), c = 0; c <= u; ++c)
      !(c < u && n(l = s[c], c, s)) === d && ((d = !d) ? a.lineStart() : a.lineEnd()), d && a.point(+t(l, c, s), +e(l, c, s));
    if (h) return a = null, h + "" || null;
  }
  return o.x = function(s) {
    return arguments.length ? (t = typeof s == "function" ? s : $t(+s), o) : t;
  }, o.y = function(s) {
    return arguments.length ? (e = typeof s == "function" ? s : $t(+s), o) : e;
  }, o.defined = function(s) {
    return arguments.length ? (n = typeof s == "function" ? s : $t(!!s), o) : n;
  }, o.curve = function(s) {
    return arguments.length ? (i = s, r != null && (a = i(r)), o) : i;
  }, o.context = function(s) {
    return arguments.length ? (s == null ? r = a = null : a = i(r = s), o) : r;
  }, o;
}
class Ta {
  constructor(e, n) {
    this._context = e, this._x = n;
  }
  areaStart() {
    this._line = 0;
  }
  areaEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  }
  point(e, n) {
    switch (e = +e, n = +n, this._point) {
      case 0: {
        this._point = 1, this._line ? this._context.lineTo(e, n) : this._context.moveTo(e, n);
        break;
      }
      case 1:
        this._point = 2;
      default: {
        this._x ? this._context.bezierCurveTo(this._x0 = (this._x0 + e) / 2, this._y0, this._x0, n, e, n) : this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + n) / 2, e, this._y0, e, n);
        break;
      }
    }
    this._x0 = e, this._y0 = n;
  }
}
function Sa(t) {
  return new Ta(t, !0);
}
function kf(t) {
  return new Ta(t, !1);
}
function pi(t, e, n) {
  t._context.bezierCurveTo(
    t._x1 + t._k * (t._x2 - t._x0),
    t._y1 + t._k * (t._y2 - t._y0),
    t._x2 + t._k * (t._x1 - e),
    t._y2 + t._k * (t._y1 - n),
    t._x2,
    t._y2
  );
}
function Er(t, e) {
  this._context = t, this._k = (1 - e) / 6;
}
Er.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        pi(this, this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
        break;
      case 1:
        this._point = 2, this._x1 = t, this._y1 = e;
        break;
      case 2:
        this._point = 3;
      default:
        pi(this, t, e);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
  }
};
const Df = function t(e) {
  function n(r) {
    return new Er(r, e);
  }
  return n.tension = function(r) {
    return t(+r);
  }, n;
}(0);
function Cf(t, e, n) {
  var r = t._x1, i = t._y1, a = t._x2, o = t._y2;
  if (t._l01_a > vi) {
    var s = 2 * t._l01_2a + 3 * t._l01_a * t._l12_a + t._l12_2a, c = 3 * t._l01_a * (t._l01_a + t._l12_a);
    r = (r * s - t._x0 * t._l12_2a + t._x2 * t._l01_2a) / c, i = (i * s - t._y0 * t._l12_2a + t._y2 * t._l01_2a) / c;
  }
  if (t._l23_a > vi) {
    var u = 2 * t._l23_2a + 3 * t._l23_a * t._l12_a + t._l12_2a, l = 3 * t._l23_a * (t._l23_a + t._l12_a);
    a = (a * u + t._x1 * t._l23_2a - e * t._l12_2a) / l, o = (o * u + t._y1 * t._l23_2a - n * t._l12_2a) / l;
  }
  t._context.bezierCurveTo(r, i, a, o, t._x2, t._y2);
}
function ka(t, e) {
  this._context = t, this._alpha = e;
}
ka.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        this.point(this._x2, this._y2);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    if (t = +t, e = +e, this._point) {
      var n = this._x2 - t, r = this._y2 - e;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
      default:
        Cf(this, t, e);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
  }
};
const $f = function t(e) {
  function n(r) {
    return e ? new ka(r, e) : new Er(r, 0);
  }
  return n.alpha = function(r) {
    return t(+r);
  }, n;
}(0.5);
function _i(t, e) {
  if ((o = t.length) > 1)
    for (var n = 1, r, i, a = t[e[0]], o, s = a.length; n < o; ++n)
      for (i = a, a = t[e[n]], r = 0; r < s; ++r)
        a[r][1] += a[r][0] = isNaN(i[r][1]) ? i[r][0] : i[r][1];
}
function ur(t) {
  for (var e = t.length, n = new Array(e); --e >= 0; ) n[e] = e;
  return n;
}
function Ef(t, e) {
  return t[e];
}
function Af(t) {
  const e = [];
  return e.key = t, e;
}
function Nf() {
  var t = $t([]), e = ur, n = _i, r = Ef;
  function i(a) {
    var o = Array.from(t.apply(this, arguments), Af), s, c = o.length, u = -1, l;
    for (const d of a)
      for (s = 0, ++u; s < c; ++s)
        (o[s][u] = [0, +r(d, o[s].key, u, a)]).data = d;
    for (s = 0, l = xa(e(o)); s < c; ++s)
      o[l[s]].index = s;
    return n(o, l), o;
  }
  return i.keys = function(a) {
    return arguments.length ? (t = typeof a == "function" ? a : $t(Array.from(a)), i) : t;
  }, i.value = function(a) {
    return arguments.length ? (r = typeof a == "function" ? a : $t(+a), i) : r;
  }, i.order = function(a) {
    return arguments.length ? (e = a == null ? ur : typeof a == "function" ? a : $t(Array.from(a)), i) : e;
  }, i.offset = function(a) {
    return arguments.length ? (n = a ?? _i, i) : n;
  }, i;
}
function Pf(t, e) {
  if ((c = t.length) > 0)
    for (var n, r = 0, i, a, o, s, c, u = t[e[0]].length; r < u; ++r)
      for (o = s = 0, n = 0; n < c; ++n)
        (a = (i = t[e[n]][r])[1] - i[0]) > 0 ? (i[0] = o, i[1] = o += a) : a < 0 ? (i[1] = s, i[0] = s += a) : (i[0] = 0, i[1] = a);
}
const Be = (t) => () => t;
function Uf(t, {
  sourceEvent: e,
  target: n,
  transform: r,
  dispatch: i
}) {
  Object.defineProperties(this, {
    type: { value: t, enumerable: !0, configurable: !0 },
    sourceEvent: { value: e, enumerable: !0, configurable: !0 },
    target: { value: n, enumerable: !0, configurable: !0 },
    transform: { value: r, enumerable: !0, configurable: !0 },
    _: { value: i }
  });
}
function Wt(t, e, n) {
  this.k = t, this.x = e, this.y = n;
}
Wt.prototype = {
  constructor: Wt,
  scale: function(t) {
    return t === 1 ? this : new Wt(this.k * t, this.x, this.y);
  },
  translate: function(t, e) {
    return t === 0 & e === 0 ? this : new Wt(this.k, this.x + this.k * t, this.y + this.k * e);
  },
  apply: function(t) {
    return [t[0] * this.k + this.x, t[1] * this.k + this.y];
  },
  applyX: function(t) {
    return t * this.k + this.x;
  },
  applyY: function(t) {
    return t * this.k + this.y;
  },
  invert: function(t) {
    return [(t[0] - this.x) / this.k, (t[1] - this.y) / this.k];
  },
  invertX: function(t) {
    return (t - this.x) / this.k;
  },
  invertY: function(t) {
    return (t - this.y) / this.k;
  },
  rescaleX: function(t) {
    return t.copy().domain(t.range().map(this.invertX, this).map(t.invert, t));
  },
  rescaleY: function(t) {
    return t.copy().domain(t.range().map(this.invertY, this).map(t.invert, t));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};
var Ar = new Wt(1, 0, 0);
Wt.prototype;
function Ln(t) {
  t.stopImmediatePropagation();
}
function Te(t) {
  t.preventDefault(), t.stopImmediatePropagation();
}
function Of(t) {
  return (!t.ctrlKey || t.type === "wheel") && !t.button;
}
function Ff() {
  var t = this;
  return t instanceof SVGElement ? (t = t.ownerSVGElement || t, t.hasAttribute("viewBox") ? (t = t.viewBox.baseVal, [[t.x, t.y], [t.x + t.width, t.y + t.height]]) : [[0, 0], [t.width.baseVal.value, t.height.baseVal.value]]) : [[0, 0], [t.clientWidth, t.clientHeight]];
}
function yi() {
  return this.__zoom || Ar;
}
function Yf(t) {
  return -t.deltaY * (t.deltaMode === 1 ? 0.05 : t.deltaMode ? 1 : 2e-3) * (t.ctrlKey ? 10 : 1);
}
function If() {
  return navigator.maxTouchPoints || "ontouchstart" in this;
}
function Wf(t, e, n) {
  var r = t.invertX(e[0][0]) - n[0][0], i = t.invertX(e[1][0]) - n[1][0], a = t.invertY(e[0][1]) - n[0][1], o = t.invertY(e[1][1]) - n[1][1];
  return t.translate(
    i > r ? (r + i) / 2 : Math.min(0, r) || Math.max(0, i),
    o > a ? (a + o) / 2 : Math.min(0, a) || Math.max(0, o)
  );
}
function Rf() {
  var t = Of, e = Ff, n = Wf, r = Yf, i = If, a = [0, 1 / 0], o = [[-1 / 0, -1 / 0], [1 / 0, 1 / 0]], s = 250, c = $u, u = Tn("start", "zoom", "end"), l, d, h, g = 500, S = 150, k = 0, $ = 10;
  function b(v) {
    v.property("__zoom", yi).on("wheel.zoom", w, { passive: !1 }).on("mousedown.zoom", N).on("dblclick.zoom", Y).filter(i).on("touchstart.zoom", E).on("touchmove.zoom", Q).on("touchend.zoom touchcancel.zoom", J).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  b.transform = function(v, O, x, U) {
    var L = v.selection ? v.selection() : v;
    L.property("__zoom", yi), v !== L ? _(v, O, x, U) : L.interrupt().each(function() {
      m(this, arguments).event(U).start().zoom(null, typeof O == "function" ? O.apply(this, arguments) : O).end();
    });
  }, b.scaleBy = function(v, O, x, U) {
    b.scaleTo(v, function() {
      var L = this.__zoom.k, z = typeof O == "function" ? O.apply(this, arguments) : O;
      return L * z;
    }, x, U);
  }, b.scaleTo = function(v, O, x, U) {
    b.transform(v, function() {
      var L = e.apply(this, arguments), z = this.__zoom, H = x == null ? f(L) : typeof x == "function" ? x.apply(this, arguments) : x, T = z.invert(H), A = typeof O == "function" ? O.apply(this, arguments) : O;
      return n(y(F(z, A), H, T), L, o);
    }, x, U);
  }, b.translateBy = function(v, O, x, U) {
    b.transform(v, function() {
      return n(this.__zoom.translate(
        typeof O == "function" ? O.apply(this, arguments) : O,
        typeof x == "function" ? x.apply(this, arguments) : x
      ), e.apply(this, arguments), o);
    }, null, U);
  }, b.translateTo = function(v, O, x, U, L) {
    b.transform(v, function() {
      var z = e.apply(this, arguments), H = this.__zoom, T = U == null ? f(z) : typeof U == "function" ? U.apply(this, arguments) : U;
      return n(Ar.translate(T[0], T[1]).scale(H.k).translate(
        typeof O == "function" ? -O.apply(this, arguments) : -O,
        typeof x == "function" ? -x.apply(this, arguments) : -x
      ), z, o);
    }, U, L);
  };
  function F(v, O) {
    return O = Math.max(a[0], Math.min(a[1], O)), O === v.k ? v : new Wt(O, v.x, v.y);
  }
  function y(v, O, x) {
    var U = O[0] - x[0] * v.k, L = O[1] - x[1] * v.k;
    return U === v.x && L === v.y ? v : new Wt(v.k, U, L);
  }
  function f(v) {
    return [(+v[0][0] + +v[1][0]) / 2, (+v[0][1] + +v[1][1]) / 2];
  }
  function _(v, O, x, U) {
    v.on("start.zoom", function() {
      m(this, arguments).event(U).start();
    }).on("interrupt.zoom end.zoom", function() {
      m(this, arguments).event(U).end();
    }).tween("zoom", function() {
      var L = this, z = arguments, H = m(L, z).event(U), T = e.apply(L, z), A = x == null ? f(T) : typeof x == "function" ? x.apply(L, z) : x, R = Math.max(T[1][0] - T[0][0], T[1][1] - T[0][1]), X = L.__zoom, it = typeof O == "function" ? O.apply(L, z) : O, ut = c(X.invert(A).concat(R / X.k), it.invert(A).concat(R / it.k));
      return function(ct) {
        if (ct === 1) ct = it;
        else {
          var lt = ut(ct), P = R / lt[2];
          ct = new Wt(P, A[0] - lt[0] * P, A[1] - lt[1] * P);
        }
        H.zoom(null, ct);
      };
    });
  }
  function m(v, O, x) {
    return !x && v.__zooming || new p(v, O);
  }
  function p(v, O) {
    this.that = v, this.args = O, this.active = 0, this.sourceEvent = null, this.extent = e.apply(v, O), this.taps = 0;
  }
  p.prototype = {
    event: function(v) {
      return v && (this.sourceEvent = v), this;
    },
    start: function() {
      return ++this.active === 1 && (this.that.__zooming = this, this.emit("start")), this;
    },
    zoom: function(v, O) {
      return this.mouse && v !== "mouse" && (this.mouse[1] = O.invert(this.mouse[0])), this.touch0 && v !== "touch" && (this.touch0[1] = O.invert(this.touch0[0])), this.touch1 && v !== "touch" && (this.touch1[1] = O.invert(this.touch1[0])), this.that.__zoom = O, this.emit("zoom"), this;
    },
    end: function() {
      return --this.active === 0 && (delete this.that.__zooming, this.emit("end")), this;
    },
    emit: function(v) {
      var O = at(this.that).datum();
      u.call(
        v,
        this.that,
        new Uf(v, {
          sourceEvent: this.sourceEvent,
          target: b,
          type: v,
          transform: this.that.__zoom,
          dispatch: u
        }),
        O
      );
    }
  };
  function w(v, ...O) {
    if (!t.apply(this, arguments)) return;
    var x = m(this, O).event(v), U = this.__zoom, L = Math.max(a[0], Math.min(a[1], U.k * Math.pow(2, r.apply(this, arguments)))), z = vt(v);
    if (x.wheel)
      (x.mouse[0][0] !== z[0] || x.mouse[0][1] !== z[1]) && (x.mouse[1] = U.invert(x.mouse[0] = z)), clearTimeout(x.wheel);
    else {
      if (U.k === L) return;
      x.mouse = [z, U.invert(z)], rn(this), x.start();
    }
    Te(v), x.wheel = setTimeout(H, S), x.zoom("mouse", n(y(F(U, L), x.mouse[0], x.mouse[1]), x.extent, o));
    function H() {
      x.wheel = null, x.end();
    }
  }
  function N(v, ...O) {
    if (h || !t.apply(this, arguments)) return;
    var x = v.currentTarget, U = m(this, O, !0).event(v), L = at(v.view).on("mousemove.zoom", A, !0).on("mouseup.zoom", R, !0), z = vt(v, x), H = v.clientX, T = v.clientY;
    Gi(v.view), Ln(v), U.mouse = [z, this.__zoom.invert(z)], rn(this), U.start();
    function A(X) {
      if (Te(X), !U.moved) {
        var it = X.clientX - H, ut = X.clientY - T;
        U.moved = it * it + ut * ut > k;
      }
      U.event(X).zoom("mouse", n(y(U.that.__zoom, U.mouse[0] = vt(X, x), U.mouse[1]), U.extent, o));
    }
    function R(X) {
      L.on("mousemove.zoom mouseup.zoom", null), Qi(X.view, U.moved), Te(X), U.event(X).end();
    }
  }
  function Y(v, ...O) {
    if (t.apply(this, arguments)) {
      var x = this.__zoom, U = vt(v.changedTouches ? v.changedTouches[0] : v, this), L = x.invert(U), z = x.k * (v.shiftKey ? 0.5 : 2), H = n(y(F(x, z), U, L), e.apply(this, O), o);
      Te(v), s > 0 ? at(this).transition().duration(s).call(_, H, U, v) : at(this).call(b.transform, H, U, v);
    }
  }
  function E(v, ...O) {
    if (t.apply(this, arguments)) {
      var x = v.touches, U = x.length, L = m(this, O, v.changedTouches.length === U).event(v), z, H, T, A;
      for (Ln(v), H = 0; H < U; ++H)
        T = x[H], A = vt(T, this), A = [A, this.__zoom.invert(A), T.identifier], L.touch0 ? !L.touch1 && L.touch0[2] !== A[2] && (L.touch1 = A, L.taps = 0) : (L.touch0 = A, z = !0, L.taps = 1 + !!l);
      l && (l = clearTimeout(l)), z && (L.taps < 2 && (d = A[0], l = setTimeout(function() {
        l = null;
      }, g)), rn(this), L.start());
    }
  }
  function Q(v, ...O) {
    if (this.__zooming) {
      var x = m(this, O).event(v), U = v.changedTouches, L = U.length, z, H, T, A;
      for (Te(v), z = 0; z < L; ++z)
        H = U[z], T = vt(H, this), x.touch0 && x.touch0[2] === H.identifier ? x.touch0[0] = T : x.touch1 && x.touch1[2] === H.identifier && (x.touch1[0] = T);
      if (H = x.that.__zoom, x.touch1) {
        var R = x.touch0[0], X = x.touch0[1], it = x.touch1[0], ut = x.touch1[1], ct = (ct = it[0] - R[0]) * ct + (ct = it[1] - R[1]) * ct, lt = (lt = ut[0] - X[0]) * lt + (lt = ut[1] - X[1]) * lt;
        H = F(H, Math.sqrt(ct / lt)), T = [(R[0] + it[0]) / 2, (R[1] + it[1]) / 2], A = [(X[0] + ut[0]) / 2, (X[1] + ut[1]) / 2];
      } else if (x.touch0) T = x.touch0[0], A = x.touch0[1];
      else return;
      x.zoom("touch", n(y(H, T, A), x.extent, o));
    }
  }
  function J(v, ...O) {
    if (this.__zooming) {
      var x = m(this, O).event(v), U = v.changedTouches, L = U.length, z, H;
      for (Ln(v), h && clearTimeout(h), h = setTimeout(function() {
        h = null;
      }, g), z = 0; z < L; ++z)
        H = U[z], x.touch0 && x.touch0[2] === H.identifier ? delete x.touch0 : x.touch1 && x.touch1[2] === H.identifier && delete x.touch1;
      if (x.touch1 && !x.touch0 && (x.touch0 = x.touch1, delete x.touch1), x.touch0) x.touch0[1] = this.__zoom.invert(x.touch0[0]);
      else if (x.end(), x.taps === 2 && (H = vt(H, this), Math.hypot(d[0] - H[0], d[1] - H[1]) < $)) {
        var T = at(this).on("dblclick.zoom");
        T && T.apply(this, arguments);
      }
    }
  }
  return b.wheelDelta = function(v) {
    return arguments.length ? (r = typeof v == "function" ? v : Be(+v), b) : r;
  }, b.filter = function(v) {
    return arguments.length ? (t = typeof v == "function" ? v : Be(!!v), b) : t;
  }, b.touchable = function(v) {
    return arguments.length ? (i = typeof v == "function" ? v : Be(!!v), b) : i;
  }, b.extent = function(v) {
    return arguments.length ? (e = typeof v == "function" ? v : Be([[+v[0][0], +v[0][1]], [+v[1][0], +v[1][1]]]), b) : e;
  }, b.scaleExtent = function(v) {
    return arguments.length ? (a[0] = +v[0], a[1] = +v[1], b) : [a[0], a[1]];
  }, b.translateExtent = function(v) {
    return arguments.length ? (o[0][0] = +v[0][0], o[1][0] = +v[1][0], o[0][1] = +v[0][1], o[1][1] = +v[1][1], b) : [[o[0][0], o[0][1]], [o[1][0], o[1][1]]];
  }, b.constrain = function(v) {
    return arguments.length ? (n = v, b) : n;
  }, b.duration = function(v) {
    return arguments.length ? (s = +v, b) : s;
  }, b.interpolate = function(v) {
    return arguments.length ? (c = v, b) : c;
  }, b.on = function() {
    var v = u.on.apply(u, arguments);
    return v === u ? b : v;
  }, b.clickDistance = function(v) {
    return arguments.length ? (k = (v = +v) * v, b) : Math.sqrt(k);
  }, b.tapDistance = function(v) {
    return arguments.length ? ($ = +v, b) : $;
  }, b;
}
function wn() {
  return crypto ? crypto.randomUUID ? crypto.randomUUID() : zf() : Lf();
}
function zf() {
  return (+[1e7] + -1e3 + -4e3 + -8e3 + -1e11).toString().replace(
    /[018]/g,
    (t) => (+t ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +t / 4).toString(16)
  );
}
function Lf() {
  const t = wi(), e = wi();
  return `${t.slice(0, 8)}-${t.slice(8, 12)}-4${t.slice(13)}-a${e.slice(1, 4)}-${e.slice(4)}`;
}
function wi() {
  return `00000000000000000${(Math.random() * 18446744073709552e3).toString(16)}`.slice(-16);
}
const Hf = () => `chart-${wn()}`;
class Xf {
  constructor(e, n) {
    Bt(this, "id", Hf());
    Bt(this, "height", G(0));
    Bt(this, "width", G(0));
    Bt(this, "padding", {
      top: 0,
      bottom: 0,
      middle: 0,
      left: 0,
      right: 0
    });
    Bt(this, "container");
    Bt(this, "resizeObserver");
    this.container = e, n != null && n.onResize && (this.onResize = n.onResize), n != null && n.padding && (this.padding = { ...this.padding, ...n.padding });
  }
  get paddingY() {
    return this.padding.top + this.padding.middle + this.padding.bottom;
  }
  get paddingX() {
    return this.padding.left + this.padding.right;
  }
  initializeChart() {
    this.container.value && (this.resizeObserver = new ResizeObserver(this._onResize.bind(this)), this.resizeObserver.observe(this.container.value), this._onResize());
  }
  teardown() {
    this.resizeObserver && this.resizeObserver.disconnect();
  }
  onResize() {
  }
  _onResize() {
    this.container.value && (this.height.value = this.container.value.offsetHeight, this.width.value = this.container.value.offsetWidth, this.onResize());
  }
}
const $n = (t, e) => {
  const n = new Xf(t, e);
  return qt(() => {
    requestAnimationFrame(() => {
      n.initializeChart();
    });
  }), Ai(() => {
    n.teardown();
  }), n;
}, Vf = ["id"], qf = { class: "bar-chart__bucket-container" }, Bf = {
  key: 1,
  class: "bar-chart__bucket",
  tabindex: "0"
}, Gf = {
  key: 1,
  class: "bar-chart__axis"
}, Qf = /* @__PURE__ */ I("div", { class: "bar-chart__empty" }, " -- ", -1), wg = /* @__PURE__ */ Mt({
  __name: "BarChart",
  props: {
    intervalStart: {},
    intervalEnd: {},
    items: {},
    chartPadding: {},
    axisPadding: {}
  },
  setup(t) {
    const e = t, n = Ni(), r = G(), i = wt(), a = Lt(), o = () => {
      s();
    }, s = () => {
      const k = e.intervalStart, $ = e.intervalEnd;
      i.domain([k, $]).range([c.padding.left, c.width.value - c.paddingX]), a.domain([0, h.value || 1]).range([c.padding.top, c.height.value - c.padding.bottom]);
    }, c = $n(r, { onResize: o, padding: e.chartPadding }), { id: u } = c;
    jt(() => e.chartPadding, (k) => {
      c.padding = { ...c.padding, ...k };
    });
    const l = C(() => Math.floor(
      Math.min(10, (c.width.value - c.paddingX) / e.items.length / 2)
    )), d = C(() => e.items.filter((k) => k.value)), h = C(() => {
      const k = e.items.map(($) => $.value);
      return Math.max(...k);
    }), g = (k) => {
      const $ = a(k.value), b = c.height.value - c.padding.bottom - $, F = i(k.intervalStart) + c.padding.left;
      return {
        height: `${$}px`,
        left: `${F}px`,
        top: `${b}px`,
        width: `${l.value}px`
      };
    }, S = C(() => ({
      bottom: `${c.padding.bottom - (e.axisPadding ?? 0)}px`
    }));
    return qt(() => {
      s();
    }), Fa(() => {
      s();
    }), (k, $) => (q(), B("div", {
      ref_key: "container",
      ref: r,
      class: "bar-chart"
    }, [
      d.value.length ? (q(), B(Rt, { key: 0 }, [
        (q(), B("svg", {
          id: nt(u),
          class: "bar-chart__svg"
        }, null, 8, Vf)),
        I("div", qf, [
          (q(!0), B(Rt, null, te(d.value, (b) => (q(), B("div", {
            key: b.intervalStart,
            style: dt(g(b)),
            class: "bar-chart__item"
          }, [
            nt(n).default ? rt(k.$slots, "default", {
              key: 0,
              item: b
            }) : (q(), B("div", Bf))
          ], 4))), 128))
        ]),
        I("div", {
          class: "bar-chart__axis-container",
          style: dt(S.value)
        }, [
          nt(n).axis ? rt(k.$slots, "axis", { key: 0 }) : (q(), B("div", Gf))
        ], 4)
      ], 64)) : rt(k.$slots, "empty", { key: 1 }, () => [
        Qf
      ])
    ], 512));
  }
}), le = 31536e3, Ae = 86400, an = 3600, cr = 60, xi = {
  years: 4,
  days: 3,
  hours: 2,
  minutes: 1,
  seconds: 0
}, Zf = {
  4: "years",
  3: "days",
  2: "hours",
  1: "minutes",
  0: "seconds"
}, Nr = (t) => {
  const e = Math.floor(t / le), n = Math.floor(t % le / Ae), r = Math.floor(t % le % Ae / an), i = Math.floor(t % le % Ae % an / cr), a = Math.ceil(t % le % Ae % an % cr);
  return { years: e, days: n, hours: r, minutes: i, seconds: a };
}, Da = (t) => {
  const e = Math.floor(t / le), n = Math.floor(t / Ae), r = Math.floor(t / an), i = Math.floor(t / cr);
  return { years: e, days: n, hours: r, minutes: i, seconds: t };
}, Kf = (t) => {
  const e = Nr(t);
  return e.years > 0 ? "years" : e.days > 0 ? "days" : e.hours > 0 ? "hours" : e.minutes > 0 ? "minutes" : "seconds";
}, bi = (t) => {
  const { seconds: e, minutes: n, hours: r, days: i, years: a } = Da(t), o = e == 0, s = n == 0, c = r == 0, u = i == 0, l = a == 0;
  return s && c && u && l ? "seconds" : !o && c && u && l ? "minutes" : !s && u && l ? "hours" : !c && l ? "days" : "years";
}, Jf = (t) => {
  switch (t) {
    case "years":
      return kt;
    case "days":
      return ae;
    case "hours":
      return Re;
    case "minutes":
      return We;
    case "seconds":
    default:
      return Vt;
  }
}, jf = (t) => {
  switch (t) {
    case "years":
      return "days";
    case "days":
      return "hours";
    case "hours":
      return "minutes";
    case "minutes":
      return "seconds";
    case "seconds":
    default:
      return "seconds";
  }
}, xg = (t) => {
  switch (t) {
    case "years":
      return "years";
    case "days":
      return "years";
    case "hours":
      return "days";
    case "minutes":
      return "hours";
    case "seconds":
    default:
      return "minutes";
  }
}, bg = (t, e, n = 5) => {
  const r = t.getTime() / 1e3, i = e.getTime() / 1e3, a = Nr(i - r), o = Kf(i - r);
  let s = o;
  return a[o] < n && (s = jf(o)), s;
};
function th(t, e = !0) {
  return `${t === 1 && !e ? "" : t}`;
}
function Se(t, e, n = !0) {
  return `${th(e, n)}${t}`;
}
function eh(t, e = !0) {
  const { years: n, days: r, hours: i, minutes: a, seconds: o } = Nr(t), s = Se("y", n, e), c = Se("d", r, e), u = Se("h", i, e), l = Se("m", a, e), d = Se("s", o, e);
  switch (!0) {
    case n > 0:
      return s;
    case r > 0:
      return c;
    case i > 0:
      return u;
    case a > 0:
      return l;
    default:
      return d;
  }
}
const nh = Ot(".%L"), rh = Ot(":%S"), ih = Ot("%I:%M"), ah = Ot("%I %p"), oh = Ot("%a %d"), sh = Ot("%b %d"), uh = Ot("%B"), ch = Ot("%Y"), lh = (t) => {
  if (typeof t != "number")
    return `${t.valueOf()}`;
  const e = Dr(".2f");
  return t === 0 ? "0s" : t < 1 ? `${e(t)}s` : `${eh(t)}`;
}, Pr = (t) => t instanceof Date ? Vt(t) < t ? nh(t) : We(t) < t ? rh(t) : Re(t) < t ? ih(t) : ae(t) < t ? ah(t) : Cn(t) < t ? ze(t) < t ? oh(t) : sh(t) : kt(t) < t ? uh(t) : ch(t) : "", fh = ["id"], hh = /* @__PURE__ */ I("g", { class: "diverging-bar-chart__axis-group" }, null, -1), dh = [
  hh
], mh = {
  key: 1,
  class: "diverging-bar-chart__median"
}, gh = { class: "diverging-bar-chart__series-container" }, vh = {
  key: 1,
  class: "diverging-bar-chart__series-bar"
}, ph = /* @__PURE__ */ I("div", { class: "diverging-bar-chart__empty" }, " -- ", -1), Mg = /* @__PURE__ */ Mt({
  __name: "DivergingBarChart",
  props: {
    intervalStart: {},
    intervalEnd: {},
    items: {},
    staticMedian: { type: Boolean },
    showAxis: { type: Boolean },
    axisClass: {},
    positiveSentimentKeys: {},
    negativeSentimentKeys: {},
    chartPadding: {}
  },
  setup(t) {
    const e = t, n = Ni(), r = C(() => {
      const f = new Map(e.positiveSentimentKeys.map((m) => [m, -1])), _ = new Map(e.negativeSentimentKeys.map((m) => [m, 1]));
      return new Map([...f, ..._]);
    }), i = G(), a = G(wt()), o = G(Lt()), c = $n(i, { onResize: () => {
      y();
    }, padding: e.chartPadding }), { id: u } = c;
    let l;
    const d = C(() => {
      if (!e.items.length)
        return 1;
      const f = Math.floor(e.items.length * ((c.width.value - c.paddingX) / (e.items.length * 150)));
      return Math.max(f, 1);
    }), h = (f) => f.attr("class", () => {
      var w;
      const _ = f.attr("class").split(" "), m = ((w = e.axisClass) == null ? void 0 : w.split(" ")) ?? [];
      return [..._, ...m.filter((N) => !_.includes(N))].join(" ");
    }).call(
      co(a.value).tickPadding(0).ticks(d.value).tickFormat(Pr).tickSizeInner(0).tickSizeOuter(0)
    ).call((_) => _.select(".domain").remove()).call((_) => _.selectAll(".tick").style("opacity", 1)), g = C(() => {
      const f = e.items.map((m) => m.data);
      return Nf().keys([...e.positiveSentimentKeys, ...e.negativeSentimentKeys]).value((m, p) => {
        const w = r.value.get(p);
        return m[p] * (w ?? 1) || 0;
      }).order(ur).offset(Pf)(f);
    }), S = C(() => {
      const f = e.items.map((_, m) => {
        const p = g.value.map((w) => ({ key: w.key, value: w[m] }));
        return [_.intervalStart, { data: _, series: p }];
      });
      return new Map(f);
    }), k = (f) => {
      const _ = a.value(f.intervalStart), m = a.value(f.intervalEnd);
      return {
        left: `${_}px`,
        width: `${m - _}px`
      };
    }, $ = (f) => {
      const _ = c.padding.middle / 2;
      let m = o.value(f[0]), p = o.value(f[1]);
      return f[0] < 0 ? (m -= _, p -= _) : (m += _, p += _), {
        height: `${Math.ceil(p - m)}px`,
        top: `${m}px`
      };
    }, b = C(() => o.value(0)), F = C(() => ({
      top: `${b.value > 0 ? b.value : c.height.value / 2}px`
    })), y = () => {
      var E;
      const f = e.intervalStart, _ = e.intervalEnd;
      let m = 0;
      e.showAxis && l ? (l.call(h), m = ((E = l.node()) == null ? void 0 : E.getBBox().height) ?? 0, l.attr("transform", `translate(0, ${c.height.value - m / 2})`)) : l && l.selectAll(".tick").style("opacity", 0), a.value = wt().domain([f, _]).range([c.padding.left, c.width.value - c.paddingX]);
      const p = g.value.flat(2);
      let w = Math.min(...p), N = Math.max(...p);
      w == N && (w = -1, N = 1);
      const Y = Lt().range([
        c.padding.top + c.padding.middle / 2,
        c.height.value - c.padding.bottom - c.padding.middle / 2 - m
      ]);
      if (e.staticMedian) {
        const Q = Math.max(Math.abs(w), Math.abs(N));
        Y.domain([-Q, Q]);
      } else
        Y.domain([w, N]);
      o.value = Y, e.showAxis && l ? l.call(h) : l && l.selectAll(".tick").style("opacity", 0);
    };
    return qt(() => {
      l = at(`#${u}`).select(".diverging-bar-chart__axis-group"), y();
    }), dr(() => {
      l = at(`#${u}`).select(".diverging-bar-chart__axis-group"), c.padding = { ...c.padding, ...e.chartPadding }, y();
    }), (f, _) => (q(), B("div", {
      ref_key: "container",
      ref: i,
      class: "diverging-bar-chart"
    }, [
      (q(), B("svg", {
        id: nt(u),
        class: "diverging-bar-chart__svg"
      }, dh, 8, fh)),
      e.items.length ? (q(), B(Rt, { key: 0 }, [
        I("div", {
          class: "diverging-bar-chart__median-container",
          style: dt(F.value)
        }, [
          nt(n).median ? rt(f.$slots, "median", { key: 0 }) : (q(), B("div", mh))
        ], 4),
        I("div", gh, [
          (q(!0), B(Rt, null, te(S.value, ([m, p]) => (q(), B("div", {
            key: m,
            class: "diverging-bar-chart__series",
            style: dt(k(p.data))
          }, [
            (q(!0), B(Rt, null, te(p.series, (w) => (q(), B("div", {
              key: w.key,
              class: "diverging-bar-chart__series-point",
              style: dt($(w.value))
            }, [
              nt(n).default ? rt(f.$slots, "default", {
                key: w.key,
                value: w.value.data[w.key],
                series: p
              }) : (q(), B("div", vh))
            ], 4))), 128))
          ], 4))), 128))
        ])
      ], 64)) : rt(f.$slots, "empty", { key: 1 }, () => [
        ph
      ])
    ], 512));
  }
});
var Ge = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function _h(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var yh = "Expected a function", Mi = NaN, wh = "[object Symbol]", xh = /^\s+|\s+$/g, bh = /^[-+]0x[0-9a-f]+$/i, Mh = /^0b[01]+$/i, Th = /^0o[0-7]+$/i, Sh = parseInt, kh = typeof Ge == "object" && Ge && Ge.Object === Object && Ge, Dh = typeof self == "object" && self && self.Object === Object && self, Ch = kh || Dh || Function("return this")(), $h = Object.prototype, Eh = $h.toString, Ah = Math.max, Nh = Math.min, Hn = function() {
  return Ch.Date.now();
};
function Ph(t, e, n) {
  var r, i, a, o, s, c, u = 0, l = !1, d = !1, h = !0;
  if (typeof t != "function")
    throw new TypeError(yh);
  e = Ti(e) || 0, lr(n) && (l = !!n.leading, d = "maxWait" in n, a = d ? Ah(Ti(n.maxWait) || 0, e) : a, h = "trailing" in n ? !!n.trailing : h);
  function g(m) {
    var p = r, w = i;
    return r = i = void 0, u = m, o = t.apply(w, p), o;
  }
  function S(m) {
    return u = m, s = setTimeout(b, e), l ? g(m) : o;
  }
  function k(m) {
    var p = m - c, w = m - u, N = e - p;
    return d ? Nh(N, a - w) : N;
  }
  function $(m) {
    var p = m - c, w = m - u;
    return c === void 0 || p >= e || p < 0 || d && w >= a;
  }
  function b() {
    var m = Hn();
    if ($(m))
      return F(m);
    s = setTimeout(b, k(m));
  }
  function F(m) {
    return s = void 0, h && r ? g(m) : (r = i = void 0, o);
  }
  function y() {
    s !== void 0 && clearTimeout(s), u = 0, r = c = i = s = void 0;
  }
  function f() {
    return s === void 0 ? o : F(Hn());
  }
  function _() {
    var m = Hn(), p = $(m);
    if (r = arguments, i = this, c = m, p) {
      if (s === void 0)
        return S(c);
      if (d)
        return s = setTimeout(b, e), g(c);
    }
    return s === void 0 && (s = setTimeout(b, e)), o;
  }
  return _.cancel = y, _.flush = f, _;
}
function lr(t) {
  var e = typeof t;
  return !!t && (e == "object" || e == "function");
}
function Uh(t) {
  return !!t && typeof t == "object";
}
function Oh(t) {
  return typeof t == "symbol" || Uh(t) && Eh.call(t) == wh;
}
function Ti(t) {
  if (typeof t == "number")
    return t;
  if (Oh(t))
    return Mi;
  if (lr(t)) {
    var e = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = lr(e) ? e + "" : e;
  }
  if (typeof t != "string")
    return t === 0 ? t : +t;
  t = t.replace(xh, "");
  var n = Mh.test(t);
  return n || Th.test(t) ? Sh(t.slice(2), n ? 2 : 8) : bh.test(t) ? Mi : +t;
}
var Fh = Ph;
const Yh = /* @__PURE__ */ _h(Fh), Ih = ["id"], Wh = /* @__PURE__ */ I("g", { class: "timeline__axis-group" }, null, -1), Rh = [
  Wh
], zh = ["id"], Lh = /* @__PURE__ */ I("g", { class: "timeline__grid-group" }, null, -1), Hh = [
  Lh
], Xh = { class: "timeline__node-container" }, Vh = /* @__PURE__ */ I("div", { class: "timeline__node-content" }, null, -1), Tg = /* @__PURE__ */ Mt({
  __name: "Timeline",
  props: {
    start: {},
    end: {},
    items: {},
    axisTeleportTarget: {},
    hideAxis: { type: Boolean },
    axisClass: {},
    gridLineClass: {},
    intervalHeight: {},
    intervalWidth: {},
    nodeMinWidth: {},
    chartPadding: {}
  },
  setup(t) {
    const e = t, n = G(), r = G(), i = G(), a = G(!1), s = $n(i, { onResize: () => {
      H();
    }, padding: e.chartPadding }), { id: c } = s, u = G(wt());
    let l, d;
    const h = () => e.start ? new Date(e.start) : /* @__PURE__ */ new Date(), g = () => {
      const { end: T } = e, A = E.value, R = new Date(h()), X = new Date(Math.max((A == null ? void 0 : A.getTime()) ?? 0, R.getTime() + 3e4));
      switch ($.value) {
        case "years":
          X.setMonth(X.getMonth() + 1);
          break;
        case "days":
          X.setDate(X.getDate() + 1);
          break;
        case "hours":
          X.setHours(X.getHours() + 1);
          break;
        case "minutes":
          X.setMinutes(X.getMinutes() + 1);
          break;
        default:
          X.setSeconds(X.getSeconds() + 30);
      }
      return T && A ? new Date(Math.max(A.getTime(), T.getTime())) : X;
    }, S = G(e.intervalWidth ?? 84), k = G(e.intervalHeight ?? 32), $ = C(() => {
      const T = e.items.filter((R) => R.end).map((R) => {
        const X = R.start.getTime() / 1e3, it = (R.end ?? e.end ?? /* @__PURE__ */ new Date()).getTime() / 1e3;
        return xi[bi(it - X)];
      });
      if (T.push(xi[bi(g().getTime() / 1e3 - h().getTime() / 1e3)]), T.length === 0)
        return "seconds";
      const A = Math.max(...T);
      return Zf[A];
    }), b = C(() => Jf($.value).every(1)), F = C(() => {
      const T = h().getTime() / 1e3, A = g().getTime() / 1e3, R = Math.ceil(r.value.offsetWidth / S.value), X = Da(A - T);
      return R > X[$.value] ? R : X[$.value];
    }), y = C(() => F.value * S.value), f = C(() => {
      var A, R;
      const T = (m.value.size + 1) * k.value;
      return T < ((A = r.value) == null ? void 0 : A.offsetHeight) ? (R = r.value) == null ? void 0 : R.offsetHeight : T;
    }), _ = (T) => {
      const A = u.value(T.start), R = u.value(T.end ?? /* @__PURE__ */ new Date()), X = m.value.get(T.id) * k.value, it = Math.max(e.nodeMinWidth ?? 32, R - A);
      return {
        height: `${k.value}px`,
        left: `${A}px`,
        top: `${X}px`,
        width: `${it}px`
      };
    }, m = G(/* @__PURE__ */ new Map()), p = () => {
      const T = [], A = /* @__PURE__ */ new Map();
      w.value.forEach((R) => {
        const { start: X } = R, it = R.end ?? X, ut = u.value(X), ct = u.value(it), lt = Math.max(e.nodeMinWidth ?? 32, ct - ut);
        let P = 0;
        for (; ; ) {
          const Z = T[P];
          if (Z) {
            const [, K] = Z;
            if (ut > K) {
              T[P][1] = ut + lt;
              break;
            } else {
              P++;
              continue;
            }
          } else {
            T[P] = [ut, ut + lt];
            break;
          }
        }
        A.set(R.id, P);
      }), m.value = A;
    }, w = C(() => [...e.items].sort((T, A) => new Date(T.start).getTime() - new Date(A.start).getTime())), N = C(() => e.items.filter((T) => T.end !== void 0).map((T) => T.end.getTime())), Y = C(() => e.items.length && (!e.end || e.items.some((T) => !T.end))), E = C(() => {
      const T = Math.max(...N.value);
      return T === -1 / 0 ? null : new Date(T);
    }), Q = (T, A) => (R) => R.attr("class", () => {
      var ct;
      const X = R.attr("class").split(" "), it = ((ct = e.axisClass) == null ? void 0 : ct.split(" ")) ?? [];
      return [...X, ...it.filter((lt) => !X.includes(lt))].join(" ");
    }).call(
      Oi(T).tickPadding(0).ticks(A).tickFormat(Pr)
    ).call((X) => X.select(".domain").remove()), J = () => {
      const T = h(), A = g();
      u.value = wt().domain([T, A]).range([s.padding.left, y.value - s.padding.right]).clamp(!0);
    }, v = () => {
      e.hideAxis || l && l.call(Q(u.value, b.value));
    }, O = () => {
      d && (d.selectAll(".timeline__grid-line.timeline__grid-line--x").data(Array.from({ length: Math.ceil(f.value / k.value) })).join(
        (T) => T.append("line").attr("id", (A, R) => `timeline__grid-line-x-${R}`).attr("class", `timeline__grid-line timeline__grid-line--x ${e.gridLineClass}`).attr("x1", 0).attr("x2", y.value).attr("y1", (A, R) => R * k.value).attr("y2", (A, R) => R * k.value),
        (T) => T.attr("x1", 0).attr("x2", y.value).attr("y1", (A, R) => R * k.value).attr("y2", (A, R) => R * k.value),
        (T) => T.remove()
      ), d.selectAll(".timeline__grid-line.timeline__grid-line--y").data(u.value.ticks(b.value)).join(
        (T) => T.append("line").attr("id", (A, R) => `x-${R}`).attr("class", `timeline__grid-line timeline__grid-line--y ${e.gridLineClass}`).attr("x1", (A) => u.value(A)).attr("x2", (A) => u.value(A)).attr("y1", 0).attr("y2", f.value),
        (T) => T.attr("x1", (A) => u.value(A)).attr("x2", (A) => u.value(A)).attr("y1", 0).attr("y2", f.value),
        (T) => T.remove()
      ).call(() => {
        Y.value && H();
      }));
    }, x = () => {
      l = at(`#${c}__axis`).select(".timeline__axis-group"), d = at(`#${c}__grid`).select(".timeline__grid-group");
    }, U = () => {
      at(`#${c}__axis`).attr("viewbox", `0, 0, ${y.value}, 24`).style("width", `${y.value}px`), at(`#${c}__grid`).attr("viewbox", `0, 0, ${y.value}, ${f.value}`).style("width", `${y.value}px`).style("height", `${f.value}px`);
    }, L = () => {
      var T;
      (T = r.value) == null || T.scroll({ left: n.value.scrollLeft });
    }, z = () => {
      var T;
      (T = n.value) == null || T.scroll({ left: r.value.scrollLeft });
    }, H = Yh(() => {
      requestAnimationFrame(() => {
        x(), U(), J(), v(), O(), p();
      });
    }, 60, { maxWait: 120 });
    return qt(() => {
      H(), a.value = !0;
    }), dr(() => {
      e.hideAxis || Ya(() => {
        H();
      });
    }), jt(() => [e.end, e.items, e.start], () => {
      H();
    }), jt(() => e.chartPadding, (T) => {
      s.padding = { ...s.padding, ...T };
    }), (T, A) => (q(), B("div", {
      ref_key: "container",
      ref: r,
      class: "timeline",
      onScroll: z
    }, [
      I("main", {
        ref_key: "chart",
        ref: i,
        class: "timeline__viewport",
        style: dt({ height: `${f.value}px` })
      }, [
        a.value && !T.hideAxis ? (q(), Ia(Wa(T.axisTeleportTarget ? Ra : "div"), {
          key: 0,
          to: T.axisTeleportTarget,
          class: "timeline__axis-container"
        }, {
          default: za(() => [
            I("nav", {
              ref_key: "axis",
              ref: n,
              class: "timeline__nav",
              onScroll: L
            }, [
              (q(), B("svg", {
                id: `${nt(c)}__axis`,
                class: "timeline__axis"
              }, Rh, 8, Ih))
            ], 544)
          ]),
          _: 1
        }, 8, ["to"])) : pt("", !0),
        (q(), B("svg", {
          id: `${nt(c)}__grid`,
          class: "timeline__grid"
        }, Hh, 8, zh)),
        I("div", Xh, [
          (q(!0), B(Rt, null, te(T.items, (R, X) => (q(), B("div", {
            key: X,
            class: "timeline__node",
            style: dt(_(R))
          }, [
            rt(T.$slots, "default", { node: R }, () => [
              Vh
            ])
          ], 4))), 128))
        ])
      ], 4)
    ], 544));
  }
});
function qh(t) {
  return t.some((e) => e === void 0);
}
const Bh = ["id"], Gh = /* @__PURE__ */ I("g", { class: "scatter-plot__x-axis-group" }, null, -1), Qh = /* @__PURE__ */ I("g", { class: "scatter-plot__y-axis-group" }, null, -1), Zh = [
  Gh,
  Qh
], Sg = /* @__PURE__ */ Mt({
  __name: "ScatterPlot",
  props: {
    items: {},
    yTicks: { default: 5 },
    startDate: { default: null },
    endDate: { default: null },
    showNowLine: { type: Boolean },
    dotDiameter: { default: 14 },
    chartPadding: { default: () => ({ top: 16, left: 40, bottom: 48, right: 0 }) }
  },
  setup(t) {
    const e = t, n = G(), r = G(wt()), i = G(Lt()), a = C(() => e.items), s = $n(n, { onResize: () => {
      y();
    }, padding: e.chartPadding }), { id: c } = s;
    let u;
    const l = C(() => {
      const w = (s.width.value - s.paddingX) / 100;
      return Math.max(2, Math.ceil(w));
    }), d = (p) => p.call(
      Oi(r.value).tickPadding(10).tickSizeInner(5).tickSizeOuter(0).ticks(l.value).tickFormat(Pr)
    );
    let h;
    const g = (p) => p.call(
      lo(i.value).tickPadding(10).tickSizeInner(-(s.width.value - s.paddingX)).tickFormat(lh).tickValues(m())
    ), S = (p) => p.x, k = (p) => p.y, $ = (p) => {
      const w = i.value(p.y) + s.padding.top - e.dotDiameter / 2, N = r.value(p.x);
      return {
        height: `${e.dotDiameter}px`,
        width: `${e.dotDiameter}px`,
        left: `${N}px`,
        top: `${w}px`
      };
    }, b = () => {
      const [p, w] = F(), N = /* @__PURE__ */ new Date();
      return p > N || w < N ? null : {
        left: `${r.value(N) + e.dotDiameter}px`
      };
    }, F = () => {
      let p = Or(a.value, S);
      if (qh(p)) {
        const w = /* @__PURE__ */ new Date(), N = w.setDate(w.getDate() - 1);
        p = [new Date(N), w];
      }
      return e.startDate && (p[0] = e.startDate), e.endDate && (p[1] = e.endDate), p;
    }, y = () => {
      f(), _(), u && (u.call(d), u.attr("transform", `translate(${e.dotDiameter}, ${s.height.value - s.padding.bottom + e.dotDiameter})`), u.selectAll(".tick text").attr("class", "scatter-plot__tick-label scatter-plot__tick-label--x"), u.select(".domain").remove()), h && (h.call(g), h.attr("transform", `translate(${s.padding.left}, ${s.padding.top})`), h.selectAll(".tick text").attr("class", "scatter-plot__tick-label scatter-plot__tick-label--y"), h.selectAll(".tick line").attr("class", "scatter-plot__tick-line"), h.select(".domain").remove());
    }, f = () => {
      const p = F();
      r.value = wt().domain(p).range([s.padding.left, s.width.value - s.paddingX - s.padding.right]);
    }, _ = () => {
      let [, w = 0] = Or(a.value, k);
      w = Math.max(w, 1), i.value = Lt().domain([0, w]).range([s.height.value - s.paddingY, 0]);
    }, m = () => {
      const [p, w] = i.value.domain(), N = (w - p) / (e.yTicks - 1);
      return no(p, w + N, N);
    };
    return qt(() => {
      const p = at(`#${c}`);
      u = p.select(".scatter-plot__x-axis-group"), h = p.select(".scatter-plot__y-axis-group"), y();
    }), jt(() => e.chartPadding, (p) => {
      s.padding = { ...s.padding, ...p };
    }), jt(() => e.items, () => y()), (p, w) => (q(), B("div", {
      ref_key: "container",
      ref: n,
      class: "scatter-plot"
    }, [
      (q(), B("svg", {
        id: nt(c),
        class: "scatter-plot__svg"
      }, Zh, 8, Bh)),
      (q(!0), B(Rt, null, te(a.value, (N) => (q(), B("div", {
        key: N.id,
        style: dt($(N)),
        class: Et(["scatter-plot__dot", N.itemClass])
      }, [
        rt(p.$slots, "default", { item: N })
      ], 6))), 128)),
      p.showNowLine && b() ? (q(), B("div", {
        key: 0,
        class: "scatter-plot__now",
        style: dt(b())
      }, null, 4)) : pt("", !0)
    ], 512));
  }
});
function xn(t) {
  "@babel/helpers - typeof";
  return xn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, xn(t);
}
function Ht(t) {
  if (t === null || t === !0 || t === !1)
    return NaN;
  var e = Number(t);
  return isNaN(e) ? e : e < 0 ? Math.ceil(e) : Math.floor(e);
}
function ot(t, e) {
  if (e.length < t)
    throw new TypeError(t + " argument" + (t > 1 ? "s" : "") + " required, but only " + e.length + " present");
}
function ft(t) {
  ot(1, arguments);
  var e = Object.prototype.toString.call(t);
  return t instanceof Date || xn(t) === "object" && e === "[object Date]" ? new Date(t.getTime()) : typeof t == "number" || e === "[object Number]" ? new Date(t) : ((typeof t == "string" || e === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function Ca(t, e) {
  ot(2, arguments);
  var n = ft(t).getTime(), r = Ht(e);
  return new Date(n + r);
}
var Kh = {};
function En() {
  return Kh;
}
function Jh(t) {
  var e = new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()));
  return e.setUTCFullYear(t.getFullYear()), t.getTime() - e.getTime();
}
function jh(t) {
  ot(1, arguments);
  var e = ft(t);
  return e.setHours(0, 0, 0, 0), e;
}
function on(t, e) {
  ot(2, arguments);
  var n = Ht(e);
  return Ca(t, n * 1e3);
}
function td(t) {
  return ot(1, arguments), t instanceof Date || xn(t) === "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function ed(t) {
  if (ot(1, arguments), !td(t) && typeof t != "number")
    return !1;
  var e = ft(t);
  return !isNaN(Number(e));
}
function nd(t, e) {
  return ot(2, arguments), ft(t).getTime() - ft(e).getTime();
}
var Si = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function(e) {
    return e < 0 ? Math.ceil(e) : Math.floor(e);
  }
  // Math.trunc is not supported by IE
}, rd = "trunc";
function id(t) {
  return t ? Si[t] : Si[rd];
}
function ad(t) {
  ot(1, arguments);
  var e = ft(t);
  return e.setHours(23, 59, 59, 999), e;
}
function od(t, e, n) {
  ot(2, arguments);
  var r = nd(t, e) / 1e3;
  return id(void 0)(r);
}
function sd() {
  return ad(Date.now());
}
function ud(t, e) {
  ot(2, arguments);
  var n = Ht(e);
  return Ca(t, -n);
}
var cd = 864e5;
function ld(t) {
  ot(1, arguments);
  var e = ft(t), n = e.getTime();
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
  var r = e.getTime(), i = n - r;
  return Math.floor(i / cd) + 1;
}
function bn(t) {
  ot(1, arguments);
  var e = 1, n = ft(t), r = n.getUTCDay(), i = (r < e ? 7 : 0) + r - e;
  return n.setUTCDate(n.getUTCDate() - i), n.setUTCHours(0, 0, 0, 0), n;
}
function $a(t) {
  ot(1, arguments);
  var e = ft(t), n = e.getUTCFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var i = bn(r), a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(n, 0, 4), a.setUTCHours(0, 0, 0, 0);
  var o = bn(a);
  return e.getTime() >= i.getTime() ? n + 1 : e.getTime() >= o.getTime() ? n : n - 1;
}
function fd(t) {
  ot(1, arguments);
  var e = $a(t), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(e, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var r = bn(n);
  return r;
}
var hd = 6048e5;
function dd(t) {
  ot(1, arguments);
  var e = ft(t), n = bn(e).getTime() - fd(e).getTime();
  return Math.round(n / hd) + 1;
}
function Mn(t, e) {
  var n, r, i, a, o, s, c, u;
  ot(1, arguments);
  var l = En(), d = Ht((n = (r = (i = (a = e == null ? void 0 : e.weekStartsOn) !== null && a !== void 0 ? a : e == null || (o = e.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && i !== void 0 ? i : l.weekStartsOn) !== null && r !== void 0 ? r : (c = l.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var h = ft(t), g = h.getUTCDay(), S = (g < d ? 7 : 0) + g - d;
  return h.setUTCDate(h.getUTCDate() - S), h.setUTCHours(0, 0, 0, 0), h;
}
function Ea(t, e) {
  var n, r, i, a, o, s, c, u;
  ot(1, arguments);
  var l = ft(t), d = l.getUTCFullYear(), h = En(), g = Ht((n = (r = (i = (a = e == null ? void 0 : e.firstWeekContainsDate) !== null && a !== void 0 ? a : e == null || (o = e.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && i !== void 0 ? i : h.firstWeekContainsDate) !== null && r !== void 0 ? r : (c = h.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(g >= 1 && g <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var S = /* @__PURE__ */ new Date(0);
  S.setUTCFullYear(d + 1, 0, g), S.setUTCHours(0, 0, 0, 0);
  var k = Mn(S, e), $ = /* @__PURE__ */ new Date(0);
  $.setUTCFullYear(d, 0, g), $.setUTCHours(0, 0, 0, 0);
  var b = Mn($, e);
  return l.getTime() >= k.getTime() ? d + 1 : l.getTime() >= b.getTime() ? d : d - 1;
}
function md(t, e) {
  var n, r, i, a, o, s, c, u;
  ot(1, arguments);
  var l = En(), d = Ht((n = (r = (i = (a = e == null ? void 0 : e.firstWeekContainsDate) !== null && a !== void 0 ? a : e == null || (o = e.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && i !== void 0 ? i : l.firstWeekContainsDate) !== null && r !== void 0 ? r : (c = l.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), h = Ea(t, e), g = /* @__PURE__ */ new Date(0);
  g.setUTCFullYear(h, 0, d), g.setUTCHours(0, 0, 0, 0);
  var S = Mn(g, e);
  return S;
}
var gd = 6048e5;
function vd(t, e) {
  ot(1, arguments);
  var n = ft(t), r = Mn(n, e).getTime() - md(n, e).getTime();
  return Math.round(r / gd) + 1;
}
function et(t, e) {
  for (var n = t < 0 ? "-" : "", r = Math.abs(t).toString(); r.length < e; )
    r = "0" + r;
  return n + r;
}
var Xt = {
  // Year
  y: function(e, n) {
    var r = e.getUTCFullYear(), i = r > 0 ? r : 1 - r;
    return et(n === "yy" ? i % 100 : i, n.length);
  },
  // Month
  M: function(e, n) {
    var r = e.getUTCMonth();
    return n === "M" ? String(r + 1) : et(r + 1, 2);
  },
  // Day of the month
  d: function(e, n) {
    return et(e.getUTCDate(), n.length);
  },
  // AM or PM
  a: function(e, n) {
    var r = e.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(e, n) {
    return et(e.getUTCHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H: function(e, n) {
    return et(e.getUTCHours(), n.length);
  },
  // Minute
  m: function(e, n) {
    return et(e.getUTCMinutes(), n.length);
  },
  // Second
  s: function(e, n) {
    return et(e.getUTCSeconds(), n.length);
  },
  // Fraction of second
  S: function(e, n) {
    var r = n.length, i = e.getUTCMilliseconds(), a = Math.floor(i * Math.pow(10, r - 3));
    return et(a, n.length);
  }
}, ce = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, pd = {
  // Era
  G: function(e, n, r) {
    var i = e.getUTCFullYear() > 0 ? 1 : 0;
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(i, {
          width: "abbreviated"
        });
      case "GGGGG":
        return r.era(i, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return r.era(i, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(e, n, r) {
    if (n === "yo") {
      var i = e.getUTCFullYear(), a = i > 0 ? i : 1 - i;
      return r.ordinalNumber(a, {
        unit: "year"
      });
    }
    return Xt.y(e, n);
  },
  // Local week-numbering year
  Y: function(e, n, r, i) {
    var a = Ea(e, i), o = a > 0 ? a : 1 - a;
    if (n === "YY") {
      var s = o % 100;
      return et(s, 2);
    }
    return n === "Yo" ? r.ordinalNumber(o, {
      unit: "year"
    }) : et(o, n.length);
  },
  // ISO week-numbering year
  R: function(e, n) {
    var r = $a(e);
    return et(r, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, n) {
    var r = e.getUTCFullYear();
    return et(r, n.length);
  },
  // Quarter
  Q: function(e, n, r) {
    var i = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (n) {
      case "Q":
        return String(i);
      case "QQ":
        return et(i, 2);
      case "Qo":
        return r.ordinalNumber(i, {
          unit: "quarter"
        });
      case "QQQ":
        return r.quarter(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(i, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, n, r) {
    var i = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (n) {
      case "q":
        return String(i);
      case "qq":
        return et(i, 2);
      case "qo":
        return r.ordinalNumber(i, {
          unit: "quarter"
        });
      case "qqq":
        return r.quarter(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(i, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, n, r) {
    var i = e.getUTCMonth();
    switch (n) {
      case "M":
      case "MM":
        return Xt.M(e, n);
      case "Mo":
        return r.ordinalNumber(i + 1, {
          unit: "month"
        });
      case "MMM":
        return r.month(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(i, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(e, n, r) {
    var i = e.getUTCMonth();
    switch (n) {
      case "L":
        return String(i + 1);
      case "LL":
        return et(i + 1, 2);
      case "Lo":
        return r.ordinalNumber(i + 1, {
          unit: "month"
        });
      case "LLL":
        return r.month(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(i, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(e, n, r, i) {
    var a = vd(e, i);
    return n === "wo" ? r.ordinalNumber(a, {
      unit: "week"
    }) : et(a, n.length);
  },
  // ISO week of year
  I: function(e, n, r) {
    var i = dd(e);
    return n === "Io" ? r.ordinalNumber(i, {
      unit: "week"
    }) : et(i, n.length);
  },
  // Day of the month
  d: function(e, n, r) {
    return n === "do" ? r.ordinalNumber(e.getUTCDate(), {
      unit: "date"
    }) : Xt.d(e, n);
  },
  // Day of year
  D: function(e, n, r) {
    var i = ld(e);
    return n === "Do" ? r.ordinalNumber(i, {
      unit: "dayOfYear"
    }) : et(i, n.length);
  },
  // Day of week
  E: function(e, n, r) {
    var i = e.getUTCDay();
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(i, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, n, r, i) {
    var a = e.getUTCDay(), o = (a - i.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "e":
        return String(o);
      case "ee":
        return et(o, 2);
      case "eo":
        return r.ordinalNumber(o, {
          unit: "day"
        });
      case "eee":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(a, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, n, r, i) {
    var a = e.getUTCDay(), o = (a - i.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "c":
        return String(o);
      case "cc":
        return et(o, n.length);
      case "co":
        return r.ordinalNumber(o, {
          unit: "day"
        });
      case "ccc":
        return r.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return r.day(a, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(a, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, n, r) {
    var i = e.getUTCDay(), a = i === 0 ? 7 : i;
    switch (n) {
      case "i":
        return String(a);
      case "ii":
        return et(a, n.length);
      case "io":
        return r.ordinalNumber(a, {
          unit: "day"
        });
      case "iii":
        return r.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return r.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return r.day(i, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return r.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, n, r) {
    var i = e.getUTCHours(), a = i / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, n, r) {
    var i = e.getUTCHours(), a;
    switch (i === 12 ? a = ce.noon : i === 0 ? a = ce.midnight : a = i / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, n, r) {
    var i = e.getUTCHours(), a;
    switch (i >= 17 ? a = ce.evening : i >= 12 ? a = ce.afternoon : i >= 4 ? a = ce.morning : a = ce.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, n, r) {
    if (n === "ho") {
      var i = e.getUTCHours() % 12;
      return i === 0 && (i = 12), r.ordinalNumber(i, {
        unit: "hour"
      });
    }
    return Xt.h(e, n);
  },
  // Hour [0-23]
  H: function(e, n, r) {
    return n === "Ho" ? r.ordinalNumber(e.getUTCHours(), {
      unit: "hour"
    }) : Xt.H(e, n);
  },
  // Hour [0-11]
  K: function(e, n, r) {
    var i = e.getUTCHours() % 12;
    return n === "Ko" ? r.ordinalNumber(i, {
      unit: "hour"
    }) : et(i, n.length);
  },
  // Hour [1-24]
  k: function(e, n, r) {
    var i = e.getUTCHours();
    return i === 0 && (i = 24), n === "ko" ? r.ordinalNumber(i, {
      unit: "hour"
    }) : et(i, n.length);
  },
  // Minute
  m: function(e, n, r) {
    return n === "mo" ? r.ordinalNumber(e.getUTCMinutes(), {
      unit: "minute"
    }) : Xt.m(e, n);
  },
  // Second
  s: function(e, n, r) {
    return n === "so" ? r.ordinalNumber(e.getUTCSeconds(), {
      unit: "second"
    }) : Xt.s(e, n);
  },
  // Fraction of second
  S: function(e, n) {
    return Xt.S(e, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, n, r, i) {
    var a = i._originalDate || e, o = a.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (n) {
      case "X":
        return Di(o);
      case "XXXX":
      case "XX":
        return Qt(o);
      case "XXXXX":
      case "XXX":
      default:
        return Qt(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, n, r, i) {
    var a = i._originalDate || e, o = a.getTimezoneOffset();
    switch (n) {
      case "x":
        return Di(o);
      case "xxxx":
      case "xx":
        return Qt(o);
      case "xxxxx":
      case "xxx":
      default:
        return Qt(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, n, r, i) {
    var a = i._originalDate || e, o = a.getTimezoneOffset();
    switch (n) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + ki(o, ":");
      case "OOOO":
      default:
        return "GMT" + Qt(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, n, r, i) {
    var a = i._originalDate || e, o = a.getTimezoneOffset();
    switch (n) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + ki(o, ":");
      case "zzzz":
      default:
        return "GMT" + Qt(o, ":");
    }
  },
  // Seconds timestamp
  t: function(e, n, r, i) {
    var a = i._originalDate || e, o = Math.floor(a.getTime() / 1e3);
    return et(o, n.length);
  },
  // Milliseconds timestamp
  T: function(e, n, r, i) {
    var a = i._originalDate || e, o = a.getTime();
    return et(o, n.length);
  }
};
function ki(t, e) {
  var n = t > 0 ? "-" : "+", r = Math.abs(t), i = Math.floor(r / 60), a = r % 60;
  if (a === 0)
    return n + String(i);
  var o = e;
  return n + String(i) + o + et(a, 2);
}
function Di(t, e) {
  if (t % 60 === 0) {
    var n = t > 0 ? "-" : "+";
    return n + et(Math.abs(t) / 60, 2);
  }
  return Qt(t, e);
}
function Qt(t, e) {
  var n = e || "", r = t > 0 ? "-" : "+", i = Math.abs(t), a = et(Math.floor(i / 60), 2), o = et(i % 60, 2);
  return r + a + n + o;
}
var Ci = function(e, n) {
  switch (e) {
    case "P":
      return n.date({
        width: "short"
      });
    case "PP":
      return n.date({
        width: "medium"
      });
    case "PPP":
      return n.date({
        width: "long"
      });
    case "PPPP":
    default:
      return n.date({
        width: "full"
      });
  }
}, Aa = function(e, n) {
  switch (e) {
    case "p":
      return n.time({
        width: "short"
      });
    case "pp":
      return n.time({
        width: "medium"
      });
    case "ppp":
      return n.time({
        width: "long"
      });
    case "pppp":
    default:
      return n.time({
        width: "full"
      });
  }
}, _d = function(e, n) {
  var r = e.match(/(P+)(p+)?/) || [], i = r[1], a = r[2];
  if (!a)
    return Ci(e, n);
  var o;
  switch (i) {
    case "P":
      o = n.dateTime({
        width: "short"
      });
      break;
    case "PP":
      o = n.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      o = n.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      o = n.dateTime({
        width: "full"
      });
      break;
  }
  return o.replace("{{date}}", Ci(i, n)).replace("{{time}}", Aa(a, n));
}, yd = {
  p: Aa,
  P: _d
}, wd = ["D", "DD"], xd = ["YY", "YYYY"];
function bd(t) {
  return wd.indexOf(t) !== -1;
}
function Md(t) {
  return xd.indexOf(t) !== -1;
}
function $i(t, e, n) {
  if (t === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(e, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(e, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(e, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(e, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var Td = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Sd = function(e, n, r) {
  var i, a = Td[e];
  return typeof a == "string" ? i = a : n === 1 ? i = a.one : i = a.other.replace("{{count}}", n.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + i : i + " ago" : i;
};
function Xn(t) {
  return function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = e.width ? String(e.width) : t.defaultWidth, r = t.formats[n] || t.formats[t.defaultWidth];
    return r;
  };
}
var kd = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Dd = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Cd = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, $d = {
  date: Xn({
    formats: kd,
    defaultWidth: "full"
  }),
  time: Xn({
    formats: Dd,
    defaultWidth: "full"
  }),
  dateTime: Xn({
    formats: Cd,
    defaultWidth: "full"
  })
}, Ed = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Ad = function(e, n, r, i) {
  return Ed[e];
};
function ke(t) {
  return function(e, n) {
    var r = n != null && n.context ? String(n.context) : "standalone", i;
    if (r === "formatting" && t.formattingValues) {
      var a = t.defaultFormattingWidth || t.defaultWidth, o = n != null && n.width ? String(n.width) : a;
      i = t.formattingValues[o] || t.formattingValues[a];
    } else {
      var s = t.defaultWidth, c = n != null && n.width ? String(n.width) : t.defaultWidth;
      i = t.values[c] || t.values[s];
    }
    var u = t.argumentCallback ? t.argumentCallback(e) : e;
    return i[u];
  };
}
var Nd = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Pd = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Ud = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, Od = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, Fd = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Yd = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Id = function(e, n) {
  var r = Number(e), i = r % 100;
  if (i > 20 || i < 10)
    switch (i % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, Wd = {
  ordinalNumber: Id,
  era: ke({
    values: Nd,
    defaultWidth: "wide"
  }),
  quarter: ke({
    values: Pd,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: ke({
    values: Ud,
    defaultWidth: "wide"
  }),
  day: ke({
    values: Od,
    defaultWidth: "wide"
  }),
  dayPeriod: ke({
    values: Fd,
    defaultWidth: "wide",
    formattingValues: Yd,
    defaultFormattingWidth: "wide"
  })
};
function De(t) {
  return function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.width, i = r && t.matchPatterns[r] || t.matchPatterns[t.defaultMatchWidth], a = e.match(i);
    if (!a)
      return null;
    var o = a[0], s = r && t.parsePatterns[r] || t.parsePatterns[t.defaultParseWidth], c = Array.isArray(s) ? zd(s, function(d) {
      return d.test(o);
    }) : Rd(s, function(d) {
      return d.test(o);
    }), u;
    u = t.valueCallback ? t.valueCallback(c) : c, u = n.valueCallback ? n.valueCallback(u) : u;
    var l = e.slice(o.length);
    return {
      value: u,
      rest: l
    };
  };
}
function Rd(t, e) {
  for (var n in t)
    if (t.hasOwnProperty(n) && e(t[n]))
      return n;
}
function zd(t, e) {
  for (var n = 0; n < t.length; n++)
    if (e(t[n]))
      return n;
}
function Ld(t) {
  return function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = e.match(t.matchPattern);
    if (!r) return null;
    var i = r[0], a = e.match(t.parsePattern);
    if (!a) return null;
    var o = t.valueCallback ? t.valueCallback(a[0]) : a[0];
    o = n.valueCallback ? n.valueCallback(o) : o;
    var s = e.slice(i.length);
    return {
      value: o,
      rest: s
    };
  };
}
var Hd = /^(\d+)(th|st|nd|rd)?/i, Xd = /\d+/i, Vd = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, qd = {
  any: [/^b/i, /^(a|c)/i]
}, Bd = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Gd = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Qd = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Zd = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, Kd = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Jd = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, jd = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, tm = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, em = {
  ordinalNumber: Ld({
    matchPattern: Hd,
    parsePattern: Xd,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: De({
    matchPatterns: Vd,
    defaultMatchWidth: "wide",
    parsePatterns: qd,
    defaultParseWidth: "any"
  }),
  quarter: De({
    matchPatterns: Bd,
    defaultMatchWidth: "wide",
    parsePatterns: Gd,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: De({
    matchPatterns: Qd,
    defaultMatchWidth: "wide",
    parsePatterns: Zd,
    defaultParseWidth: "any"
  }),
  day: De({
    matchPatterns: Kd,
    defaultMatchWidth: "wide",
    parsePatterns: Jd,
    defaultParseWidth: "any"
  }),
  dayPeriod: De({
    matchPatterns: jd,
    defaultMatchWidth: "any",
    parsePatterns: tm,
    defaultParseWidth: "any"
  })
}, nm = {
  code: "en-US",
  formatDistance: Sd,
  formatLong: $d,
  formatRelative: Ad,
  localize: Wd,
  match: em,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, rm = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, im = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, am = /^'([^]*?)'?$/, om = /''/g, sm = /[a-zA-Z]/;
function Fe(t, e, n) {
  var r, i, a, o, s, c, u, l, d, h, g, S, k, $;
  ot(2, arguments);
  var b = String(e), F = En(), y = (r = (i = void 0) !== null && i !== void 0 ? i : F.locale) !== null && r !== void 0 ? r : nm, f = Ht((a = (o = (s = (c = void 0) !== null && c !== void 0 ? c : void 0) !== null && s !== void 0 ? s : F.firstWeekContainsDate) !== null && o !== void 0 ? o : (u = F.locale) === null || u === void 0 || (l = u.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && a !== void 0 ? a : 1);
  if (!(f >= 1 && f <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var _ = Ht((d = (h = (g = (S = void 0) !== null && S !== void 0 ? S : void 0) !== null && g !== void 0 ? g : F.weekStartsOn) !== null && h !== void 0 ? h : (k = F.locale) === null || k === void 0 || ($ = k.options) === null || $ === void 0 ? void 0 : $.weekStartsOn) !== null && d !== void 0 ? d : 0);
  if (!(_ >= 0 && _ <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!y.localize)
    throw new RangeError("locale must contain localize property");
  if (!y.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var m = ft(t);
  if (!ed(m))
    throw new RangeError("Invalid time value");
  var p = Jh(m), w = ud(m, p), N = {
    firstWeekContainsDate: f,
    weekStartsOn: _,
    locale: y,
    _originalDate: m
  }, Y = b.match(im).map(function(E) {
    var Q = E[0];
    if (Q === "p" || Q === "P") {
      var J = yd[Q];
      return J(E, y.formatLong);
    }
    return E;
  }).join("").match(rm).map(function(E) {
    if (E === "''")
      return "'";
    var Q = E[0];
    if (Q === "'")
      return um(E);
    var J = pd[Q];
    if (J)
      return Md(E) && $i(E, e, String(t)), bd(E) && $i(E, e, String(t)), J(w, E, y.localize, N);
    if (Q.match(sm))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + Q + "`");
    return E;
  }).join("");
  return Y;
}
function um(t) {
  var e = t.match(am);
  return e ? e[1].replace(om, "'") : t;
}
function Qe(t, e) {
  ot(2, arguments);
  var n = ft(t), r = ft(e);
  return n.getTime() > r.getTime();
}
function Ze(t, e) {
  ot(2, arguments);
  var n = ft(t), r = ft(e);
  return n.getTime() < r.getTime();
}
function cm() {
  return jh(Date.now());
}
function Vn(t, e) {
  ot(2, arguments);
  var n = Ht(e);
  return on(t, -n);
}
function fr(t) {
  return Fe(t, "MMM do, yyyy");
}
function hr(t) {
  return Fe(t, "hh:mm a");
}
const lm = { class: "chart-cursor__label" }, fm = { class: "chart-cursor__date" }, hm = { class: "chart-cursor__time" }, kg = /* @__PURE__ */ Mt({
  __name: "ChartCursor",
  props: {
    startDate: {},
    endDate: {},
    cursor: {}
  },
  emits: ["update:cursor"],
  setup(t, { emit: e }) {
    const n = t, r = G(), { width: i } = Pt(r), a = G(), { width: o } = Pt(a), s = G(null), c = G(!1), { down: u } = Ui("Shift"), l = C({
      get() {
        return n.cursor ?? s.value;
      },
      set(f) {
        s.value = f, e("update:cursor", f);
      }
    }), d = C(() => {
      if (l.value === null)
        return !1;
      const f = g.value(l.value), _ = h.value(l.value);
      return f === _;
    }), h = C(() => {
      const f = wt();
      return f.domain([n.startDate, n.endDate]), f.range([0, i.value]), f;
    }), g = C(() => h.value.copy().clamp(!0)), S = C(() => {
      if (!l.value || !u.value)
        return {
          display: "none"
        };
      const f = h.value(l.value);
      return {
        left: xt(f)
      };
    }), k = C(() => {
      if (!l.value || !u.value)
        return {
          display: "none"
        };
      const f = h.value(l.value), _ = o.value / 2;
      let m = f - _;
      return m < 0 && (m = 0), m + o.value > i.value && (m = i.value - o.value), {
        left: xt(m)
      };
    });
    function $(f) {
      c.value = !0, y(f);
    }
    function b(f) {
      y(f);
    }
    function F() {
      l.value = null, c.value = !1;
    }
    function y(f) {
      const [_] = vt(f, r.value);
      l.value = g.value.invert(_);
    }
    return (f, _) => (q(), B("div", mr({
      ref_key: "chart",
      ref: r,
      class: "chart-cursor"
    }, { onPointerenter: $, onPointermove: b, onPointerleave: F }), [
      rt(f.$slots, "default"),
      d.value ? (q(), B("div", {
        key: 0,
        class: "chart-cursor__cursor",
        style: dt(S.value)
      }, null, 4)) : pt("", !0),
      l.value && c.value ? (q(), B("div", {
        key: 1,
        ref_key: "label",
        ref: a,
        class: "chart-cursor__label-wrapper",
        style: dt(k.value)
      }, [
        rt(f.$slots, "label", { value: l.value }, () => [
          I("div", lm, [
            I("span", fm, gt(nt(fr)(l.value)), 1),
            I("span", hm, gt(nt(hr)(l.value)), 1)
          ])
        ])
      ], 4)) : pt("", !0)
    ], 16));
  }
}), Dg = /* @__PURE__ */ Mt({
  __name: "ChartZoom",
  props: {
    startDate: {},
    endDate: {},
    options: {}
  },
  emits: ["update:startDate", "update:endDate", "updated"],
  setup(t, { emit: e }) {
    const n = t, { startDate: r, endDate: i } = La(n), a = G(), { width: o } = Pt(a), { down: s } = Ui("Shift"), c = Rf().on("start", k).on("zoom", $).on("end", b).filter((f) => !f.shiftKey), u = C(() => {
      const f = wt();
      return f.domain([r.value, i.value]), f.range([0, o.value]), f;
    }), l = G(!1), d = C(() => ({
      "chart-zoom--enabled": !s.value,
      "chart-zoom--dragging": l.value
    }));
    let h = !1, g = !1;
    jt(u, () => {
      a.value && h && (F(), h = !1);
    }), qt(() => {
      S();
    });
    function S() {
      a.value && at(a.value).call(c);
    }
    function k({ sourceEvent: f }) {
      f.type === "mousedown" && (l.value = !0);
    }
    function $(f) {
      if (g) {
        g = !1;
        return;
      }
      const _ = f.transform.rescaleX(u.value), [m, p] = _.domain(), w = y({ startDate: m, endDate: p });
      if (w === null) {
        F();
        return;
      }
      e("update:startDate", w.startDate), e("update:endDate", w.endDate), h = !0;
    }
    function b() {
      l.value = !1, e("updated", {
        startDate: n.startDate,
        endDate: n.endDate
      });
    }
    function F() {
      a.value && (at(a.value).call(c.transform, Ar), g = !0);
    }
    function y({ startDate: f, endDate: _ }) {
      var L, z, H, T;
      const {
        minRangeInSeconds: m = -1 / 0,
        maxRangeInSeconds: p = 1 / 0
      } = n.options ?? {};
      let w = f.getTime(), N = _.getTime();
      const Y = N - w, E = n.endDate.getTime() - n.startDate.getTime(), Q = ((z = (L = n.options) == null ? void 0 : L.minDate) == null ? void 0 : z.getTime()) ?? -1 / 0, J = ((T = (H = n.options) == null ? void 0 : H.maxDate) == null ? void 0 : T.getTime()) ?? 1 / 0, v = m * 1e3, O = p * 1e3, x = Y < E && E <= v, U = Y > E && E >= O;
      if (x || U)
        return null;
      if (Y > O) {
        const R = (Y - O) / 2;
        w = w + R, N = N - R;
      }
      if (Y < v) {
        const R = (v - Y) / 2;
        w = w - R, N = N + R;
      }
      if (w < Q) {
        const A = Q - w;
        w = w + A, N = N + A;
      }
      if (N > J) {
        const A = N - J;
        w = w - A, N = N - A;
      }
      return {
        startDate: new Date(w),
        endDate: new Date(N)
      };
    }
    return (f, _) => (q(), B("div", {
      ref_key: "chart",
      ref: a,
      class: Et(["chart-zoom", d.value])
    }, [
      rt(f.$slots, "default", gr(Ha({ startDate: nt(r), endDate: nt(i) })))
    ], 2));
  }
}), dm = { class: "chart-labels__chart" }, mm = {
  key: 0,
  class: "chart-labels__y"
}, gm = { class: "chart-labels__label chart-labels__label-y chart-labels__label-y--min" }, vm = { class: "chart-labels__value-label" }, pm = { class: "chart-labels__label chart-labels__label-y chart-labels__label-y--max" }, _m = { class: "chart-labels__value-label" }, ym = {
  key: 1,
  class: "chart-labels__x"
}, wm = { class: "chart-labels__label chart-labels__label-x chart-labels__label-x--start" }, xm = { class: "chart-labels__date-label" }, bm = { class: "chart-labels__time-label" }, Mm = { class: "chart-labels__label chart-labels__label-x chart-labels__label-x--end" }, Tm = { class: "chart-labels__date-label" }, Sm = { class: "chart-labels__time-label" }, Cg = /* @__PURE__ */ Mt({
  __name: "ChartLabels",
  props: {
    xAxis: {},
    yAxis: {}
  },
  setup(t) {
    const e = t, n = C(() => ({
      root: {
        "chart-labels--x": e.xAxis,
        "chart-labels--y": e.yAxis
      }
    })), r = C(() => {
      var s;
      return (s = e.xAxis) == null ? void 0 : s.at(0);
    }), i = C(() => {
      var s;
      return (s = e.xAxis) == null ? void 0 : s.at(-1);
    }), a = C(() => {
      var s;
      return (s = e.yAxis) == null ? void 0 : s.at(0);
    }), o = C(() => {
      var s;
      return (s = e.yAxis) == null ? void 0 : s.at(-1);
    });
    return (s, c) => (q(), B("div", {
      class: Et(["chart-labels", n.value.root])
    }, [
      I("div", dm, [
        rt(s.$slots, "default")
      ]),
      s.yAxis ? (q(), B("div", mm, [
        I("div", gm, [
          rt(s.$slots, "label-y", { value: o.value }, () => [
            I("span", vm, gt(o.value), 1)
          ])
        ]),
        I("div", pm, [
          rt(s.$slots, "label-y", { value: a.value }, () => [
            I("span", _m, gt(a.value), 1)
          ])
        ])
      ])) : pt("", !0),
      s.xAxis ? (q(), B("div", ym, [
        I("div", wm, [
          r.value ? rt(s.$slots, "label-x", {
            key: 0,
            value: r.value
          }, () => [
            I("span", xm, gt(nt(fr)(r.value)), 1),
            I("span", bm, gt(nt(hr)(r.value)), 1)
          ]) : pt("", !0)
        ]),
        I("div", Mm, [
          i.value ? rt(s.$slots, "label-x", {
            key: 0,
            value: i.value
          }, () => [
            I("span", Tm, gt(nt(fr)(i.value)), 1),
            I("span", Sm, gt(nt(hr)(i.value)), 1)
          ]) : pt("", !0)
        ])
      ])) : pt("", !0)
    ], 2));
  }
}), $g = /* @__PURE__ */ Mt({
  __name: "ChartPlayHead",
  props: {
    startDate: {},
    endDate: {}
  },
  setup(t) {
    const e = t, n = G(), { width: r } = Pt(n), i = G(), { width: a } = Pt(i), { now: o } = qa(), s = C(() => {
      const u = wt();
      return u.domain([e.startDate, e.endDate]), u.range([0, r.value]), u;
    }), c = C(() => {
      const u = s.value(o.value) - a.value / 2;
      return {
        left: xt(u)
      };
    });
    return (u, l) => (q(), B("div", {
      ref_key: "chart",
      ref: n,
      class: "chart-play-head"
    }, [
      rt(u.$slots, "default"),
      I("div", {
        ref_key: "line",
        ref: i,
        class: "chart-play-head__now",
        style: dt(c.value)
      }, null, 4)
    ], 512));
  }
});
function qn(t) {
  return t.slice().sort((e, n) => e.getTime() - n.getTime());
}
function Na(t, e) {
  return t.slice().sort((n, r) => {
    const i = n[e], a = r[e];
    return i.getTime() - a.getTime();
  });
}
const Eg = /* @__PURE__ */ Mt({
  __name: "ChartSelection",
  props: {
    startDate: {},
    endDate: {},
    selectionStart: {},
    selectionEnd: {}
  },
  emits: ["selection", "update:selectionStart", "update:selectionEnd"],
  setup(t, { emit: e }) {
    const n = t;
    qt(() => {
      $(), document.addEventListener("pointermove", F);
    }), Ai(() => {
      document.removeEventListener("pointermove", F);
    });
    const r = C(() => {
      const m = wt();
      return m.domain([n.startDate, n.endDate]), m.range([0, a.value]), m;
    }), i = G(), { width: a } = Pt(i), o = G(), { width: s } = Pt(o), c = C(() => n.selectionStart ?? null), u = C(() => n.selectionEnd ?? null), l = G(!1), d = G(null), h = G(null), g = C(() => !c.value || !u.value ? null : qn([c.value, u.value])), S = C(() => {
      if (!c.value || !u.value)
        return {
          display: "none"
        };
      const [m, p] = qn([c.value, u.value]), w = r.value(m), N = a.value - r.value(p);
      return {
        left: xt(w),
        right: xt(N)
      };
    }), k = C(() => {
      if (!c.value || !u.value)
        return {
          display: "none"
        };
      const m = r.value(c.value), p = r.value(u.value), w = (m + p) / 2, N = s.value / 2;
      let Y = w - N;
      return Y < 0 && (Y = 0), Y + s.value > a.value && (Y = a.value - s.value), {
        left: xt(Y)
      };
    });
    function $() {
      if (!i.value)
        return;
      const m = tn().on("start", b).on("end", y).filter((p) => p.shiftKey);
      at(i.value).call(m);
    }
    function b(m) {
      l.value = !0, d.value = null, h.value = null;
      const [p] = vt(m, i.value);
      d.value = r.value.clamp(!0).invert(p), f();
    }
    function F(m) {
      if (!l.value)
        return;
      const [p] = vt(m, i.value), w = r.value.clamp(!0).invert(p);
      h.value = w, f();
    }
    function y() {
      l.value = !1, e("selection", g.value);
    }
    function f() {
      if (!d.value || !h.value) {
        e("update:selectionStart", null), e("update:selectionEnd", null);
        return;
      }
      const [m, p] = qn([d.value, h.value]);
      e("update:selectionStart", m), e("update:selectionEnd", p);
    }
    function _(m) {
      return Fe(m, "MMM do, hh:mm a");
    }
    return (m, p) => (q(), B("div", {
      ref_key: "chart",
      ref: i,
      class: "chart-selection",
      onPointermove: F
    }, [
      rt(m.$slots, "default"),
      I("div", {
        class: "chart-selection__selection",
        style: dt(S.value)
      }, null, 4),
      I("div", {
        ref_key: "label",
        ref: o,
        class: "chart-selection__label",
        style: dt(k.value)
      }, [
        c.value && u.value ? rt(m.$slots, "label", {
          key: 0,
          start: c.value,
          end: u.value
        }, () => [
          Xa(gt(_(c.value)) + " - " + gt(_(u.value)), 1)
        ]) : pt("", !0)
      ], 4)
    ], 544));
  }
});
function Pa(t, e) {
  const n = km(t), r = Math.ceil(t / n) * n;
  return r === t ? r + n : r;
}
const Ei = {
  25: 5,
  100: 10,
  150: 25,
  500: 50,
  1e3: 100,
  1e4: 1e3,
  1e5: 1e5,
  Infinity: 1e6
};
function km(t) {
  const e = Object.keys(Ei).map(Number).find((n) => t < n);
  return Ei[e];
}
const Dm = { class: "histogram-chart__chart" }, Cm = ["width", "height", "viewbox"], $m = ["id", "y1"], Em = /* @__PURE__ */ I("stop", {
  offset: "0%",
  class: "histogram-chart__path--0"
}, null, -1), Am = /* @__PURE__ */ I("stop", {
  offset: "85%",
  class: "histogram-chart__path--85"
}, null, -1), Nm = /* @__PURE__ */ I("stop", {
  offset: "100%",
  class: "histogram-chart__path--100"
}, null, -1), Pm = [
  Em,
  Am,
  Nm
], Um = /* @__PURE__ */ I("linearGradient", {
  id: "histogram-fill-gradient",
  x1: "50%",
  y1: "100%",
  x2: "50%",
  y2: "0%"
}, [
  /* @__PURE__ */ I("stop", {
    offset: "0%",
    class: "histogram-chart__gradient-start"
  }),
  /* @__PURE__ */ I("stop", {
    offset: "100%",
    class: "histogram-chart__gradient-stop"
  })
], -1), Om = ["d"], Fm = ["d"], Ym = {
  key: 0,
  class: "histogram-chart__axis-y"
}, Im = { class: "histogram-chart__label histogram-chart__label-y histogram-chart__label-y--min" }, Wm = { class: "histogram-chart__value-label" }, Rm = { class: "histogram-chart__label histogram-chart__label-y histogram-chart__label-y--max" }, zm = /* @__PURE__ */ I("span", { class: "histogram-chart__value-label" }, /* @__PURE__ */ gt(0), -1), Lm = {
  key: 1,
  class: "histogram-chart__axis-x"
}, Hm = { class: "histogram-chart__label histogram-chart__label-x histogram-chart__label-x--start" }, Xm = { class: "histogram-chart__date-label" }, Vm = { class: "histogram-chart__time-label" }, qm = { class: "histogram-chart__label histogram-chart__label-x histogram-chart__label-x--end" }, Bm = { class: "histogram-chart__date-label" }, Gm = { class: "histogram-chart__time-label" }, Ag = /* @__PURE__ */ Mt({
  __name: "HistogramChart",
  props: {
    data: {},
    smooth: { type: Boolean },
    options: {},
    startDate: {},
    endDate: {},
    selectionStart: {},
    selectionEnd: {}
  },
  emits: ["update:selectionStart", "update:selectionEnd", "selection"],
  setup(t, { emit: e }) {
    const n = t;
    Pi((M) => ({
      fb75021e: a.value,
      "0c2f9d70": h.value
    }));
    const r = C(() => ({
      ...Qm,
      ...n.options
    })), i = C(() => Na(n.data, "intervalStart")), a = C(() => `${r.value.transitionDuration}ms`), o = C(() => !n.smooth), s = C(() => n.smooth), c = C(() => n.selectionEnd && n.selectionStart), u = G(!1), l = G(!0), d = C(() => `histogram-path-gradient-${wn()}`), h = C(() => `url(#${d.value})`), g = jt(c, (M) => {
      M && (D(), g());
    });
    qt(() => {
      c.value && (g(), D()), mt();
    });
    const S = G(), { width: k, height: $, x: b } = Pt(S), F = G(), y = G(), f = G();
    dr(() => document.body.classList.toggle("histogram-chart--dragging", u.value));
    const _ = C(() => i.value.at(0).intervalStart), m = C(() => n.startDate ? n.startDate : _.value), p = C(() => i.value.at(-1).intervalEnd), w = C(() => n.endDate ? n.endDate : p.value), N = C(() => {
      const M = i.value.map((W) => W.value), V = Math.max(...M, 0);
      return Pa(V);
    }), Y = C(() => {
      const M = wt();
      return M.domain([m.value, w.value]), M.range([0, k.value]), M;
    }), E = C(() => {
      const M = Lt();
      return M.domain([0, N.value]), M.range([0, $.value]), M;
    }), Q = C(() => i.value.map((M) => L(M))), J = C(() => {
      const M = i.value.at(0), V = i.value.at(-1), W = i.value.map((Nn) => z(Nn)), [, j = 0] = W.shift() ?? [], [, st = j] = W.pop() ?? [], Ft = Y.value(M.intervalStart), Ct = Y.value(V.intervalEnd), ye = [Ft, j], An = [Ct, st];
      return [
        ye,
        ...W,
        An
      ];
    }), v = C(() => {
      const M = Ma();
      return M.curve(r.value.curve), M(J.value) ?? "";
    }), O = C(() => {
      const M = v.value, V = `L ${Y.value(p.value)},${$.value}`, W = `L ${Y.value(_.value)},${$.value}`;
      return `${M}${V}${W}Z`;
    }), x = C(() => {
      const { selectionStart: M, selectionEnd: V } = n;
      if (!M || !V)
        return;
      const W = Y.value(M), j = k.value - Y.value(V);
      return {
        left: `${W}px`,
        right: `${j}px`
      };
    }), U = C(() => ({
      root: {
        "histogram-chart--loading": l.value,
        "histogram-chart--x-axis": r.value.showXAxis,
        "histogram-chart--y-axis": r.value.showYAxis
      },
      selection: {
        "histogram-chart__selection--moving": u.value
      },
      bar: {
        "histogram-chart__bar--transitioned": r.value.transition,
        "histogram-chart__bar--visible": o.value
      },
      path: {
        "histogram-chart__path--transitioned": r.value.transition,
        "histogram-chart__path--visible": s.value
      }
    }));
    function L(M) {
      const V = E.value(M.value), W = Y.value(M.intervalStart), st = Y.value(M.intervalEnd) - W, Ft = V, Ct = {
        left: xt(W),
        width: xt(st),
        height: xt(Ft),
        bottom: xt(0)
      };
      return (l.value || !o.value) && (Ct.height = xt(0)), { ...M, styles: Ct };
    }
    function z(M) {
      const V = new Date((M.intervalStart.getTime() + M.intervalEnd.getTime()) / 2), W = Y.value(V), j = $.value - E.value(M.value);
      return l.value || !s.value ? [W, $.value] : [W, j];
    }
    function H(M) {
      return Fe(M, "MMM do, yyyy");
    }
    function T(M) {
      return Fe(M, "hh:mm a");
    }
    function A({ selectionStart: M, selectionEnd: V }) {
      const W = m.value, j = w.value, st = od(V, M);
      return Ze(M, W) ? {
        selectionStart: W,
        selectionEnd: on(W, st)
      } : Qe(V, j) ? {
        selectionStart: Vn(j, st),
        selectionEnd: j
      } : { selectionStart: M, selectionEnd: V };
    }
    function R() {
      u.value = !0;
    }
    function X(M) {
      if (!n.selectionStart || !n.selectionEnd)
        return;
      R();
      const [V] = vt(M, S.value), W = Y.value(n.selectionStart), j = Y.value(n.selectionEnd);
      if (V >= W && V <= j)
        return;
      const st = j - W, Ft = Math.floor(st / 2), Ct = V - Ft, ye = Ct + st, An = Y.value.invert(Ct), Ur = Y.value.invert(ye), Nn = A({ selectionStart: An, selectionEnd: Ur });
      K(Nn);
    }
    function it() {
      u.value = !1, e("selection", {
        selectionStart: n.selectionStart,
        selectionEnd: n.selectionEnd
      });
    }
    function ut({ dx: M }) {
      const V = Y.value(n.selectionStart), W = Y.value(n.selectionEnd), j = Y.value.invert(V + M), st = Y.value.invert(W + M);
      return { selectionStart: j, selectionEnd: st };
    }
    function ct(M) {
      if (Z(M))
        return;
      const V = ut(M), W = A(V);
      K(W);
    }
    function lt(M) {
      const [V] = vt(M, S.value);
      let W = Y.value.invert(V);
      Ze(W, m.value) && (W = m.value);
      const j = Vn(n.selectionEnd, r.value.selectionMaximumSeconds);
      Ze(W, j) && (W = j);
      const st = Vn(n.selectionEnd, r.value.selectionMinimumSeconds);
      Qe(W, st) && (W = st), K({
        selectionStart: W
      });
    }
    function P(M) {
      const [V] = vt(M, S.value);
      let W = Y.value.invert(V);
      Qe(W, w.value) && (W = w.value);
      const j = on(n.selectionStart, r.value.selectionMaximumSeconds);
      Qe(W, j) && (W = j);
      const st = on(n.selectionStart, r.value.selectionMinimumSeconds);
      Ze(W, st) && (W = st), K({
        selectionEnd: W
      });
    }
    function Z(M) {
      const V = M.dx, W = b.value, j = b.value + k.value, Ft = M.sourceEvent.clientX - V, Ct = W >= Ft, ye = j <= Ft;
      return !!(Ct || ye);
    }
    function K({ selectionStart: M, selectionEnd: V }) {
      M && e("update:selectionStart", M), V && e("update:selectionEnd", V);
    }
    function D() {
      if (!S.value || !F.value || !y.value || !f.value)
        return;
      const M = at(S.value), V = tn().on("start", X).on("drag", ct).on("end", it), W = tn().container(M).on("start", R).on("drag", lt).on("end", it), j = tn().container(M).on("start", R).on("drag", P).on("end", it);
      at(S.value).call(V), at(y.value).call(W), at(f.value).call(j);
    }
    function mt() {
      setTimeout(() => {
        l.value = !1;
      }, 1);
    }
    return (M, V) => i.value.length ? (q(), B("div", {
      key: 0,
      class: Et(["histogram-chart", U.value.root])
    }, [
      I("div", {
        ref_key: "chart",
        ref: S,
        class: "histogram-chart__viewport"
      }, [
        c.value ? (q(), B("div", {
          key: 0,
          ref_key: "selection",
          ref: F,
          class: Et(["histogram-chart__selection", U.value.selection]),
          style: dt(x.value)
        }, [
          I("div", {
            ref_key: "selectionLeft",
            ref: y,
            class: "histogram-chart__selection-resize histogram-chart__selection-resize--left"
          }, null, 512),
          I("div", {
            ref_key: "selectionRight",
            ref: f,
            class: "histogram-chart__selection-resize histogram-chart__selection-resize--right"
          }, null, 512)
        ], 6)) : pt("", !0),
        I("div", Dm, [
          (q(), B("svg", {
            class: "histogram-chart__svg",
            width: nt(k),
            height: nt($),
            viewbox: `0 0 ${nt(k)} ${nt($)}`
          }, [
            I("defs", null, [
              rt(M.$slots, "defs", {}, () => [
                I("linearGradient", {
                  id: d.value,
                  x1: "0",
                  y1: nt($),
                  x2: "0",
                  y2: "0",
                  gradientUnits: "userSpaceOnUse"
                }, Pm, 8, $m),
                Um
              ])
            ]),
            I("path", {
              class: Et(["histogram-chart__path", U.value.path]),
              d: v.value
            }, null, 10, Om),
            I("path", {
              class: Et(["histogram-chart__fill", U.value.path]),
              d: O.value
            }, null, 10, Fm)
          ], 8, Cm)),
          (q(!0), B(Rt, null, te(Q.value, (W) => rt(M.$slots, "bar", gr(mr({
            key: W.intervalStart.getTime()
          }, W)), () => [
            I("div", {
              class: Et(["histogram-chart__bar", U.value.bar]),
              style: dt(W.styles)
            }, null, 6)
          ])), 128))
        ])
      ], 512),
      r.value.showYAxis ? (q(), B("div", Ym, [
        I("div", Im, [
          rt(M.$slots, "label-y", { value: N.value }, () => [
            I("span", Wm, gt(N.value), 1)
          ])
        ]),
        I("div", Rm, [
          rt(M.$slots, "label-y", { value: 0 }, () => [
            zm
          ])
        ])
      ])) : pt("", !0),
      r.value.showXAxis ? (q(), B("div", Lm, [
        I("div", Hm, [
          rt(M.$slots, "label-x", { value: m.value }, () => [
            I("span", Xm, gt(H(m.value)), 1),
            I("span", Vm, gt(T(m.value)), 1)
          ])
        ]),
        I("div", qm, [
          rt(M.$slots, "label-x", { value: w.value }, () => [
            I("span", Bm, gt(H(w.value)), 1),
            I("span", Gm, gt(T(w.value)), 1)
          ])
        ])
      ])) : pt("", !0)
    ], 2)) : pt("", !0);
  }
}), Qm = {
  showXAxis: !0,
  showYAxis: !0,
  curve: Sa,
  transition: !0,
  transitionDuration: 250,
  selectionMaximumSeconds: 1 / 0,
  selectionMinimumSeconds: 0
};
function Zm(t) {
  if (typeof t == "function")
    return t;
  switch (t) {
    case "bumpX":
      return Sa;
    case "bumpY":
      return kf;
    case "cardinal":
      return Df;
    case "catmullRom":
      return $f;
  }
}
const Km = ["width", "height", "viewbox"], Jm = ["id", "y1"], jm = /* @__PURE__ */ I("stop", {
  offset: "0%",
  class: "line-chart__path--0"
}, null, -1), tg = /* @__PURE__ */ I("stop", {
  offset: "85%",
  class: "line-chart__path--85"
}, null, -1), eg = /* @__PURE__ */ I("stop", {
  offset: "100%",
  class: "line-chart__path--100"
}, null, -1), ng = [
  jm,
  tg,
  eg
], rg = ["id"], ig = /* @__PURE__ */ I("stop", {
  offset: "0%",
  class: "line-chart__gradient-start"
}, null, -1), ag = /* @__PURE__ */ I("stop", {
  offset: "100%",
  class: "line-chart__gradient-stop"
}, null, -1), og = [
  ig,
  ag
], sg = ["d"], ug = ["d"], Ng = /* @__PURE__ */ Mt({
  __name: "LineChart",
  props: {
    data: {},
    options: {}
  },
  setup(t) {
    const e = t;
    Pi((f) => ({
      "3658dfef": c.value,
      "563e115e": u.value
    }));
    const n = G(), { width: r, height: i } = Pt(n), a = C(() => e.data.slice().sort(([f], [_]) => f.getTime() - _.getTime())), o = C(() => `histogram-path-gradient-${wn()}`), s = C(() => `line-chart-fill-gradient-${wn()}`), c = C(() => `url(#${o.value})`), u = C(() => `url(#${s.value})`), l = C(() => {
      var _;
      if ((_ = e.options) != null && _.startDate)
        return e.options.startDate;
      const [f] = a.value.at(0) ?? [];
      return f ?? cm();
    }), d = C(() => {
      var _;
      if ((_ = e.options) != null && _.endDate)
        return e.options.endDate;
      const [f] = a.value.at(-1) ?? [];
      return f ?? sd();
    }), h = C(() => {
      const f = wt();
      return f.domain([l.value, d.value]), f.range([0, r.value]), f;
    }), g = C(() => a.value.map(([, f]) => f)), S = C(() => {
      var f;
      return ((f = e.options) == null ? void 0 : f.minValue) !== void 0 ? e.options.minValue : Math.min(...g.value, 0);
    }), k = C(() => {
      var _, m;
      if (((_ = e.options) == null ? void 0 : _.maxValue) !== void 0)
        return e.options.maxValue;
      const f = Math.max(...g.value, 0);
      return (m = e.options) != null && m.roundUpMaxValue ? Pa(f) : f;
    }), $ = C(() => {
      const f = Lt();
      return f.domain([S.value, k.value]), f.range([i.value, 0]), f;
    }), b = C(() => a.value.map(([f, _]) => [h.value(f), $.value(_)])), F = C(() => {
      var _;
      const f = Ma();
      if ((_ = e.options) != null && _.curve) {
        const m = Zm(e.options.curve);
        f.curve(m);
      }
      return f(b.value);
    }), y = C(() => {
      if (!F.value)
        return null;
      const [f, _] = h.value.range(), [m] = b.value.at(0) ?? [f], [p] = b.value.at(-1) ?? [_], w = `L ${p},${i.value}`, N = `L ${m},${i.value}`;
      return `${F.value}${w}${N}Z`;
    });
    return (f, _) => (q(), B("div", {
      ref_key: "chart",
      ref: n,
      class: "line-chart"
    }, [
      (q(), B("svg", {
        class: "line-chart__svg",
        width: nt(r),
        height: nt(i),
        viewbox: `0 0 ${nt(r)} ${nt(i)}`
      }, [
        I("defs", null, [
          I("linearGradient", {
            id: o.value,
            x1: "0",
            y1: nt(i),
            x2: "0",
            y2: "0",
            gradientUnits: "userSpaceOnUse"
          }, ng, 8, Jm),
          I("linearGradient", {
            id: s.value,
            x1: "50%",
            y1: "100%",
            x2: "50%",
            y2: "0%"
          }, og, 8, rg)
        ]),
        F.value ? (q(), B("path", {
          key: 0,
          class: "line-chart__path",
          d: F.value
        }, null, 8, sg)) : pt("", !0),
        y.value ? (q(), B("path", {
          key: 1,
          class: "line-chart__fill",
          d: y.value
        }, null, 8, ug)) : pt("", !0)
      ], 8, Km))
    ], 512));
  }
}), cg = ["onClick"], Pg = /* @__PURE__ */ Mt({
  __name: "MiniHistogram",
  props: {
    data: {},
    options: {}
  },
  emits: ["barClick"],
  setup(t, { emit: e }) {
    const n = t, { value: r } = Va(), i = G(), { width: a } = Pt(i), o = C(() => Na(n.data, "intervalStart")), s = C(() => o.value.map((y) => b(y))), c = C(() => ({
      colorStart: "#7210EF",
      colorEnd: "#A564F9",
      ...n.options
    })), u = C(() => {
      var y, f;
      return {
        root: {
          "mini-histogram--clickable-bars": (y = n.options) == null ? void 0 : y.clickable
        },
        bar: {
          "mini-histogram__bar--clickable": (f = n.options) == null ? void 0 : f.clickable
        }
      };
    }), l = C(() => {
      var f;
      if ((f = n.options) != null && f.startDate)
        return n.options.startDate;
      const y = o.value.at(0);
      return (y == null ? void 0 : y.intervalStart) ?? /* @__PURE__ */ new Date();
    }), d = C(() => {
      var f;
      if ((f = n.options) != null && f.endDate)
        return n.options.endDate;
      const y = o.value.at(-1);
      return (y == null ? void 0 : y.intervalEnd) ?? /* @__PURE__ */ new Date();
    }), h = C(() => {
      const y = wt();
      return y.domain([l.value, d.value]), y.range([0, a.value]), y;
    }), g = C(() => o.value.map((y) => y.value)), S = C(() => {
      var y;
      return ((y = n.options) == null ? void 0 : y.minValue) !== void 0 ? n.options.minValue : Math.min(...g.value, 0);
    }), k = C(() => {
      var y;
      return ((y = n.options) == null ? void 0 : y.maxValue) !== void 0 ? n.options.maxValue : Math.max(...g.value, 0);
    }), $ = C(() => {
      const y = Lt(), f = [c.value.colorStart, c.value.colorEnd];
      return r.value === "dark" && f.reverse(), y.domain([S.value, k.value]), y.range(f), y;
    });
    function b(y) {
      const f = h.value(y.intervalStart), m = h.value(y.intervalEnd) - f, p = {
        left: xt(f),
        width: xt(m),
        backgroundColor: $.value(y.value)
      };
      return { ...y, styles: p };
    }
    function F(y) {
      var f;
      (f = n.options) != null && f.clickable && e("barClick", y);
    }
    return (y, f) => (q(), B("div", {
      ref_key: "chart",
      ref: i,
      class: Et(["mini-histogram", u.value.root])
    }, [
      (q(!0), B(Rt, null, te(s.value, (_) => rt(y.$slots, "bar", gr(mr({
        key: _.intervalStart.getTime()
      }, _)), () => [
        I("div", {
          class: Et(["mini-histogram__bar", u.value.bar]),
          style: dt(_.styles),
          onClick: () => F(_)
        }, null, 14, cg)
      ])), 128))
    ], 2));
  }
});
function lg() {
  return {
    cursor: G(null)
  };
}
function fg() {
  const t = /* @__PURE__ */ new Map();
  function e(n) {
    if (t.has(n))
      return t.get(n);
    const r = lg();
    return t.set(n, r), r;
  }
  return (n = "default") => e(n);
}
const Ug = fg();
function hg() {
  const t = G(null), e = G(null);
  return {
    startDate: t,
    endDate: e
  };
}
function dg() {
  const t = /* @__PURE__ */ new Map();
  function e(n) {
    if (t.has(n))
      return t.get(n);
    const r = hg();
    return t.set(n, r), r;
  }
  return (n = "default") => e(n);
}
const Og = dg();
function mg() {
  const t = G(null), e = G(null);
  return {
    selectionStart: t,
    selectionEnd: e
  };
}
function gg() {
  const t = /* @__PURE__ */ new Map();
  function e(n) {
    if (t.has(n))
      return t.get(n);
    const r = mg();
    return t.set(n, r), r;
  }
  return (n = "default") => e(n);
}
const Fg = gg(), Yg = (t = {
  capTop: !0,
  capBottom: !0,
  x: 0,
  y: 0,
  height: 0,
  width: 0,
  radius: 1
}) => {
  const { capTop: e, capBottom: n, height: r, width: i, x: a, y: o, radius: s } = t, c = e ? `a ${s} ${s} 0 1 0 -${i} 0` : `a 0 0 0 1 0 -${i} 0`, u = n ? `a ${s} ${s} 0 1 0 ${i} 0` : `a 0 0 0 1 0 ${i} 0`;
  return `M${a},${o} v${r} ${u} ${n ? "" : `h${i}`} v-${r} ${c}`;
}, Ig = (t, e) => {
  if (typeof t != "object")
    throw new Error('stringAccessor: passed object is not of type "object"');
  if (typeof e != "string")
    throw new Error('stringAccessor: passed string is not of type "string"');
  return e = e.replace(/\[["'`](.*)["'`]\]/g, ".$1"), e.split(".").reduce((n, r) => n ? n[r] : void 0, t || self);
};
export {
  wg as BarChart,
  kg as ChartCursor,
  Cg as ChartLabels,
  $g as ChartPlayHead,
  Eg as ChartSelection,
  Dg as ChartZoom,
  Mg as DivergingBarChart,
  Ag as HistogramChart,
  Ng as LineChart,
  Pg as MiniHistogram,
  Sg as ScatterPlot,
  xi as TimeIntervalRanking,
  Zf as TimeIntervalReverseRanking,
  Tg as Timeline,
  Nr as aggregateSeconds,
  Yg as createCappedBar,
  Qm as defaultHistogramChartOptions,
  qh as extentUndefined,
  oh as formatDay,
  ah as formatHour,
  Pr as formatLabel,
  nh as formatMillisecond,
  ih as formatMinute,
  uh as formatMonth,
  rh as formatSecond,
  lh as formatTime,
  sh as formatWeek,
  ch as formatYear,
  Jf as getD3IntervalMethod,
  Kf as getLargestInterval,
  bg as getMinInterval,
  xg as getNextHighestInterval,
  jf as getNextLowestInterval,
  bi as getSmallestInterval,
  Da as intervalSeconds,
  eh as secondsToApproximateString,
  Ig as stringAccessor,
  Ug as useChartCursor,
  Fg as useChartSelection,
  Og as useChartZoom
};
//# sourceMappingURL=vue-charts.mjs.map
